import React, {
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  createRef,
  useImperativeHandle,
} from "react";
import {
  Box,
  Badge,
  Flex,
  Divider,
  Text,
  Image,
  Button,
  SimpleGrid,
  Spacer,
  Tr,
  Td,
  Input,
  HStack,
  VStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Stack,
  FormControl,
  Select,
  FormErrorMessage,
  FormLabel,
  InputGroup,
  InputLeftElement,
  Grid,
  GridItem,
  Heading,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Textarea,
  MenuItem,
  MenuButton,
  MenuList,
  Menu,
  Tag,
  TagLabel,
  TagCloseButton,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import MiniSideBar from "../../components/mini-sidebar";
import PatientVisitNav from "../../components/patient-visit-navbar";
import styles from "./styles/startvisit.module.css";
import VitalDisplayCard from "../../components/patient-health/vital-display-card";
import PastVitalDisplayCard from "../../components/patient-health/past-visits/past-vitals";
import PastMedicalHistory from "../../components/patient-health/past-visits/past-medical-history";
import PastMedications from "../../components/patient-health/past-visits/past-medications";
import PastPhysicalExam from "../../components/patient-health/past-visits/past-physical-exam";
import PastTreatmentPlan from "../../components/patient-health/past-visits/past-treatment-plan";
import PastSurgicalHistory from "../../components/patient-health/past-visits/past-surgical-history";
import PastFamilyTreeTable from "../../components/patient-health/past-visits/past-family-tree";
import PastVaccination from "../../components/patient-health/past-visits/past-vaccinations";
import PastSocialHistory from "../../components/patient-health/past-visits/past-social-history";
import PastAllergies from "../../components/patient-health/past-visits/past-allergy";
import PastLabTests from "../../components/patient-health/past-visits/past-lab-test";
import PastVisitOverview from "../../components/patient-health/past-visits/past-overview";
import PhysicalExamCard from "../../components/patient-health/physical-exam-card";
import HpiCard from "../../components/patient-health/hpi-card";
import DemographicsCard from "../../components/patient-health/demographics-card";
import ChiefComplaintCard from "../../components/patient-health/chief-complaint-card";
import DoctorAssessmentCard from "../../components/patient-health/doctor-assessment-card";
import TreatmentPlanCard from "../../components/patient-health/treatment-plan-card";
import CurrentVisitOverview from "../../components/patient-health/overview";
import MedicalHistory from "../../components/patient-health/medical-history";
import SurgicalHistory from "../../components/patient-health/surgical-history";
import FamilyHistory from "../../components/patient-health/family-history";
import Medications from "../../components/patient-health/medications";
import Vaccination from "../../components/patient-health/vaccinations";
import TreatmentPlan from "../../components/patient-health/treatment-plan";
import PatientVisit from "../../components/patient-health/past-visits";
import SocialHistory from "../../components/patient-health/social-history";
import PhysicalExam from "../../components/patient-health/physical-exam";
import Allergies from "../../components/patient-health/allergies";
import LabTests from "../../components/patient-health/lab-test";
import {
  GetPatientHealthData,
  GetPatientSelectedVisitData,
} from "../../middleware/services/visits/patient-overview";
import { PrimaryButton, PrimaryInput, DropdownInput } from "../../components";

import DynamicModal from "../../components/dynamic-modal";
import ModalRight from "../../components/modal-right";
import Loader from "../../components/loader/loader";

import useLoader from "../../components/loader/loaderstates";
import DatePicker from "../../components/date-picker";
import { format, parseISO } from "date-fns";
import moment from "moment";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import NoDataScreen from "../../components/patient-health/no-data-screen";
import { getIsDoctor, getLoginID, useScreenType } from "../../auth";

import { updateCondition } from "../../middleware/services/visits/patient-overview/updatehealth";
import DoctorVitalsForm from "../../components/patient-health/doctor-notes/vital-form";
import DoctorComplaintInputGPUCard from "../../components/patient-health/doctor-notes/complaint-card";
import DoctorComplaintInputCPUCard from "../../components/patient-health/doctor-notes/complaint-card-cpu";
import DoctorNotesAssessment from "../../components/patient-health/doctor-notes/assessment-plans";
import DoctorROSCard from "../../components/patient-health/doctor-notes/ros-card";

import DoctorPhysicalExamCard from "../../components/patient-health/doctor-notes/physical-exam-card";
import DoctorNotesOrders from "../../components/patient-health/doctor-notes/order-card";
import HpiNotesCard from "../../components/patient-health/doctor-notes/hpi-notes-card";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import useSecondLoader from "../../components/loader/secondloader";
import Chatbot from "../../components/chatbot";
import GPUChatbot from "../../components/chatbot/gpuIndex";
import TranscribeNotes from "../../components/patient-health/doctor-notes/notes-transcription/notes-transcription";

import GPUChunks from "../../components/patient-health/doctor-notes/notes-transcription/gpu-notes-transcription";
import GPUChunksTranscribeNotes from "../../components/patient-health/doctor-notes/notes-transcription/GPU-chunks-notes-transcription";
import {
  DeleteOrder,
  doctorUpdatePatientMedicine,
  GetDoctorFavMedicine,
  GetDoctorNotes,
  updateDoctorNotes,
  updateOrderDoctorNotes,
} from "../../middleware/services/visits/patient-overview/updatedoctornotes";
import { GetDoctorFavLab } from "../../middleware/services/doctorfavourite";
import { GetDoctorFavVaccine } from "../../middleware/services/doctorfavourite/vaccination";
import { addVaccination } from "../../middleware/services/messages";
import InvestigationsDisplayCard from "../../components/patient-health/vital-display-card/investigations";
import NoMedicalConditionDataScreen from "../../components/patient-health/medical-history/medical-condition-no-screen";
import NoSurgicalHistoryDataScreen from "../../components/patient-health/surgical-history/surgical-history-no-screen";
import StartVisitOverview from "../../components/patient-health/overview/start-visit-overview";
import ImagingTests from "../../components/patient-health/lab-test/imaging";
import PastImagingTests from "../../components/patient-health/past-visits/past-imaging";
import NoAllergyDataScreen from "../../components/patient-health/allergies/allergy-no-screen";
import NoSocialHistoryDataScreen from "../../components/patient-health/social-history/social-history-no-screen";
import NoVaccinationDataScreen from "../../components/patient-health/vaccinations/vaccinations-no-data-screen";
import CPUHpiNotesCard from "../../components/patient-health/doctor-notes/hpi-notes-card-cpu";
import { actionAccessMain } from "../../auth";
import {
  AIAlternativeMedicines,
  CorrectChiefComplaintUsingAI,
  CorrectMedicalTermsUsingAI,
  DetectDrugInteractions,
  FetchMyHealthAIData,
  GenerateAskADoctorPrescriptionFromChats,
  GenerateDoctorNotesFromTranscripts,
  GenerateDoctorPatientHistoryNotesFromTranscripts,
} from "../../middleware/services/visits/aicalls";
import CPUMessages from "../../components/patient-health/messages";
import GPUMessages from "../../components/patient-health/messages/gpu-index";
import VirtualChatDisplay from "../../components/patient-health/doctor-notes/virtual-visit-chats";
import CPUTranscribeNotes from "../../components/patient-health/doctor-notes/notes-transcription/CPU-transcription";
import AudioCompatibilityCheck from "../../components/patient-health/doctor-notes/notes-transcription/compatibility-check";
import DoctorPhysicalExamCPUCard from "../../components/patient-health/doctor-notes/physical-exam-card-cpu";
import UploadDoctorDocuments from "../../components/patient-health/doctor-notes/doctor-documents";
import DoctorROSCPUCard from "../../components/patient-health/doctor-notes/ros-card-cpu";
import { AcceptVisit, FetchDoctorsByUser } from "../../middleware/services/home";
import AssignVisit from "../../components/assignVisit";
import MobileChatBot from "../../components/chatbot/mobindex";
import MobileTranscribeNotes from "../../components/patient-health/doctor-notes/notes-transcription/Mobile-transcription";

  import FamilyNoDataScreen from "../../components/patient-health/family-history/family-history-no-screen";
import NoMedicationDataScreen from "../../components/patient-health/medications/medication-no-screen";
import NoInvestigationDataScreen from "../../components/patient-health/investigations/investigations-no-data-screen";
import SimpleTable from "../../components/simple-table";
import GrayCard from "../../components/patient-health/overview/gray-header-card";
import { GPUChatAudioManagerSpeechMode } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";
import { COLORS } from "../../components/styles/colors";
import { useHybridTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useHybridTranscriber";
import { Controller, useForm, useWatch } from "react-hook-form";
import PrimaryAssessmentInput from "../../components/patient-health/doctor-notes/assessment-input";
import AssessmentAudioManager from "../../components/patient-health/doctor-notes/assessmentaudiomanager";
import { AddVitalData } from "../../middleware/services/messages";
import { CopyIcon, SearchIcon } from "@chakra-ui/icons";
import GrayCardQuickPrescription from "../../components/patient-health/overview/gray-card-quick-prescription";
import { AudioDisplayForClutter } from "../../components/patient-health/doctor-notes/notes-transcription/utils/audio-display-multi-lingual";
import DropdownWithMultiLingual from "../../components/dropdown-multilingual";
import { languageCodeMap, languageOptions } from "../../components/language-dropdown";
import MiniDropdownInput from "../../components/mini-dropdown";
import DropdownInputForVitals from "../../components/dropdown-input-forVitals";
import { FetchMedicineList } from "../../middleware/services/billing";
import { FetchMedicineAIAnswer, FetchMedicineAIPrompts, GetAIMedicineComposition } from "../../middleware/services/medications.js";
// import AlertToaster from "../../components/toaster/AlertToaster";
import QuickViewToaster from "../../components/customizedtoaster/index.js";
import QuickViewAlertToaster from "../../components/customizedtoaster/AlertToaster.js";
import { FetchMedicineViewDetails } from "../../middleware/services/medicines/index.js";
// import { CgRemove } from "react-icons/cg";
// import { FaRegSave } from "react-icons/fa";

import { FaHeartbeat, FaMagic, FaRegSave, FaEdit, FaSync, FaTimes, FaMicrophone } from 'react-icons/fa';
import { CgRemove } from 'react-icons/cg';
import { Spinner } from '@chakra-ui/react';

// Helper function to get the meal timing option label
const getMealTimingLabel = (morning, afternoon, night) => {
  const pattern = `${morning || 0}-${afternoon || 0}-${night || 0}`;
  const labelMap = {
    "1-0-0": "1-0-0",
    "0-1-0": "0-1-0",
    "0-0-1": "0-0-1",
    "1-1-0": "1-1-0",
    "1-0-1": "1-0-1",
    "0-1-1": "0-1-1",
    "1-1-1": "1-1-1",
    "0-0-0": "0-0-0"
    // "1-0-0": "1-0-0 (Morning)",
    // "0-1-0": "0-1-0 (Afternoon)",
    // "0-0-1": "0-0-1 (Night)",
    // "1-1-0": "1-1-0 (Morning & Afternoon)",
    // "1-0-1": "1-0-1 (Morning & Night)",
    // "0-1-1": "0-1-1 (Afternoon & Night)",
    // "1-1-1": "1-1-1 (All three)",
    // "0-0-0": "0-0-0 (None)"
  };
  return labelMap[pattern] || "1-0-0"; // Default to morning if pattern not found
  // return labelMap[pattern] || "1-0-0 (Morning)"; // Default to morning if pattern not found
};

// Helper function to parse meal timing option value
const parseMealTiming = (optionValue) => {
  // Extract only the numeric part (e.g., "0-0-1" from "0-0-1 (Night)")
  const numericPart = optionValue.split(' ')[0];
  const [morning, afternoon, night] = numericPart.split('-').map(Number);
  return { morning, afternoon, night };
};

const QuickVisitIndex = () => {

  // ---------------------------------------------- Modal Add/edit form -----------------
    const addPrescriptionMedication = useRef();
    const editSelectedPrescriptionMedication = useRef();
    const editCurrentPrescriptionMedication = useRef();

  // const [submitChiefComplaintTab, setSubmitChiefComplaintTab] = useState(false);
  // const [submitAssessmentTab, setAssessmentTab] = useState(false);
  // const [submitVitalsTab, setVitalsTab] = useState(false);
const location = useLocation();
  const params = new URLSearchParams(location.search);

  const patientId = params.get("patientId");
  const appointmentId = params.get("appointmentId");
  const doctorId = getLoginID();

// ------------------------------------ Single Record Functionality start ---------------------

  const [aiResponse, setAiResponse] = useState(null);
  const [aiPatientVitals, setAiPatientVitals] = useState("");
  const [aiPatientResponse, setAiPatientResponse] = useState(null);

  const [aiCc, setAiCc] = useState("");
  const [aiHpiText, setAiHpiText] = useState("");

  // Add these state variables
const [combinedNotes, setCombinedNotes] = useState("");
const [isVitalsModalOpen, setIsVitalsModalOpen] = useState(false);
const [tempVitalsData, setTempVitalsData] = useState("");

const [transcriptionText, setTranscriptionText] = useState(""); // Add this for user's transcription
const [aiSuggestions, setAiSuggestions] = useState(null); // Store AI suggestions
const [isAiLoading, setIsAiLoading] = useState(false); // Loading state for AI

  const fetchPatientHistoryData = async (transcription = null) => {
      const inputToFetch = {
        input: {
          transcription: transcription || transcriptionText 
        },
      };
      showLoader();
      // console.log(inputToFetch);
      try {
        const data = await GenerateDoctorPatientHistoryNotesFromTranscripts(
          inputToFetch.input
        );
        setAiPatientResponse(data);
        setAiPatientVitals(data?.patient_vitals);
debugVitalsParsing(data?.patient_vitals);
        // console.log("patient extracted data", data);

        return data;
      } catch (error) {
        console.error("Error fetching AIRA Notes data:", error);
      } finally {
        dismissLoader();
      }
    };
  const fetchAiraGeneratedNotes = async (transcription = null) => {
      const inputToFetch = {
        input: {
          transcription: transcription || transcriptionText
        },
      };  
      showLoader();
      // console.log(inputToFetch);
      // setAiInputForFeedback(inputToFetch);
      try {
          const data = await GenerateDoctorNotesFromTranscripts(inputToFetch.input);
          // console.log(data)
          setAiResponse(data);
          setAiCc(data?.chiefcomplaint);
          setAiHpiText(data?.hpi_text);
        // console.log("Generated doctor notes", data);
        return data;
      } catch (error) {
        console.error("Error fetching AIRA Notes data:", error);
      } finally {
        dismissLoader();
      }
    };

    useEffect(() => {
  // Fetch saved data when component mounts
  fetchAllDoctorNotesData();
  
  // Fetch AI suggestions if needed
  fetchPatientHistoryData();
  fetchAiraGeneratedNotes();
}, [doctorId, patientId, appointmentId]);

  // Replace your current transcriber hook with this
// Update the transcriber hook to handle manual entry
const { transcriber: notesTranscriber, mode: notesMode } = useHybridTranscriber(
  "speech",
  (text) => {
    // console.log("Transcript received:", text);
    
    // Append to transcription text
    setTranscriptionText(prev => {
      if (prev && prev.trim()) {
        return `${prev} ${text}`;
      }
      return text;
    });
    
    // Handle combined notes differently based on edit mode
    setCombinedNotes(prev => {
      if (editingSection) {
        // In edit mode: append new transcription to the section content
        // Extract the current section text from combined notes
        const sectionLabel = getSectionLabel(editingSection);
        const labelPrefix = `${sectionLabel}: `;
        
        let currentSectionText = "";
        if (prev.startsWith(labelPrefix)) {
          // Extract text after the label
          currentSectionText = prev.substring(labelPrefix.length);
        }
        
        // Append new transcription to existing section text
        if (currentSectionText && currentSectionText.trim()) {
          return `${labelPrefix}${currentSectionText} ${text}`;
        } else {
          return `${labelPrefix}${text}`;
        }
      } else {
        // Not in edit mode: append new transcription (original behavior)
        if (prev && prev.trim()) {
          return `${prev}\n${text}`;
        }
        return text;
      }
    });
    
    
    setNotesPlaceholder("Enter Chief Complaint, History of Present Illness, Vitals, Assessment, Plan, etc...");
    setNotesTyping(false);
  }
);

// Update processTranscriptionAndGetAI function
// First, update the processTranscriptionAndGetAI function to accept a transcript parameter
// Update the processTranscriptionAndGetAI function to avoid duplicate transcriptions
const processTranscriptionAndGetAI = async (transcript = null) => {
  // Use either passed transcript OR transcription text
  const inputText = transcript || transcriptionText.trim();
  
  if (!inputText) {
    // If no direct transcript or transcriptionText, check combinedNotes
    if (combinedNotes.trim() && !combinedNotes.includes('Chief Complaint:') && !combinedNotes.includes('History of Present Illness:') && !combinedNotes.includes('Vitals:')) {
      // This is raw transcription text in the textarea
      const inputTextFromNotes = combinedNotes.trim();
      setIsAiLoading(true);
      setAiSuggestions(null);
      setEditingSection(null);
      
      try {
        const [patientHistoryData, airaNotesData] = await Promise.all([
          fetchPatientHistoryData(inputTextFromNotes),
          fetchAiraGeneratedNotes(inputTextFromNotes)
        ]);
        
        const suggestions = {
          cc: airaNotesData?.chiefcomplaint,
          hpi: airaNotesData?.hpi_text,
          vitals: patientHistoryData?.patient_vitals,
        };
        
        setAiSuggestions(suggestions);
        const formattedNotes = formatAISuggestionsForTextarea(suggestions);
        setCombinedNotes(formattedNotes);
        
        showSuccessToast("AI suggestions generated successfully");
      } catch (error) {
        console.error("Error getting AI suggestions:", error);
        showErrorToast("Failed to get AI suggestions");
      } finally {
        setIsAiLoading(false);
      }
      return;
    }
    
    showErrorToast("Please record or enter some text first");
    return;
  }
  
  setIsAiLoading(true);
  setAiSuggestions(null);
  setEditingSection(null);
  
  try {
    // Update transcription text if we have a new transcript
    if (transcript && !transcriptionText.includes(transcript)) {
      setTranscriptionText(prev => prev ? `${prev} ${transcript}` : transcript);
    }
    
    // Call both AI functions in parallel
    const [patientHistoryData, airaNotesData] = await Promise.all([
      fetchPatientHistoryData(inputText),
      fetchAiraGeneratedNotes(inputText)
    ]);
    
    // Combine AI suggestions
    const suggestions = {
      cc: airaNotesData?.chiefcomplaint,
      hpi: airaNotesData?.hpi_text,
      vitals: patientHistoryData?.patient_vitals,
    };
    
    setAiSuggestions(suggestions);
    
    // Format AI suggestions for display in textarea
    const formattedNotes = formatAISuggestionsForTextarea(suggestions);
    
    // Clear any raw transcription text and set only AI suggestions
    setCombinedNotes(formattedNotes);
    
    showSuccessToast("AI suggestions generated successfully");
    
  } catch (error) {
    console.error("Error getting AI suggestions:", error);
    showErrorToast("Failed to get AI suggestions");
  } finally {
    setIsAiLoading(false);
  }
};

// Update the GPUChatAudioManagerSpeechMode component to trigger AI directly
// You'll need to update the component usage in your JSX

// Format AI suggestions for textarea display
const formatAISuggestionsForTextarea = (suggestions) => {
  let formattedText = "";
  
  if (suggestions.cc) {
    formattedText += `Chief Complaint: ${suggestions.cc}\n\n`;
  }
  
  if (suggestions.hpi) {
    formattedText += `History of Present Illness: ${suggestions.hpi}\n\n`;
  }
  
  if (suggestions.vitals) {
    formattedText += `Vitals: ${suggestions.vitals}\n\n`;
  }
  
  // Add more sections as needed
  
  return formattedText.trim();
};

const [notesTyping, setNotesTyping] = useState(false);
const [notesPlaceholder, setNotesPlaceholder] = useState("Enter Chief Complaint, History of Present Illness, Vitals, Assessment, Plan, etc...");

// Add these functions
// Update the openVitalsModal function
// const openVitalsModal = (vitalsText = "") => {
//   // Set the vitals text for reference
//   setTempVitalsData(vitalsText);
  
//   // Enter edit mode for vitals
//   setEditingSection('vitals');
//   setSectionBeingEdited('vitals');
  
//   // Reset all form values first
//   reset({
//     "Body Temperature": "",
//     "Pulse": "",
//     "Respiratory Rate": "",
//     "Systolic Blood Pressure": "",
//     "Diastolic Blood Pressure": "",
//     "Oxygen Saturation": "",
//     "Fasting Blood Glucose": "",
//     "Postprandial Blood Glucose": "",
//   });
  
//   setWeightValue("");
//   setHeightValue("");
//   setHeightSubValue("");
  
//   if (vitalsText) {
//     try {
//       // Use debug function to see what's being parsed
//       debugVitalsParsing(vitalsText);
      
//       // Parse vitals from the displayed text
//       const parsedVitals = parseVitalsFromDisplayText(vitalsText);
      
//       console.log("Parsed vitals for form:", parsedVitals);
      
//       // Set form values based on parsed vitals
//       parsedVitals.forEach(vital => {
//         switch(vital.name) {
//           case "Body Temperature":
//             setValue("Body Temperature", vital.value);
//             break;
//           case "Pulse":
//             setValue("Pulse", vital.value);
//             break;
//           case "Respiratory Rate":
//             setValue("Respiratory Rate", vital.value);
//             break;
//           case "Systolic Blood Pressure":
//             setValue("Systolic Blood Pressure", vital.value);
//             break;
//           case "Diastolic Blood Pressure":
//             setValue("Diastolic Blood Pressure", vital.value);
//             break;
//           case "Oxygen Saturation":
//             setValue("Oxygen Saturation", vital.value);
//             break;
//           case "Fasting Blood Glucose":
//             setValue("Fasting Blood Glucose", vital.value);
//             break;
//           case "Postprandial Blood Glucose":
//             setValue("Postprandial Blood Glucose", vital.value);
//             break;
//           case "Weight":
//             setWeightValue(vital.value);
//             setWeightUnit(vital.unit || "lbs");
//             break;
//           case "Height":
//             if (vital.unit === "ft" || vital.unit === "ft." || vital.unit === "'") {
//               const parts = vital.value.split('.');
//               setHeightValue(parts[0] || "");
//               setHeightSubValue(parts[1] || "");
//               setHeightUnit("ft");
//             } else {
//               setHeightValue(vital.value);
//               setHeightUnit("cm");
//             }
//             break;
//         }
//       });
//     } catch (error) {
//       console.error("Error parsing vitals:", error);
//     }
//   }
  
//   setIsVitalsModalOpen(true);
// };
// Add this function to help debug vitals parsing
const debugVitalsParsing = (vitalsText) => {
  // console.log("=== VITALS PARSING DEBUG ===");
  // console.log("Input text:", vitalsText);
  
  const parsed = parseVitalsFromDisplayText(vitalsText);
  // console.log("Parsed results:", parsed);
  
  parsed.forEach(vital => {
    console.log(`${vital.name}: ${vital.value} ${vital.unit}`);
  });
  
  return parsed;
};

// Parse vitals from displayed text (e.g., "Temp: 100°F, BP: 120/80 mmHg, Pulse: 72 bpm")
// Parse vitals from displayed text (e.g., "Temp: 100°F, BP: 120/80 mmHg, Pulse: 72 bpm")
const parseVitalsFromDisplayText = (displayText) => {
  const vitals = [];
  
  // console.log("Parsing vitals text:", displayText);
  
  // Temperature - handle multiple formats
  const tempMatches = [
    ...displayText.matchAll(/temp[:\s]*(\d+(?:\.\d+)?)[\s°]*f/gi),
    ...displayText.matchAll(/temperature[:\s]*(\d+(?:\.\d+)?)[\s°]*f/gi),
    ...displayText.matchAll(/temp[:\s]*(\d+(?:\.\d+)?)[\s°]*c/gi),
    ...displayText.matchAll(/temperature[:\s]*(\d+(?:\.\d+)?)[\s°]*c/gi),
  ];
  
  // Also check for simple number patterns with "is" keyword
  if (displayText.toLowerCase().includes('temperature') || displayText.toLowerCase().includes('temp')) {
    const tempMatch = displayText.match(/(?:temperature|temp)[\s]*is[\s]*(\d+(?:\.\d+)?)/i);
    if (tempMatch) {
      vitals.push({
        name: "Body Temperature",
        value: tempMatch[1],
        unit: "°F"
      });
    }
  }
  
  tempMatches.forEach(match => {
    if (match[1]) {
      const unit = match[0].toLowerCase().includes('c') ? '°C' : '°F';
      vitals.push({
        name: "Body Temperature",
        value: match[1],
        unit: unit
      });
    }
  });
  
  // Blood Pressure - handle multiple formats
  const bpMatches = [
    ...displayText.matchAll(/bp[:\s]*(\d+)\s*\/\s*(\d+)/gi),
    ...displayText.matchAll(/blood pressure[:\s]*(\d+)\s*\/\s*(\d+)/gi),
    ...displayText.matchAll(/(\d+)\s*\/\s*(\d+)\s*mmhg/gi),
  ];
  
  // Also check for "blood pressure is" pattern
  const bpIsMatch = displayText.match(/blood pressure[\s]*is[\s]*(\d+)\s*\/\s*(\d+)/i);
  if (bpIsMatch) {
    vitals.push({
      name: "Systolic Blood Pressure",
      value: bpIsMatch[1],
      unit: "mmHg"
    });
    vitals.push({
      name: "Diastolic Blood Pressure",
      value: bpIsMatch[2],
      unit: "mmHg"
    });
  }
  
  bpMatches.forEach(match => {
    if (match[1] && match[2]) {
      vitals.push({
        name: "Systolic Blood Pressure",
        value: match[1],
        unit: "mmHg"
      });
      vitals.push({
        name: "Diastolic Blood Pressure",
        value: match[2],
        unit: "mmHg"
      });
    }
  });
  
  // Pulse/Heart Rate - handle multiple formats - FIXED HERE
  const pulseMatches = [
    ...displayText.matchAll(/pulse[:\s]*(\d+)/gi),
    ...displayText.matchAll(/heart rate[:\s]*(\d+)/gi),
    ...displayText.matchAll(/heartrate[:\s]*(\d+)/gi),
    ...displayText.matchAll(/hr[:\s]*(\d+)/gi),
  ];
  
  // Also check for "heart rate is" pattern
  const pulseIsMatch = displayText.match(/heart rate[\s]*is[\s]*(\d+)/i);
  if (pulseIsMatch) {
    vitals.push({
      name: "Pulse",
      value: pulseIsMatch[1],
      unit: "bpm"
    });
  }
  
  pulseMatches.forEach(match => {
    if (match[1]) {
      vitals.push({
        name: "Pulse",
        value: match[1],
        unit: "bpm"
      });
    }
  });
  
  // Respiratory Rate - handle multiple formats
  const rrMatches = [
    ...displayText.matchAll(/respiratory rate[:\s]*(\d+)/gi),
    ...displayText.matchAll(/rr[:\s]*(\d+)/gi),
  ];
  
  // Also check for "respiratory rate is" pattern
  const rrIsMatch = displayText.match(/respiratory rate[\s]*is[\s]*(\d+)/i);
  if (rrIsMatch) {
    vitals.push({
      name: "Respiratory Rate",
      value: rrIsMatch[1],
      unit: "b/min"
    });
  }
  
  rrMatches.forEach(match => {
    if (match[1]) {
      vitals.push({
        name: "Respiratory Rate",
        value: match[1],
        unit: "b/min"
      });
    }
  });
  
  // SPO2/Oxygen Saturation - handle multiple formats - FIXED HERE
  const spo2Matches = [
    ...displayText.matchAll(/spo2[:\s]*(\d+)/gi),
    ...displayText.matchAll(/oxygen saturation[:\s]*(\d+)/gi),
    ...displayText.matchAll(/spO2[:\s]*(\d+)/gi),
    ...displayText.matchAll(/o2[\s]*sat[:\s]*(\d+)/gi),
  ];
  
  // Also check for "oxygen saturation is" pattern
  const spo2IsMatch = displayText.match(/oxygen saturation[\s]*is[\s]*(\d+)/i);
  if (spo2IsMatch) {
    vitals.push({
      name: "Oxygen Saturation",
      value: spo2IsMatch[1],
      unit: "%"
    });
  }
  
  spo2Matches.forEach(match => {
    if (match[1]) {
      vitals.push({
        name: "Oxygen Saturation",
        value: match[1],
        unit: "%"
      });
    }
  });
  
  // Fasting Glucose - handle multiple formats
  const fGlucoseMatches = [
    ...displayText.matchAll(/fasting[:\s]*glucose[:\s]*(\d+)/gi),
    ...displayText.matchAll(/f\.?\s*glucose[:\s]*(\d+)/gi),
    ...displayText.matchAll(/fasting blood glucose[:\s]*(\d+)/gi),
  ];
  
  fGlucoseMatches.forEach(match => {
    if (match[1]) {
      vitals.push({
        name: "Fasting Blood Glucose",
        value: match[1],
        unit: "mg/dL"
      });
    }
  });
  
  // Postprandial Glucose - handle multiple formats
  const pGlucoseMatches = [
    ...displayText.matchAll(/postprandial[:\s]*glucose[:\s]*(\d+)/gi),
    ...displayText.matchAll(/p\.?\s*glucose[:\s]*(\d+)/gi),
    ...displayText.matchAll(/postprandial blood glucose[:\s]*(\d+)/gi),
  ];
  
  pGlucoseMatches.forEach(match => {
    if (match[1]) {
      vitals.push({
        name: "Postprandial Blood Glucose",
        value: match[1],
        unit: "mg/dL"
      });
    }
  });
  
  // Add additional parsing for numeric patterns
  // Look for numbers that might be vitals
  const allNumbers = displayText.match(/\b(\d+)\b/g);
  if (allNumbers) {
    const textLower = displayText.toLowerCase();
    
    // Try to find heart rate
    if (textLower.includes('heart') || textLower.includes('pulse')) {
      for (const num of allNumbers) {
        const numInt = parseInt(num);
        if (numInt >= 40 && numInt <= 200) {
          const numIndex = textLower.indexOf(num);
          const context = textLower.substring(Math.max(0, numIndex - 20), Math.min(textLower.length, numIndex + 20));
          if (context.includes('heart') || context.includes('pulse')) {
            // Check if not already added
            if (!vitals.some(v => v.name === "Pulse")) {
              vitals.push({
                name: "Pulse",
                value: num,
                unit: "bpm"
              });
            }
            break;
          }
        }
      }
    }
    
    // Try to find SPO2
    if (textLower.includes('oxygen') || textLower.includes('spo2') || textLower.includes('saturation')) {
      for (const num of allNumbers) {
        const numInt = parseInt(num);
        if (numInt >= 70 && numInt <= 100) {
          const numIndex = textLower.indexOf(num);
          const context = textLower.substring(Math.max(0, numIndex - 20), Math.min(textLower.length, numIndex + 20));
          if (context.includes('oxygen') || context.includes('spo2') || context.includes('saturation')) {
            // Check if not already added
            if (!vitals.some(v => v.name === "Oxygen Saturation")) {
              vitals.push({
                name: "Oxygen Saturation",
                value: num,
                unit: "%"
              });
            }
            break;
          }
        }
      }
    }
  }
  
  // console.log("Parsed vitals:", vitals);
  return vitals;
};

// Update the vitals form submit handler
const handleVitalsSubmit = async (data) => {
  try {
    // Prepare vitals array for API
    const vitalsArray = prepareVitalsArrayForAPI(data);
    
    // Format vitals for display
    const vitalsText = formatVitalsForTextarea(data);
    
    // Update AI suggestions with new vitals
    if (aiSuggestions) {
      const updatedSuggestions = {
        ...aiSuggestions,
        vitals: vitalsText
      };
      setAiSuggestions(updatedSuggestions);
      setSavedVitals(vitalsText);
    } else {
      // If no existing aiSuggestions, create one with vitals
      setAiSuggestions({
        cc: savedCc || "",
        hpi: savedHpi || "",
        vitals: vitalsText
      });
      setSavedVitals(vitalsText);
    }
    
    // Save vitals to backend
    await saveVitalsToBackend(vitalsArray);
    
    // Clear textarea and exit edit mode
    setCombinedNotes("");
    setTranscriptionText("");
    setEditingSection(null);
    setSectionBeingEdited(null);
    
    // Close modal
    closeVitalsModal();
    
    // Reset placeholder
    setNotesPlaceholder("Enter Chief Complaint, History of Present Illness, Vitals, Assessment, Plan, etc...");
    
    showSuccessToast("Vitals saved successfully");
    
  } catch (error) {
    console.error("Error saving vitals:", error);
    showErrorToast("Failed to save vitals");
  }
};

// Prepare vitals array for API call
const prepareVitalsArrayForAPI = (formData) => {
  const vitalsArray = [];
  const now = new Date();
  const padZero = (num) => num.toString().padStart(2, "0");
  const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())} ${padZero(now.getHours())}:${padZero(now.getMinutes())}:${padZero(now.getSeconds())}`;
  
  // Add all vital signs from form
  const vitalFields = [
    { name: "Systolic Blood Pressure", unit: "mmHg", value: formData["Systolic Blood Pressure"] },
    { name: "Diastolic Blood Pressure", unit: "mmHg", value: formData["Diastolic Blood Pressure"] },
    { name: "Pulse", unit: "bpm", value: formData["Pulse"] },
    { name: "Body Temperature", unit: "°F", value: formData["Body Temperature"] },
    { name: "Respiratory Rate", unit: "b/min", value: formData["Respiratory Rate"] },
    { name: "Oxygen Saturation", unit: "%", value: formData["Oxygen Saturation"] },
    { name: "Fasting Blood Glucose", unit: "mg/dL", value: formData["Fasting Blood Glucose"] },
    { name: "Postprandial Blood Glucose", unit: "mg/dL", value: formData["Postprandial Blood Glucose"] },
  ];
  
  vitalFields.forEach(field => {
    if (field.value && field.value !== "") {
      vitalsArray.push({
        vitalname: field.name,
        vitalvalue: field.value,
        vitalunit: field.unit,
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
  });
  
  // Add weight if available
  if (weightValue) {
    vitalsArray.push({
      vitalname: "Weight",
      vitalvalue: weightValue,
      vitalunit: weightUnit,
      vitaltype_cd: "",
      vitaladdeddate: formattedDate
    });
  }
  
  // Add height if available
  if (heightValue) {
    const heightValueToSave = heightUnit === "ft" 
      ? `${heightValue}.${heightSubValue || '0'}`
      : heightValue;
    
    vitalsArray.push({
      vitalname: "Height",
      vitalvalue: heightValueToSave,
      vitalunit: heightUnit,
      vitaltype_cd: "238",
      vitaladdeddate: formattedDate
    });
  }
  
  return vitalsArray;
};

// Save vitals using the same updateDoctorNotes API
const saveVitalsToBackend = async (vitalsArray) => {
  try {
    if (vitalsArray.length > 0) {
      const inputToSave = {
        input: {
          doctorid: doctorId,
          patientid: patientId,
          appointmentid: appointmentId,
          vitals: vitalsArray,
        },
      };
      
      // console.log("Saving vitals:", inputToSave);
      
      showLoader();
      const result = await updateDoctorNotes(inputToSave.input);
      dismissLoader();
      
      // Refresh data
      fetchPatientHealthData();
      fetchAllDoctorNotesData();
      
      return result;
    }
  } catch (error) {
    console.error("Error saving vitals:", error);
    dismissLoader();
    throw error;
  }
};

// Save vitals using the same updateDoctorNotes API
// const saveVitalsToBackend = async (vitalsData) => {
//   try {
//     const vitalsArray = [];
//     const now = new Date();
//     const padZero = (num) => num.toString().padStart(2, "0");
//     const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())} ${padZero(now.getHours())}:${padZero(now.getMinutes())}:${padZero(now.getSeconds())}`;
    
//     // Add form vitals
//     if (vitalsData["Body Temperature"]) {
//       vitalsArray.push({
//         vitalname: "Body Temperature",
//         vitalvalue: vitalsData["Body Temperature"],
//         vitalunit: "°F",
//         vitaltype_cd: "",
//         vitaladdeddate: formattedDate
//       });
//     }
    
//     if (vitalsData["Pulse"]) {
//       vitalsArray.push({
//         vitalname: "Pulse",
//         vitalvalue: vitalsData["Pulse"],
//         vitalunit: "bpm",
//         vitaltype_cd: "",
//         vitaladdeddate: formattedDate
//       });
//     }
    
//     // Add other vitals... (same as before)
    
//     if (vitalsArray.length > 0) {
//       const inputToSave = {
//         input: {
//           doctorid: doctorId,
//           patientid: patientId,
//           appointmentid: appointmentId,
//           vitals: vitalsArray,
//           // ...(branchId && { branchid: branchId }),
//           // ...(hospitalId && { hospitalid: hospitalId })
//         },
//       };
      
//       console.log("Saving vitals:", inputToSave);
      
//       showLoader();
//       const result = await updateDoctorNotes(inputToSave.input);
//       dismissLoader();
      
//       // Refresh patient data
//       fetchPatientHealthData();
//       fetchAllDoctorNotesData();
      
//       return result;
//     }
//   } catch (error) {
//     console.error("Error saving vitals:", error);
//     dismissLoader();
//     throw error;
//   }
// };
// Format form data into vitals text for textarea
// Format form data into vitals text for textarea
const formatVitalsForTextarea = (data) => {
  const vitalsParts = [];
  
  if (data["Body Temperature"]) {
    vitalsParts.push(`Temp: ${data["Body Temperature"]}°F`);
  }
  if (data["Pulse"]) {
    vitalsParts.push(`Pulse: ${data["Pulse"]} bpm`);
  }
  if (data["Respiratory Rate"]) {
    vitalsParts.push(`RR: ${data["Respiratory Rate"]} b/min`);
  }
  if (data["Systolic Blood Pressure"] && data["Diastolic Blood Pressure"]) {
    vitalsParts.push(`BP: ${data["Systolic Blood Pressure"]}/${data["Diastolic Blood Pressure"]} mmHg`);
  }
  if (data["Oxygen Saturation"]) {
    vitalsParts.push(`SPO2: ${data["Oxygen Saturation"]}%`);
  }
  if (data["Fasting Blood Glucose"]) {
    vitalsParts.push(`F. Glucose: ${data["Fasting Blood Glucose"]} mg/dL`);
  }
  if (data["Postprandial Blood Glucose"]) {
    vitalsParts.push(`P. Glucose: ${data["Postprandial Blood Glucose"]} mg/dL`);
  }
  if (weightValue) {
    vitalsParts.push(`Weight: ${weightValue} ${weightUnit}`);
  }
  if (heightValue) {
    const heightDisplay = heightUnit === "ft" 
      ? `${heightValue}.${heightSubValue || '0'} ${heightUnit}`
      : `${heightValue} ${heightUnit}`;
    vitalsParts.push(`Height: ${heightDisplay}`);
  }
  
  return vitalsParts.join(", ");
};

// New function to save vitals from form
const SubmitVitalsForm = async (vitalsData) => {
  const vitalsToSave = [];
  
  // Add form vitals
  if (vitalsData["Body Temperature"]) {
    vitalsToSave.push({
      vitalname: "Body Temperature",
      vitalvalue: vitalsData["Body Temperature"],
      vitalunit: "°F",
      vitaltype_cd: "",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  if (vitalsData["Pulse"]) {
    vitalsToSave.push({
      vitalname: "Pulse",
      vitalvalue: vitalsData["Pulse"],
      vitalunit: "bpm",
      vitaltype_cd: "",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  if (vitalsData["Respiratory Rate"]) {
    vitalsToSave.push({
      vitalname: "Respiratory Rate",
      vitalvalue: vitalsData["Respiratory Rate"],
      vitalunit: "b/min",
      vitaltype_cd: "",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  if (vitalsData["Systolic Blood Pressure"]) {
    vitalsToSave.push({
      vitalname: "Systolic Blood Pressure",
      vitalvalue: vitalsData["Systolic Blood Pressure"],
      vitalunit: "mmHg",
      vitaltype_cd: "",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  if (vitalsData["Diastolic Blood Pressure"]) {
    vitalsToSave.push({
      vitalname: "Diastolic Blood Pressure",
      vitalvalue: vitalsData["Diastolic Blood Pressure"],
      vitalunit: "mmHg",
      vitaltype_cd: "",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  if (vitalsData["Oxygen Saturation"]) {
    vitalsToSave.push({
      vitalname: "Oxygen Saturation",
      vitalvalue: vitalsData["Oxygen Saturation"],
      vitalunit: "%",
      vitaltype_cd: "",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  if (vitalsData["Fasting Blood Glucose"]) {
    vitalsToSave.push({
      vitalname: "Fasting Blood Glucose",
      vitalvalue: vitalsData["Fasting Blood Glucose"],
      vitalunit: "mg/dL",
      vitaltype_cd: "",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  if (vitalsData["Postprandial Blood Glucose"]) {
    vitalsToSave.push({
      vitalname: "Postprandial Blood Glucose",
      vitalvalue: vitalsData["Postprandial Blood Glucose"],
      vitalunit: "mg/dL",
      vitaltype_cd: "",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  // Add weight and height if available
  if (weightValue) {
    vitalsToSave.push({
      vitalname: "Weight",
      vitalvalue: weightValue,
      vitalunit: weightUnit,
      vitaltype_cd: "",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  if (heightValue) {
    const heightValueToSave = heightUnit === "ft" 
      ? `${heightValue}.${heightSubValue || '0'}`
      : heightValue;
    
    vitalsToSave.push({
      vitalname: "Height",
      vitalvalue: heightValueToSave,
      vitalunit: heightUnit,
      vitaltype_cd: "238",
      vitaladdeddate: `${date} ${time}`
    });
  }
  
  if (vitalsToSave.length > 0) {
    const input = {
      patientid: patientId,
      appointment_id: appointmentId,
      vitals: vitalsToSave
    };
    
    // Format date if needed
    if (moment(date, "DD-MM-YYYY", true).isValid()) {
      const formatteddate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
      const vitaldate = formatteddate + " " + time;
      input.vitals.forEach(vital => {
        vital.vitaladdeddate = vitaldate;
      });
    }
    
    // console.log("Saving vitals:", input);
    const result = await AddVitalData(input);
    
    // Refresh patient data
    fetchPatientHealthData();
    fetchAllDoctorNotesData();
    
    return result;
  }
};

const closeVitalsModal = () => {
  setIsVitalsModalOpen(false);
  setTempVitalsData("");
  
  // Don't populate textarea when closing modal
  // The vitals will be shown in the AI Suggestions section instead
  // Textarea should remain empty after saving
};


// Function to fetch saved notes data
const fetchSavedNotesData = async () => {
  try {
    // Fetch saved doctor notes
    const savedNotes = await fetchAllDoctorNotesData(); // Assuming you have this function
    
    if (savedNotes) {
      // Create AI suggestions object from saved data
      const suggestions = {
        cc: savedNotes.chiefcomplaint || "",
        hpi: savedNotes.hpitext?.description || "",
        vitals: savedNotes.vitals || "", // You might need to format vitals from saved data
      };
      
      // Set AI suggestions with saved data
      setAiSuggestions(suggestions);
      
      // Format saved data for display
      if (savedNotes.chiefcomplaint || savedNotes.hpitext?.description) {
        let formattedText = "";
        
        if (savedNotes.chiefcomplaint) {
          formattedText += `Chief Complaint: ${savedNotes.chiefcomplaint}\n\n`;
        }
        
        if (savedNotes.hpitext?.description) {
          formattedText += `History of Present Illness: ${savedNotes.hpitext.description}\n\n`;
        }
        
        if (savedNotes.vitals) {
          formattedText += `Vitals: ${savedNotes.vitals}\n\n`;
        }
        
        setCombinedNotes(formattedText.trim());
      }
    }
    
    // Also fetch vitals data separately
    fetchPatientHealthData();
    
  } catch (error) {
    console.error("Error fetching saved notes:", error);
  }
};
// const handleCombinedNotesSubmit = async (e) => {
//   e.preventDefault();
  
//   if (!combinedNotes.trim()) {
//     showErrorToast("Please enter some notes");
//     return;
//   }
  
//   try {
//     // Parse the notes into sections
//     const parsedNotes = parseNotesIntoSections(combinedNotes);
    
//     // Get current vitals from form or AI suggestions
//     const vitalsArray = await getCurrentVitalsForAPI();
//     const vitalsText = formatVitalsForDisplayFromArray(vitalsArray);
    
//     // Prepare input with separate fields for each section
//     const inputToSave = {
//       input: {
//         doctorid: doctorId,
//         patientid: patientId,
//         appointmentid: appointmentId,
//       }
//     };
    
//     // Add chief complaint if it exists in parsed notes or AI suggestions
//     if (parsedNotes.cc) {
//       inputToSave.input.chiefcomplaint = parsedNotes.cc;
//     } else if (aiSuggestions?.cc) {
//       inputToSave.input.chiefcomplaint = aiSuggestions.cc;
//     }
    
//     // Add HPI if it exists
//     if (parsedNotes.hpi) {
//       inputToSave.input.hpitext = {
//         description: parsedNotes.hpi,
//         type: "other"
//       };
//     } else if (aiSuggestions?.hpi) {
//       inputToSave.input.hpitext = {
//         description: aiSuggestions.hpi,
//         type: "other"
//       };
//     }
    
//     // Add vitals if they exist
//     if (vitalsArray.length > 0) {
//       inputToSave.input.vitals = vitalsArray;
//     }
    
//     console.log("Saving all notes:", inputToSave);
    
//     showLoader();
//     const result = await updateDoctorNotes(inputToSave.input);
//     dismissLoader();
    
//     if (result) {
//       // Update saved data state
//       setSavedCc(parsedNotes.cc || aiSuggestions?.cc || "");
//       setSavedHpi(parsedNotes.hpi || aiSuggestions?.hpi || "");
//       setSavedVitals(vitalsText);
      
//       // Update AI suggestions with saved data
//       const updatedSuggestions = {
//         cc: parsedNotes.cc || aiSuggestions?.cc || "",
//         hpi: parsedNotes.hpi || aiSuggestions?.hpi || "",
//         vitals: vitalsText,
//       };
//       setAiSuggestions(updatedSuggestions);
      
//       // ✅ Clear the textarea after successful save
//       setCombinedNotes("");
      
//       // Clear transcription but keep AI suggestions
//       setTranscriptionText("");
      
//       // Reset placeholder
//       setNotesPlaceholder("Enter Chief Complaint, History of Present Illness, Vitals, Assessment, Plan, etc...");
      
//       showSuccessToast("All notes saved successfully");
//     }
    
//   } catch (error) {
//     console.error("Error saving notes:", error);
//     dismissLoader();
//     showErrorToast("Failed to save notes");
//   }
// };
// Save all notes (CC, HPI, Vitals) in one API call
// const saveAllNotesToBackend = async (notes) => {
//   try {
//     // Get vitals from current form state for API
//     const vitalsArray = await getCurrentVitalsForAPI();
    
//     const inputToSave = {
//       input: {
//         doctorid: doctorId,
//         patientid: patientId,
//         appointmentid: appointmentId,
//         chiefcomplaint: notes.cc || "",
//         ...(notes.hpi && {
//           hpitext: {
//             description: notes.hpi,
//             type: "other"
//           }
//         }),
//         ...(vitalsArray.length > 0 && {
//           vitals: vitalsArray
//         }),
//         // ...(branchId && { branchid: branchId }),
//         // ...(hospitalId && { hospitalid: hospitalId })
//       },
//     };
    
//     console.log("Saving notes input:", inputToSave);
    
//     showLoader();
//     const result = await updateDoctorNotes(inputToSave.input);
//     dismissLoader();
    
//     // Update saved data state with new values
//     setSavedCc(notes.cc || "");
//     setSavedHpi(notes.hpi || "");
    
//     // Format vitals for display
//     const vitalsText = formatVitalsForDisplayFromArray(vitalsArray);
//     setSavedVitals(vitalsText);
    
//     // Keep AI suggestions with updated data
//     const updatedSuggestions = {
//       cc: notes.cc || "",
//       hpi: notes.hpi || "",
//       vitals: vitalsText,
//     };
//     setAiSuggestions(updatedSuggestions);
    
//     // Keep the textarea populated with saved data
//     const formattedText = formatAISuggestionsForTextarea(updatedSuggestions);
//     setCombinedNotes(formattedText);
    
//     // Clear transcription but keep AI suggestions
//     setTranscriptionText("");
    
//     showSuccessToast("Notes saved successfully");
    
//     return result;
//   } catch (error) {
//     console.error("Error saving notes:", error);
//     dismissLoader();
//     throw error;
//   }
// };

// Helper function to format vitals array for display
const formatVitalsForDisplayFromArray = (vitalsArray) => {
  if (!vitalsArray || vitalsArray.length === 0) return "";
  
  const vitalsParts = [];
  
  vitalsArray.forEach(vital => {
    switch(vital.vitalname) {
      case "Body Temperature":
        vitalsParts.push(`Temp: ${vital.vitalvalue}${vital.vitalunit}`);
        break;
      case "Pulse":
        vitalsParts.push(`Pulse: ${vital.vitalvalue} ${vital.vitalunit}`);
        break;
      case "Respiratory Rate":
        vitalsParts.push(`RR: ${vital.vitalvalue} ${vital.vitalunit}`);
        break;
      case "Systolic Blood Pressure":
        // Look for diastolic to pair
        const diastolic = vitalsArray.find(v => v.vitalname === "Diastolic Blood Pressure");
        if (diastolic) {
          vitalsParts.push(`BP: ${vital.vitalvalue}/${diastolic.vitalvalue} mmHg`);
        }
        break;
      case "Oxygen Saturation":
        vitalsParts.push(`SPO2: ${vital.vitalvalue}${vital.vitalunit}`);
        break;
      case "Fasting Blood Glucose":
        vitalsParts.push(`F. Glucose: ${vital.vitalvalue} ${vital.vitalunit}`);
        break;
      case "Postprandial Blood Glucose":
        vitalsParts.push(`P. Glucose: ${vital.vitalvalue} ${vital.vitalunit}`);
        break;
      case "Weight":
        vitalsParts.push(`Weight: ${vital.vitalvalue} ${vital.vitalunit}`);
        break;
      case "Height":
        vitalsParts.push(`Height: ${vital.vitalvalue} ${vital.vitalunit}`);
        break;
    }
  });
  
  return vitalsParts.join(", ");
};

// Get current vitals from form for API (same structure as CC/HPI)
const getCurrentVitalsForAPI = async () => {
  try {
    const vitalsToSave = [];
    const now = new Date();
    const padZero = (num) => num.toString().padStart(2, "0");
    const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())} ${padZero(now.getHours())}:${padZero(now.getMinutes())}:${padZero(now.getSeconds())}`;
    
    // Get form values
    const formValues = vitalsControl?._formValues || {};
    
    // Add form vitals
    if (formValues["Body Temperature"]) {
      vitalsToSave.push({
        vitalname: "Body Temperature",
        vitalvalue: formValues["Body Temperature"],
        vitalunit: "°F",
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
    
    if (formValues["Pulse"]) {
      vitalsToSave.push({
        vitalname: "Pulse",
        vitalvalue: formValues["Pulse"],
        vitalunit: "bpm",
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
    
    if (formValues["Respiratory Rate"]) {
      vitalsToSave.push({
        vitalname: "Respiratory Rate",
        vitalvalue: formValues["Respiratory Rate"],
        vitalunit: "b/min",
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
    
    if (formValues["Systolic Blood Pressure"]) {
      vitalsToSave.push({
        vitalname: "Systolic Blood Pressure",
        vitalvalue: formValues["Systolic Blood Pressure"],
        vitalunit: "mmHg",
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
    
    if (formValues["Diastolic Blood Pressure"]) {
      vitalsToSave.push({
        vitalname: "Diastolic Blood Pressure",
        vitalvalue: formValues["Diastolic Blood Pressure"],
        vitalunit: "mmHg",
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
    
    if (formValues["Oxygen Saturation"]) {
      vitalsToSave.push({
        vitalname: "Oxygen Saturation",
        vitalvalue: formValues["Oxygen Saturation"],
        vitalunit: "%",
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
    
    if (formValues["Fasting Blood Glucose"]) {
      vitalsToSave.push({
        vitalname: "Fasting Blood Glucose",
        vitalvalue: formValues["Fasting Blood Glucose"],
        vitalunit: "mg/dL",
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
    
    if (formValues["Postprandial Blood Glucose"]) {
      vitalsToSave.push({
        vitalname: "Postprandial Blood Glucose",
        vitalvalue: formValues["Postprandial Blood Glucose"],
        vitalunit: "mg/dL",
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
    
    // Add weight and height if available
    if (weightValue) {
      vitalsToSave.push({
        vitalname: "Weight",
        vitalvalue: weightValue,
        vitalunit: weightUnit,
        vitaltype_cd: "",
        vitaladdeddate: formattedDate
      });
    }
    
    if (heightValue) {
      const heightValueToSave = heightUnit === "ft" 
        ? `${heightValue}.${heightSubValue || '0'}`
        : heightValue;
      
      vitalsToSave.push({
        vitalname: "Height",
        vitalvalue: heightValueToSave,
        vitalunit: heightUnit,
        vitaltype_cd: "238",
        vitaladdeddate: formattedDate
      });
    }
    
    return vitalsToSave;
  } catch (error) {
    console.error("Error getting vitals for API:", error);
    return [];
  }
};

// Parse vitals from notes text and save them
const saveVitalsFromNotes = async (vitalsText) => {
  try {
    // Parse vitals from text (e.g., "Temp: 102.8°F, Pulse: 95 bpm, BP: 135/85 mmHg")
    const vitalsData = parseVitalsFromText(vitalsText);
    
    if (vitalsData && vitalsData.length > 0) {
      const vitalsInput = {
        patientid: patientId,
        appointment_id: appointmentId,
        vitals: vitalsData.map(vital => ({
          vitalname: vital.name,
          vitalvalue: vital.value,
          vitalunit: vital.unit || "",
          vitaltype_cd: "",
          vitaladdeddate: `${date} ${time}`
        }))
      };
      
      // console.log("Saving vitals:", vitalsInput);
      const result = await AddVitalData(vitalsInput);
      return result;
    }
  } catch (error) {
    console.error("Error saving vitals:", error);
    throw error;
  }
};

// Parse vitals from text string
// const parseVitalsFromText = (vitalsText) => {
//   // Ensure vitalsText is a string
//   if (!vitalsText || typeof vitalsText !== 'string') {
//     return [];
//   }
  
//   const vitals = [];
  
//   // Common vital patterns - simplified to avoid regex issues
//   const patterns = [
//     // Temperature patterns
//     { 
//       regex: /(?:temp|temperature)[:\s]*(\d+(?:\.\d+)?)[\s°]*F/i, 
//       name: "Body Temperature", 
//       unit: "°F" 
//     },
//     { 
//       regex: /(?:temp|temperature)[:\s]*(\d+(?:\.\d+)?)[\s°]*C/i, 
//       name: "Body Temperature", 
//       unit: "°C" 
//     },
//     // Pulse patterns
//     { 
//       regex: /(?:pulse|heart rate|hr)[:\s]*(\d+)(?:\s*bpm)?/i, 
//       name: "Pulse", 
//       unit: "bpm" 
//     },
//     // Blood Pressure patterns
//     { 
//       regex: /(?:bp|blood pressure)[:\s]*(\d+)\s*\/\s*(\d+)(?:\s*mmhg)?/i, 
//       name: "Blood Pressure",
//       isBP: true 
//     },
//     // Respiratory Rate patterns
//     { 
//       regex: /(?:rr|respiratory rate)[:\s]*(\d+)(?:\s*b\/?min)?/i, 
//       name: "Respiratory Rate", 
//       unit: "b/min" 
//     },
//     // SPO2 patterns
//     { 
//       regex: /(?:spo2|oxygen saturation)[:\s]*(\d+)(?:\s*%)?/i, 
//       name: "Oxygen Saturation", 
//       unit: "%" 
//     },
//   ];
  
//   patterns?.forEach(pattern => {
//     try {
//       const match = vitalsText?.match(pattern.regex);
//       if (match) {
//         if (pattern.isBP && match[1] && match[2]) {
//           // Blood pressure - need two values
//           vitals.push({
//             name: "Systolic Blood Pressure",
//             value: match[1],
//             unit: "mmHg"
//           });
//           vitals.push({
//             name: "Diastolic Blood Pressure",
//             value: match[2],
//             unit: "mmHg"
//           });
//         } else if (match[1]) {
//           vitals.push({
//             name: pattern.name,
//             value: match[1], 
//             unit: pattern.unit || ""
//           });
//         }
//       }
//     } catch (error) {
//       console.error("Error parsing vital pattern:", error);
//     }
//   });
  
//   return vitals;
// };

// Parse textarea content back into sections
// Parse textarea content back into sections
const parseNotesIntoSections = (notesText) => {
  const sections = {
    cc: "",
    hpi: "",
    vitals: "",
    assessment: "",
    plan: ""
  };
  
  if (!notesText.trim()) return sections;
  
  // Check if text has section headers
  const hasSectionHeaders = notesText.includes('Chief Complaint:') || 
                            notesText.includes('History of Present Illness:') || 
                            notesText.includes('Vitals:');
  
  if (hasSectionHeaders) {
    // Split by potential section markers
    const lines = notesText.split('\n');
    let currentSection = null;
    
    for (const line of lines) {
      const trimmedLine = line.trim();
      
      if (trimmedLine.startsWith('Chief Complaint:')) {
        currentSection = 'cc';
        sections.cc = trimmedLine.replace('Chief Complaint:', '').trim();
      } else if (trimmedLine.startsWith('History of Present Illness:')) {
        currentSection = 'hpi';
        sections.hpi = trimmedLine.replace('History of Present Illness:', '').trim();
      } else if (trimmedLine.startsWith('Vitals:')) {
        currentSection = 'vitals';
        sections.vitals = trimmedLine.replace('Vitals:', '').trim();
      } else if (trimmedLine.startsWith('Assessment:')) {
        currentSection = 'assessment';
        sections.assessment = trimmedLine.replace('Assessment:', '').trim();
      } else if (trimmedLine.startsWith('Plan:')) {
        currentSection = 'plan';
        sections.plan = trimmedLine.replace('Plan:', '').trim();
      } else if (currentSection && trimmedLine) {
        // Append to current section with a space
        if (sections[currentSection]) {
          sections[currentSection] += ' ' + trimmedLine;
        } else {
          sections[currentSection] = trimmedLine;
        }
      }
    }
  } else {
    // If no section headers, assume it's all CC
    sections.cc = notesText.trim();
  }
  
  return sections;
};

// Save to backend function
const saveNotesToBackend = async (notes) => {
  const inputToSave = {
    input: {
      doctorid: doctorId,
      patientid: patientId,
      appointmentid: appointmentId,
      chiefcomplaint: notes.cc,
      hpitext: notes.hpi ? {
        description: notes.hpi,
        type: "other"
      } : null,
      // Add other sections as needed
    },
  };
  
  showLoader();
  try {
    const result = await updateDoctorNotes(inputToSave.input);
    return result;
  } catch (error) {
    console.error("Error saving notes:", error);
    throw error;
  } finally {
    dismissLoader();
  }
};

// Function to add vitals to notes
const addVitalsToNotes = (vitals) => {
  setCombinedNotes(prev => {
    if (prev) {
      return `${prev}\n\nVitals: ${vitals}`;
    }
    return `Vitals: ${vitals}`;
  });
};

// ------------------ Edit Functionality here
// Add these state variables near your other state declarations
// Add these state variables near your other state declarations
const [editingSection, setEditingSection] = useState(null); // 'cc', 'hpi', 'vitals', or null
const [sectionBeingEdited, setSectionBeingEdited] = useState(null); // To track which section user clicked to edit
const [clutterIconClicked, setClutterIconClicked] = useState(false); // Track if clutter icon was clicked

// Function to call the appropriate AI correction based on section
const handleAICorrection = async () => {
  if (!editingSection || !combinedNotes.trim()) {
    showErrorToast("No text to correct");
    return;
  }
  
  setIsAiLoading(true);
  setClutterIconClicked(true);
  
  try {
    // Parse the current text to get the section content
    const sections = parseNotesIntoSections(combinedNotes);
    const sectionText = sections[editingSection] || combinedNotes.replace(`${getSectionLabel(editingSection)}:`, '').trim();
    
    if (!sectionText) {
      showErrorToast(`Please enter some ${editingSection.toUpperCase()} text first`);
      setIsAiLoading(false);
      return;
    }
    
    let result;
    const baseInput = {
      doctorid: doctorId,
      // branchid: branchId,
      // hospitalid: hospitalId
    };
    
    if (editingSection === 'cc') {
      const input = {
        text: sectionText,
        ...baseInput
      };
      result = await CorrectChiefComplaintUsingAI({ input });
    } else if (editingSection === 'hpi') {
      const input = {
        input: {
          text: sectionText,
          type: "HPI",
          ...baseInput
        }
      };
      result = await CorrectMedicalTermsUsingAI(input);
    }
    
    if (result?.text) {
      // Update the combinedNotes with corrected text
      const correctedText = `${getSectionLabel(editingSection)}: ${result.text}`;
      setCombinedNotes(correctedText);
      
      // Also update AI suggestions if they exist
      if (aiSuggestions) {
        setAiSuggestions(prev => ({
          ...prev,
          [editingSection]: result.text
        }));
      }
      
      showSuccessToast(`${getSectionLabel(editingSection)} corrected successfully`);
    }
  } catch (error) {
    console.error(`Error correcting ${editingSection}:`, error);
    showErrorToast(`Failed to correct ${editingSection}`);
  } finally {
    setIsAiLoading(false);
  }
};

// Helper function to get section label for display
const getSectionLabel = (sectionType) => {
  switch(sectionType) {
    case 'cc': return 'Chief Complaint';
    case 'hpi': return 'History of Present Illness';
    case 'vitals': return 'Vitals';
    default: return '';
  }
};

// Function to handle edit icon click for a section
// Update the handleEditSectionClick function to preserve other sections
// Function to handle edit icon click for a section
// Function to handle edit icon click for a section
// const handleEditSectionClick = (sectionType) => {
//   setEditingSection(sectionType);
//   setSectionBeingEdited(sectionType);
//   setClutterIconClicked(false);
  
//   // Get current AI suggestions OR saved data
//   let currentSuggestions = { ...aiSuggestions };
  
//   // If no AI suggestions exist, create from saved data
//   if (!currentSuggestions && (savedCc || savedHpi || savedVitals)) {
//     currentSuggestions = {
//       cc: savedCc || "",
//       hpi: savedHpi || "",
//       vitals: savedVitals || ""
//     };
//   }
  
//   // Ensure currentSuggestions is an object
//   currentSuggestions = currentSuggestions || {};
  
//   // Fill in any missing sections from saved data
//   if (!currentSuggestions.cc && savedCc) currentSuggestions.cc = savedCc;
//   if (!currentSuggestions.hpi && savedHpi) currentSuggestions.hpi = savedHpi;
//   if (!currentSuggestions.vitals && savedVitals) currentSuggestions.vitals = savedVitals;
  
//   // ✅ Keep all sections in AI suggestions state
//   setAiSuggestions(currentSuggestions);
  
//   // Get the text for the section being edited
//   const sectionText = currentSuggestions[sectionType] || "";
  
//   // Set textarea to only this section with label
//   if (sectionText) {
//     setCombinedNotes(`${getSectionLabel(sectionType)}: ${sectionText}`);
//   } else {
//     setCombinedNotes(`${getSectionLabel(sectionType)}: `);
//   }
  
//   // Clear transcription text when entering edit mode
//   setTranscriptionText("");
  
//   // Update placeholder to show we're in edit mode
//   setNotesPlaceholder(`Editing ${getSectionLabel(sectionType)}...`);
// };
// Function to save individual section
// Function to save individual section
// Function to save individual section
const saveIndividualSection = async () => {
  if (!editingSection || !combinedNotes.trim()) {
    showErrorToast("No section to save");
    return;
  }
  
  try {
    const sections = parseNotesIntoSections(combinedNotes);
    const sectionText = sections[editingSection] || combinedNotes.replace(`${getSectionLabel(editingSection)}:`, '').trim();
    
    if (!sectionText) {
      showErrorToast(`Please enter some ${editingSection.toUpperCase()} text`);
      return;
    }
    
    // Get current AI suggestions OR saved data to preserve all sections
    let currentAiSuggestions = { ...aiSuggestions };
    
    // If no AI suggestions exist yet, create from saved data
    if (!currentAiSuggestions && (savedCc || savedHpi || savedVitals)) {
      currentAiSuggestions = {
        cc: savedCc || "",
        hpi: savedHpi || "",
        vitals: savedVitals || ""
      };
    }
    
    // Ensure currentAiSuggestions is an object
    currentAiSuggestions = currentAiSuggestions || {};
    
    // Update the section being edited
    currentAiSuggestions[editingSection] = sectionText;
    
    // Prepare input with only the section being saved
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
      }
    };
    
    // Include the section being saved
    if (editingSection === 'cc') {
      inputToSave.input.chiefcomplaint = sectionText;
      // Don't send empty HPI if not being edited
      if (currentAiSuggestions.hpi) {
        inputToSave.input.hpitext = {
          description: currentAiSuggestions.hpi,
          type: "other"
        };
      }
    } else if (editingSection === 'hpi') {
      inputToSave.input.hpitext = {
        description: sectionText,
        type: "other"
      };
      // Don't send empty CC if not being edited
      if (currentAiSuggestions.cc) {
        inputToSave.input.chiefcomplaint = currentAiSuggestions.cc;
      }
    }
    
    // console.log("Saving individual section:", inputToSave);
    
    showLoader();
    const result = await updateDoctorNotes(inputToSave.input);
    dismissLoader();
    
    if (result) {
      // Update saved data state
      if (editingSection === 'cc') {
        setSavedCc(sectionText);
      } else if (editingSection === 'hpi') {
        setSavedHpi(sectionText);
      }
      
      // ✅ Keep ALL sections in AI suggestions including other sections
      setAiSuggestions(currentAiSuggestions);
      
      // ✅ Clear the textarea after successful save
      setCombinedNotes("");
      
      // Clear transcription
      setTranscriptionText("");
      
      // Reset editing mode
      setEditingSection(null);
      setSectionBeingEdited(null);
      setClutterIconClicked(false);
      
      // Reset placeholder
      setNotesPlaceholder("Enter Chief Complaint, History of Present Illness, Vitals, Assessment, Plan, etc...");
      
      // Show success message
      showSuccessToast(`${getSectionLabel(editingSection)} saved successfully`);
      
      // Refresh the saved data display to get latest from server
      fetchAllDoctorNotesData();
    }
  } catch (error) {
    console.error(`Error saving ${editingSection}:`, error);
    dismissLoader();
    showErrorToast(`Failed to save ${editingSection}`);
  }
};

// Function to cancel editing mode
const cancelEditing = () => {
  // Get current AI suggestions OR saved data
  let currentSuggestions = { ...aiSuggestions };
  
  // If no AI suggestions exist, create from saved data
  if (!currentSuggestions && (savedCc || savedHpi || savedVitals)) {
    currentSuggestions = {
      cc: savedCc || "",
      hpi: savedHpi || "",
      vitals: savedVitals || ""
    };
  }
  
  // Ensure currentSuggestions is an object
  currentSuggestions = currentSuggestions || {};
  
  // Fill in any missing sections from saved data
  if (!currentSuggestions.cc && savedCc) currentSuggestions.cc = savedCc;
  if (!currentSuggestions.hpi && savedHpi) currentSuggestions.hpi = savedHpi;
  if (!currentSuggestions.vitals && savedVitals) currentSuggestions.vitals = savedVitals;
  
  // ✅ Clear the textarea when canceling
  setCombinedNotes("");
  
  // Keep all sections in AI suggestions
  setAiSuggestions(currentSuggestions);
  
  // Reset editing states
  setEditingSection(null);
  setSectionBeingEdited(null);
  setClutterIconClicked(false);
  
  // Reset placeholder
  setNotesPlaceholder("Enter Chief Complaint, History of Present Illness, Vitals, Assessment, Plan, etc...");
  
  // Show message
  showSuccessToast("Editing cancelled");
};

// Function to handle edit icon click
// const handleEditSection = (sectionType) => {
//   setEditingSection(sectionType);
//   setSectionBeingEdited(sectionType);
  
//   // Extract the current text from AI suggestions or saved data
//   let sectionText = "";
//   switch(sectionType) {
//     case 'cc':
//       sectionText = aiSuggestions?.cc || savedCc || "";
//       // Set textarea to only CC
//       setCombinedNotes(sectionText ? `Chief Complaint: ${sectionText}` : "");
//       break;
//     case 'hpi':
//       sectionText = aiSuggestions?.hpi || savedHpi || "";
//       // Set textarea to only HPI
//       setCombinedNotes(sectionText ? `History of Present Illness: ${sectionText}` : "");
//       break;
//     case 'vitals':
//       // Vitals already handled by openVitalsModal
//       break;
//   }
// };

// Function to call AI for correcting individual section
// Function to call AI for correcting individual section
const callCorrectionAI = async (sectionType, text) => {
  if (!text.trim()) {
    showErrorToast(`Please enter some ${sectionType.toUpperCase()} text first`);
    return;
  }
  
  setIsAiLoading(true);
  
  try {
    let result;
    const baseInput = {
      doctorid: doctorId,
    };
    
    if (sectionType === 'cc') {
      const input = {
        input: {
          text: text,
          ...baseInput
        }
      };
      result = await CorrectChiefComplaintUsingAI(input.input);
    } else if (sectionType === 'hpi') {
      const input = {
        input: {
          text: text,
          type: "HPI",
          ...baseInput
        }
      };
      result = await CorrectMedicalTermsUsingAI(input);
    }
    
    if (result?.text) {
      // Get current AI suggestions to preserve other sections
      let currentSuggestions = { ...aiSuggestions };
      
      // If no AI suggestions exist, create from saved data
      if (!currentSuggestions && (savedCc || savedHpi || savedVitals)) {
        currentSuggestions = {
          cc: savedCc || "",
          hpi: savedHpi || "",
          vitals: savedVitals || ""
        };
      }
      
      // Ensure currentSuggestions is an object
      currentSuggestions = currentSuggestions || {};
      
      // Fill in any missing sections from saved data
      if (!currentSuggestions.cc && savedCc) currentSuggestions.cc = savedCc;
      if (!currentSuggestions.hpi && savedHpi) currentSuggestions.hpi = savedHpi;
      if (!currentSuggestions.vitals && savedVitals) currentSuggestions.vitals = savedVitals;
      
      // Update the corrected section
      currentSuggestions[sectionType] = result.text;
      
      // ✅ Update AI suggestions with all sections preserved
      setAiSuggestions(currentSuggestions);
      
      // Update the combinedNotes with corrected text
      setCombinedNotes(`${getSectionLabel(sectionType)}: ${result.text}`);
      
      showSuccessToast(`${getSectionLabel(sectionType)} corrected successfully`);
    }
  } catch (error) {
    console.error(`Error correcting ${sectionType}:`, error);
    showErrorToast(`Failed to correct ${sectionType}`);
  } finally {
    setIsAiLoading(false);
  }
};
// Add this function to save all notes before editing
// const saveAllNotesBeforeEdit = async () => {
//   try {
//     // Check if we have unsaved AI suggestions or transcription
//     if (aiSuggestions && (transcriptionText || combinedNotes.trim())) {
//       console.log("Auto-saving all notes before editing...");
      
//       // Parse the current notes
//       const parsedNotes = parseNotesIntoSections(combinedNotes);
      
//       // Use AI suggestions as fallback for missing sections
//       const notesToSave = {
//         cc: parsedNotes.cc || aiSuggestions?.cc || "",
//         hpi: parsedNotes.hpi || aiSuggestions?.hpi || "",
//         vitals: aiSuggestions?.vitals || savedVitals || ""
//       };
      
//       // Check if we actually have data to save
//       const hasDataToSave = notesToSave.cc || notesToSave.hpi || notesToSave.vitals;
      
//       if (hasDataToSave) {
//         // Get current vitals for API
//         const vitalsArray = await getCurrentVitalsForAPI();
        
//         const inputToSave = {
//           input: {
//             doctorid: doctorId,
//             patientid: patientId,
//             appointmentid: appointmentId,
//             chiefcomplaint: notesToSave.cc,
//             ...(notesToSave.hpi && {
//               hpitext: {
//                 description: notesToSave.hpi,
//                 type: "other"
//               }
//             }),
//             ...(vitalsArray.length > 0 && {
//               vitals: vitalsArray
//             }),
//           },
//         };
        
//         console.log("Auto-saving before edit:", inputToSave);
        
//         showLoader();
//         const result = await updateDoctorNotes(inputToSave.input);
//         dismissLoader();
        
//         if (result) {
//           // Update saved data state
//           setSavedCc(notesToSave.cc || "");
//           setSavedHpi(notesToSave.hpi || "");
          
//           // Format vitals for display
//           const vitalsText = formatVitalsForDisplayFromArray(vitalsArray);
//           setSavedVitals(vitalsText);
          
//           // Keep AI suggestions with updated data
//           const updatedSuggestions = {
//             cc: notesToSave.cc || "",
//             hpi: notesToSave.hpi || "",
//             vitals: vitalsText,
//           };
//           setAiSuggestions(updatedSuggestions);
          
//           console.log("Auto-save successful");
//           return true;
//         }
//       }
//     }
//     return false;
//   } catch (error) {
//     console.error("Error in auto-save before edit:", error);
//     dismissLoader();
//     return false;
//   }
// };

// Update the handleEditSection function to save before editing
const handleEditSection = async (sectionType) => {
  // First, save all existing notes before editing
  const saved = await saveAllNotesBeforeEdit();
  
  if (saved) {
    showSuccessToast("Data saved before editing");
  }
  
  // Now proceed with editing
  setEditingSection(sectionType);
  setSectionBeingEdited(sectionType);
  
  // Get current AI suggestions OR saved data
  let currentSuggestions = { ...aiSuggestions };
  
  // If no AI suggestions exist, create from saved data
  if (!currentSuggestions && (savedCc || savedHpi || savedVitals)) {
    currentSuggestions = {
      cc: savedCc || "",
      hpi: savedHpi || "",
      vitals: savedVitals || ""
    };
  }
  
  // Ensure currentSuggestions is an object
  currentSuggestions = currentSuggestions || {};
  
  // Fill in any missing sections from saved data
  if (!currentSuggestions.cc && savedCc) currentSuggestions.cc = savedCc;
  if (!currentSuggestions.hpi && savedHpi) currentSuggestions.hpi = savedHpi;
  if (!currentSuggestions.vitals && savedVitals) currentSuggestions.vitals = savedVitals;
  
  // ✅ Keep all sections in AI suggestions state
  setAiSuggestions(currentSuggestions);
  
  // Get the text for the section being edited
  const sectionText = currentSuggestions[sectionType] || "";
  
  // Set textarea to only this section with label
  if (sectionText) {
    setCombinedNotes(`${getSectionLabel(sectionType)}: ${sectionText}`);
  } else {
    setCombinedNotes(`${getSectionLabel(sectionType)}: `);
  }
  
  // Clear transcription text when entering edit mode
  setTranscriptionText("");
  
  // Update placeholder to show we're in edit mode
  setNotesPlaceholder(`Editing ${getSectionLabel(sectionType)}...`);
};

// Update the handleEditSectionClick function similarly
const handleEditSectionClick = async (sectionType) => {
  // First, save all existing notes before editing
  const saved = await saveAllNotesBeforeEdit();
  
  if (saved) {
    showSuccessToast("Data saved before editing");
  }
  
  // Now proceed with the original logic
  setEditingSection(sectionType);
  setSectionBeingEdited(sectionType);
  setClutterIconClicked(false);
  
  // Get current AI suggestions OR saved data
  let currentSuggestions = { ...aiSuggestions };
  
  // If no AI suggestions exist, create from saved data
  if (!currentSuggestions && (savedCc || savedHpi || savedVitals)) {
    currentSuggestions = {
      cc: savedCc || "",
      hpi: savedHpi || "",
      vitals: savedVitals || ""
    };
  }
  
  // Ensure currentSuggestions is an object
  currentSuggestions = currentSuggestions || {};
  
  // Fill in any missing sections from saved data
  if (!currentSuggestions.cc && savedCc) currentSuggestions.cc = savedCc;
  if (!currentSuggestions.hpi && savedHpi) currentSuggestions.hpi = savedHpi;
  if (!currentSuggestions.vitals && savedVitals) currentSuggestions.vitals = savedVitals;
  
  // ✅ Keep all sections in AI suggestions state
  setAiSuggestions(currentSuggestions);
  
  // Get the text for the section being edited
  const sectionText = currentSuggestions[sectionType] || "";
  
  // Set textarea to only this section with label
  if (sectionText) {
    setCombinedNotes(`${getSectionLabel(sectionType)}: ${sectionText}`);
    // ✅ Set transcriptionText to existing text so new recording appends to it
    setTranscriptionText(sectionText);
  } else {
    setCombinedNotes(`${getSectionLabel(sectionType)}: `);
    // Clear transcription text when entering edit mode with no existing text
    setTranscriptionText("");
  }
  
  // Update placeholder to show we're in edit mode
  setNotesPlaceholder(`Editing ${getSectionLabel(sectionType)}...`);
};

// Update the openVitalsModal function to also save before editing
const openVitalsModal = async (vitalsText = "") => {
  // First, save all existing notes before editing vitals
  const saved = await saveAllNotesBeforeEdit();
  
  if (saved) {
    showSuccessToast("Data saved before editing vitals");
  }
  
  // Then proceed with the original vitals modal logic
  setTempVitalsData(vitalsText);
  setEditingSection('vitals');
  setSectionBeingEdited('vitals');
  
  // ✅ Populate textarea with existing vitals when modal opens
  if (vitalsText) {
    setCombinedNotes(`Vitals: ${vitalsText}`);
    setTranscriptionText(vitalsText);
  }
  
  // Update placeholder to show we're in edit mode
  setNotesPlaceholder("Editing Vitals...");
  
  // Reset all form values first
  reset({
    "Body Temperature": "",
    "Pulse": "",
    "Respiratory Rate": "",
    "Systolic Blood Pressure": "",
    "Diastolic Blood Pressure": "",
    "Oxygen Saturation": "",
    "Fasting Blood Glucose": "",
    "Postprandial Blood Glucose": "",
  });
  
  setWeightValue("");
  setHeightValue("");
  setHeightSubValue("");
  
  if (vitalsText) {
    try {
      // Use debug function to see what's being parsed
      debugVitalsParsing(vitalsText);
      
      // Parse vitals from the displayed text
      const parsedVitals = parseVitalsFromDisplayText(vitalsText);
      
      // console.log("Parsed vitals for form:", parsedVitals);
      
      // Set form values based on parsed vitals
      parsedVitals.forEach(vital => {
        switch(vital.name) {
          case "Body Temperature":
            setValue("Body Temperature", vital.value);
            break;
          case "Pulse":
            setValue("Pulse", vital.value);
            break;
          case "Respiratory Rate":
            setValue("Respiratory Rate", vital.value);
            break;
          case "Systolic Blood Pressure":
            setValue("Systolic Blood Pressure", vital.value);
            break;
          case "Diastolic Blood Pressure":
            setValue("Diastolic Blood Pressure", vital.value);
            break;
          case "Oxygen Saturation":
            setValue("Oxygen Saturation", vital.value);
            break;
          case "Fasting Blood Glucose":
            setValue("Fasting Blood Glucose", vital.value);
            break;
          case "Postprandial Blood Glucose":
            setValue("Postprandial Blood Glucose", vital.value);
            break;
          case "Weight":
            setWeightValue(vital.value);
            setWeightUnit(vital.unit || "lbs");
            break;
          case "Height":
            if (vital.unit === "ft" || vital.unit === "ft." || vital.unit === "'") {
              const parts = vital.value.split('.');
              setHeightValue(parts[0] || "");
              setHeightSubValue(parts[1] || "");
              setHeightUnit("ft");
            } else {
              setHeightValue(vital.value);
              setHeightUnit("cm");
            }
            break;
        }
      });
    } catch (error) {
      console.error("Error parsing vitals:", error);
    }
  }
  
  setIsVitalsModalOpen(true);
};

// Update the saveAllNotesBeforeEdit function to properly handle vitals
const saveAllNotesBeforeEdit = async () => {
  try {
    // Check if we have unsaved AI suggestions or transcription
    const hasUnsavedAiSuggestions = aiSuggestions && (transcriptionText || combinedNotes.trim());
    const hasUnsavedVitals = aiSuggestions?.vitals && !savedVitals;
    
    if (hasUnsavedAiSuggestions || hasUnsavedVitals) {
      // console.log("Auto-saving all notes before editing...", { aiSuggestions, savedVitals });
      
      // Parse the current notes
      const parsedNotes = parseNotesIntoSections(combinedNotes);
      
      // Use AI suggestions as fallback for missing sections
      const notesToSave = {
        cc: parsedNotes.cc || aiSuggestions?.cc || "",
        hpi: parsedNotes.hpi || aiSuggestions?.hpi || "",
        vitals: aiSuggestions?.vitals || savedVitals || ""
      };
      
      // Check if we actually have data to save
      const hasDataToSave = notesToSave.cc || notesToSave.hpi || notesToSave.vitals;
      
      if (hasDataToSave) {
        // For vitals, we need to parse them from the text and prepare for API
        let vitalsArray = [];
        
        if (notesToSave.vitals) {
          // Parse vitals from the formatted text
          const parsedVitals = parseVitalsFromText(notesToSave.vitals);
          
          if (parsedVitals.length > 0) {
            const now = new Date();
            const padZero = (num) => num.toString().padStart(2, "0");
            const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())} ${padZero(now.getHours())}:${padZero(now.getMinutes())}:${padZero(now.getSeconds())}`;
            
            vitalsArray = parsedVitals.map(vital => ({
              vitalname: vital.name,
              vitalvalue: vital.value,
              vitalunit: vital.unit || getDefaultUnit(vital.name),
              vitaltype_cd: "",
              vitaladdeddate: formattedDate
            }));
          }
        }
        
        // If no vitals from text parsing, try to get from form
        if (vitalsArray.length === 0) {
          vitalsArray = await getCurrentVitalsForAPI();
        }
        
        const inputToSave = {
          input: {
            doctorid: doctorId,
            patientid: patientId,
            appointmentid: appointmentId,
            ...(notesToSave.cc && { chiefcomplaint: notesToSave.cc }),
            ...(notesToSave.hpi && {
              hpitext: {
                description: notesToSave.hpi,
                type: "other"
              }
            }),
            ...(vitalsArray.length > 0 && {
              vitals: vitalsArray
            }),
          },
        };
        
        // console.log("Auto-saving before edit:", inputToSave);
        
        // Only save if we have data
        const shouldSave = notesToSave.cc || notesToSave.hpi || vitalsArray.length > 0;
        
        if (shouldSave) {
          showLoader();
          const result = await updateDoctorNotes(inputToSave.input);
          dismissLoader();
          
          if (result) {
            // Update saved data state
            if (notesToSave.cc) setSavedCc(notesToSave.cc);
            if (notesToSave.hpi) setSavedHpi(notesToSave.hpi);
            
            // Format vitals for display
            const vitalsText = formatVitalsForDisplayFromArray(vitalsArray);
            if (vitalsText) setSavedVitals(vitalsText);
            
            // Keep AI suggestions with updated data
            const updatedSuggestions = {
              cc: notesToSave.cc || aiSuggestions?.cc || "",
              hpi: notesToSave.hpi || aiSuggestions?.hpi || "",
              vitals: vitalsText || aiSuggestions?.vitals || "",
            };
            setAiSuggestions(updatedSuggestions);
            
            // console.log("Auto-save successful");
            return true;
          }
        }
      }
    }
    return false;
  } catch (error) {
    console.error("Error in auto-save before edit:", error);
    dismissLoader();
    return false;
  }
};

// Helper function to get default unit for vitals
const getDefaultUnit = (vitalName) => {
  switch(vitalName) {
    case "Body Temperature": return "°F";
    case "Pulse": return "bpm";
    case "Respiratory Rate": return "b/min";
    case "Systolic Blood Pressure": return "mmHg";
    case "Diastolic Blood Pressure": return "mmHg";
    case "Oxygen Saturation": return "%";
    case "Fasting Blood Glucose": return "mg/dL";
    case "Postprandial Blood Glucose": return "mg/dL";
    case "Weight": return "lbs";
    case "Height": return "cm";
    default: return "";
  }
};

// Also update the handleCombinedNotesSubmit function to properly handle vitals
const handleCombinedNotesSubmit = async (e) => {
  e.preventDefault();
  
  if (!combinedNotes.trim()) {
    showErrorToast("Please enter some notes");
    return;
  }
  
  try {
    // Parse the notes into sections
    const parsedNotes = parseNotesIntoSections(combinedNotes);
    
    // For vitals, check multiple sources
    let vitalsArray = [];
    let vitalsText = "";
    
    // 1. First check if we have vitals in parsed notes
    if (parsedNotes.vitals) {
      vitalsText = parsedNotes.vitals;
    } 
    // 2. Then check AI suggestions
    else if (aiSuggestions?.vitals) {
      vitalsText = aiSuggestions.vitals;
    }
    // 3. Then check saved vitals
    else if (savedVitals) {
      vitalsText = savedVitals;
    }
    
    // Parse vitals from text if we have it
    if (vitalsText) {
      const parsedVitals = parseVitalsFromText(vitalsText);
      
      if (parsedVitals.length > 0) {
        const now = new Date();
        const padZero = (num) => num.toString().padStart(2, "0");
        const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())} ${padZero(now.getHours())}:${padZero(now.getMinutes())}:${padZero(now.getSeconds())}`;
        
        vitalsArray = parsedVitals.map(vital => ({
          vitalname: vital.name,
          vitalvalue: vital.value,
          vitalunit: vital.unit || getDefaultUnit(vital.name),
          vitaltype_cd: "",
          vitaladdeddate: formattedDate
        }));
      }
    }
    
    // If still no vitals, try to get from form
    if (vitalsArray.length === 0) {
      vitalsArray = await getCurrentVitalsForAPI();
      vitalsText = formatVitalsForDisplayFromArray(vitalsArray);
    }
    
    // Prepare input with separate fields for each section
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
      }
    };
    
    // Add chief complaint if it exists in parsed notes or AI suggestions
    if (parsedNotes.cc) {
      inputToSave.input.chiefcomplaint = parsedNotes.cc;
    } else if (aiSuggestions?.cc) {
      inputToSave.input.chiefcomplaint = aiSuggestions.cc;
    }
    
    // Add HPI if it exists
    if (parsedNotes.hpi) {
      inputToSave.input.hpitext = {
        description: parsedNotes.hpi,
        type: "other"
      };
    } else if (aiSuggestions?.hpi) {
      inputToSave.input.hpitext = {
        description: aiSuggestions.hpi,
        type: "other"
      };
    }
    
    // Add vitals if they exist
    if (vitalsArray.length > 0) {
      inputToSave.input.vitals = vitalsArray;
    }
    
    // console.log("Saving all notes:", inputToSave);
    
    showLoader();
    const result = await updateDoctorNotes(inputToSave.input);
    dismissLoader();
    
    if (result) {
      // Update saved data state
      setSavedCc(parsedNotes.cc || aiSuggestions?.cc || "");
      setSavedHpi(parsedNotes.hpi || aiSuggestions?.hpi || "");
      setSavedVitals(vitalsText);
      
      // Update AI suggestions with saved data
      const updatedSuggestions = {
        cc: parsedNotes.cc || aiSuggestions?.cc || "",
        hpi: parsedNotes.hpi || aiSuggestions?.hpi || "",
        vitals: vitalsText,
      };
      setAiSuggestions(updatedSuggestions);
      
      // ✅ Clear the textarea after successful save
      setCombinedNotes("");
      
      // Clear transcription but keep AI suggestions
      setTranscriptionText("");
      
      // Reset placeholder
      setNotesPlaceholder("Enter Chief Complaint, History of Present Illness, Vitals, Assessment, Plan, etc...");
      
      showSuccessToast("All notes saved successfully");
    }
    
  } catch (error) {
    console.error("Error saving notes:", error);
    dismissLoader();
    showErrorToast("Failed to save notes");
  }
};

// Update the saveAllNotesToBackend function as well
const saveAllNotesToBackend = async (notes) => {
  try {
    // Get vitals - check multiple sources
    let vitalsArray = [];
    let vitalsText = "";
    
    if (notes.vitals) {
      vitalsText = notes.vitals;
      const parsedVitals = parseVitalsFromText(vitalsText);
      
      if (parsedVitals.length > 0) {
        const now = new Date();
        const padZero = (num) => num.toString().padStart(2, "0");
        const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())} ${padZero(now.getHours())}:${padZero(now.getMinutes())}:${padZero(now.getSeconds())}`;
        
        vitalsArray = parsedVitals.map(vital => ({
          vitalname: vital.name,
          vitalvalue: vital.value,
          vitalunit: vital.unit || getDefaultUnit(vital.name),
          vitaltype_cd: "",
          vitaladdeddate: formattedDate
        }));
      }
    }
    
    // If still no vitals, try to get from form
    if (vitalsArray.length === 0) {
      vitalsArray = await getCurrentVitalsForAPI();
      vitalsText = formatVitalsForDisplayFromArray(vitalsArray);
    }
    
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        chiefcomplaint: notes.cc || "",
        ...(notes.hpi && {
          hpitext: {
            description: notes.hpi,
            type: "other"
          }
        }),
        ...(vitalsArray.length > 0 && {
          vitals: vitalsArray
        }),
      },
    };
    
    // console.log("Saving notes input:", inputToSave);
    
    showLoader();
    const result = await updateDoctorNotes(inputToSave.input);
    dismissLoader();
    
    // Update saved data state with new values
    setSavedCc(notes.cc || "");
    setSavedHpi(notes.hpi || "");
    
    // Format vitals for display
    if (vitalsText) setSavedVitals(vitalsText);
    
    // Keep AI suggestions with updated data
    const updatedSuggestions = {
      cc: notes.cc || "",
      hpi: notes.hpi || "",
      vitals: vitalsText || "",
    };
    setAiSuggestions(updatedSuggestions);
    
    // Keep the textarea populated with saved data
    const formattedText = formatAISuggestionsForTextarea(updatedSuggestions);
    setCombinedNotes(formattedText);
    
    // Clear transcription but keep AI suggestions
    setTranscriptionText("");
    
    showSuccessToast("Notes saved successfully");
    
    return result;
  } catch (error) {
    console.error("Error saving notes:", error);
    dismissLoader();
    throw error;
  }
};

// Also update the parseVitalsFromText function to handle more formats
const parseVitalsFromText = (vitalsText) => {
  // Ensure vitalsText is a string
  if (!vitalsText || typeof vitalsText !== 'string') {
    return [];
  }
  
  const vitals = [];
  const text = vitalsText.toLowerCase();
  
  // console.log("Parsing vitals text:", vitalsText);
  
  // Parse temperature
  const tempMatch = text.match(/(?:temp|temperature)[:\s]*(\d+(?:\.\d+)?)/);
  if (tempMatch) {
    vitals.push({
      name: "Body Temperature",
      value: tempMatch[1],
      unit: text.includes('c') ? '°C' : '°F'
    });
  }
  
  // Parse blood pressure - handle both 120/80 and 120x80 formats
  const bpMatch = text.match(/(?:bp|blood pressure)[:\s]*(\d+)[\sx\/]*(\d+)/);
  if (bpMatch) {
    vitals.push({
      name: "Systolic Blood Pressure",
      value: bpMatch[1],
      unit: "mmHg"
    });
    vitals.push({
      name: "Diastolic Blood Pressure",
      value: bpMatch[2],
      unit: "mmHg"
    });
  }
  
  // Parse heart rate
  const hrMatch = text.match(/(?:heart rate|hr|pulse)[:\s]*(\d+)/);
  if (hrMatch) {
    vitals.push({
      name: "Pulse",
      value: hrMatch[1],
      unit: "bpm"
    });
  }
  
  // Parse respiratory rate
  const rrMatch = text.match(/(?:respiratory rate|rr)[:\s]*(\d+)/);
  if (rrMatch) {
    vitals.push({
      name: "Respiratory Rate",
      value: rrMatch[1],
      unit: "b/min"
    });
  }
  
  // Parse SPO2
  const spo2Match = text.match(/(?:spo2|spO2|oxygen saturation)[:\s]*(\d+)/);
  if (spo2Match) {
    vitals.push({
      name: "Oxygen Saturation",
      value: spo2Match[1],
      unit: "%"
    });
  }
  
  // Parse fasting glucose
  const fGlucoseMatch = text.match(/(?:fasting glucose|f\.?\s*glucose)[:\s]*(\d+)/);
  if (fGlucoseMatch) {
    vitals.push({
      name: "Fasting Blood Glucose",
      value: fGlucoseMatch[1],
      unit: "mg/dL"
    });
  }
  
  // Parse postprandial glucose
  const pGlucoseMatch = text.match(/(?:postprandial glucose|p\.?\s*glucose)[:\s]*(\d+)/);
  if (pGlucoseMatch) {
    vitals.push({
      name: "Postprandial Blood Glucose",
      value: pGlucoseMatch[1],
      unit: "mg/dL"
    });
  }
  
  // console.log("Parsed vitals from text:", vitals);
  return vitals;
};
    
  // ------------------------------------ Single Record Functionality end ---------------------

  // __________________________________QUICK VISIT FUNCTIONALITY START_____________________________

// ------------------------------- CC start -----------------------------------------------
const { transcriber: activeTranscriber, mode } =
  useHybridTranscriber("speech", (text) => {
    setPlaceholder(text || "");
    setTyping(false);
  });

const [typing, setTyping] = useState(false);
const [placeholder, setPlaceholder] = useState("Click anywhere to start typing....");

//------------------other functionality - CHIEF COMPLAINT
const { register: registerChiefComplaint, handleSubmit: handleChiefComplaintSubmit, watch: watchChiefComplaint, setValue: setChiefComplaintValue } = useForm();
const textFieldValue = watchChiefComplaint("textField", "");
const [isButtonDisabled, setIsButtonDisabled] = useState(false);
const [initialText, setInitialText] = useState("");
const advanceCheifComplaints = useRef();

const onSubmit = (data) => {
  setIsButtonDisabled(true); // Disable button on submit
  UpdateChiefComplaint(data);
  fetchDoctorNotesEmptyIndication();
};

useEffect(() => {
  if (activeTranscriber?.output?.text) {
    setChiefComplaintValue("textField", activeTranscriber.output.text);
    setPlaceholder("Click anywhere to start typing....");
    setTyping(false);
  }
}, [activeTranscriber?.output?.text, setChiefComplaintValue]);

// Add these state variables
const [savedCc, setSavedCc] = useState("");
const [savedHpi, setSavedHpi] = useState("");
const [savedVitals, setSavedVitals] = useState("");
const [isDataLoaded, setIsDataLoaded] = useState(false);
const fetchAllDoctorNotesData = async () => {
  const inputToFetch = {
    input: {
      patientid: patientId,
      doctorid: doctorId,
      appointmentid: appointmentId,
    },
  };

  showLoader();
  try {
    const data = await GetDoctorNotes(inputToFetch.input);
    
    // Extract and store saved data for AI Suggestions section
    const savedCc = data?.output?.data?.chiefcomplaint?.chiefcomplaint || "";
    const savedHpi = data?.output?.data?.hpitext?.description || "";
    
    // Format vitals from API response
    const vitalsData = data?.output?.data?.vitals || [];
    const formattedVitals = formatVitalsFromAPIResponse(vitalsData);
    
    // Store saved data
    setSavedCc(savedCc);
    setSavedHpi(savedHpi);
    setSavedVitals(formattedVitals);
    
    // Set AI suggestions with saved data
    if (savedCc || savedHpi || formattedVitals) {
      const suggestions = {
        cc: savedCc,
        hpi: savedHpi,
        vitals: formattedVitals,
      };
      setAiSuggestions(suggestions);
      
      // DO NOT populate combined notes here - only AI Suggestions box shows saved data
      // Combined notes textarea should remain empty until user starts recording or clicks edit
      // This prevents textarea repopulation after save and refresh
    }
    
    setIsDataLoaded(true);
    
    // Rest of your existing code...
    // Set Chief Complaint data
    setInitialText(savedCc);
    setChiefComplaintValue("textField", savedCc);
    
    // Set Diagnosis data
    if (!isSaving) {
      setDoctorNotes(data?.output?.data);
      const doctorsassessment = data?.output?.data?.doctorsassessment || [];
      
      // console.log("Fetched doctorsassessment:", doctorsassessment);
      
      const diagnosisTagsFromAPI = doctorsassessment
        .map(assessment => ({
          id: assessment.id,
          diagnosis: assessment.diagnosis
        }))
        .filter(item => item.diagnosis && item.diagnosis.trim() !== "");
      
      setDiagnosisTags(diagnosisTagsFromAPI);
    }
    
    setSelectedButton(data?.output?.data?.patientdiagnosis);
    setSelectedButtonInitial(data?.output?.data?.patientdiagnosis);

    // Set Vitals data - Using the working logic from fetchDoctorNotes
    const formValues = {};
    
    vitalsData.forEach((vital) => {
      let vitalName = vital.vitalname;

      if (vitalName === "Body temperature") {
        vitalName = "Body Temperature";
      } else if (vitalName === "Respiratory rate") {
        vitalName = "Respiratory Rate";
      }
      
      formValues[vitalName] = vital.vitalvalue;
    });

    // Handle temperature unit
    const temperatureUnit =
      vitalsData.find(
        (vital) =>
          vital.vitalname === "Body temperature" ||
          vital.vitalname === "Body Temperature"
      )?.vitalunit || "°F";
    formValues["temperatureUnit"] = temperatureUnit;

    // Handle Weight and Height separately for the state variables
    const weightVital = vitalsData.find(vital => vital.vitalname === "Weight");
    const heightVital = vitalsData.find(vital => vital.vitalname === "Height");

    if (weightVital) {
      setWeightValue(weightVital.vitalvalue || "");
      if (weightVital.vitalunit === "kg") {
        setWeightUnit("kg");
      } else {
        setWeightUnit("lbs");
      }
    }

    if (heightVital) {
      const heightValue = heightVital.vitalvalue || "";
      if (heightVital.vitalunit === "cm") {
        setHeightUnit("cm");
        setHeightValue(heightValue);
        setHeightSubValue("");
      } else {
        setHeightUnit("ft");
        if (heightValue.includes('.')) {
          const [feet, inches] = heightValue.split('.');
          setHeightValue(feet || "");
          setHeightSubValue(inches || "");
        } else {
          setHeightValue(heightValue);
          setHeightSubValue("");
        }
      }
    }

    // Reset form with fetched values
    reset(formValues);

    // console.log("Fetched form values: ", formValues);

  } catch (error) {
    console.error("Error fetching Doctor Notes data:", error);
  } finally {
    dismissLoader();
  }
};
// Function to format vitals from API response for display
const formatVitalsFromAPIResponse = (vitalsArray) => {
  if (!vitalsArray || !Array.isArray(vitalsArray) || vitalsArray.length === 0) {
    return "";
  }
  
  // Get latest vitals (most recent by date)
  const sortedVitals = [...vitalsArray].sort((a, b) => {
    return new Date(b.vitaladdeddate) - new Date(a.vitaladdeddate);
  });
  
  // Group by date to get complete sets
  const vitalsByDate = {};
  sortedVitals.forEach(vital => {
    if (vital.vitaladdeddate) {
      const dateKey = new Date(vital.vitaladdeddate).toISOString().split('T')[0];
      if (!vitalsByDate[dateKey]) {
        vitalsByDate[dateKey] = [];
      }
      vitalsByDate[dateKey].push(vital);
    }
  });
  
  // Get latest date
  const latestDate = Object.keys(vitalsByDate).sort().pop();
  const latestVitals = latestDate ? vitalsByDate[latestDate] : sortedVitals.slice(0, 10);
  
  // Format vitals for display
  const vitalsMap = {};
  
  latestVitals.forEach(vital => {
    if (vital.vitalname && vital.vitalvalue) {
      const displayName = getVitalDisplayNameForAPI(vital.vitalname);
      if (displayName) {
        if (displayName === "BP") {
          if (vital.vitalname === "Systolic Blood Pressure") {
            if (!vitalsMap["BP"]) vitalsMap["BP"] = {};
            vitalsMap["BP"].systolic = vital.vitalvalue;
          } else if (vital.vitalname === "Diastolic Blood Pressure") {
            if (!vitalsMap["BP"]) vitalsMap["BP"] = {};
            vitalsMap["BP"].diastolic = vital.vitalvalue;
          }
        } else {
          vitalsMap[displayName] = {
            value: vital.vitalvalue,
            unit: vital.vitalunit || ""
          };
        }
      }
    }
  });
  
  // Build formatted string
  const vitalsParts = [];
  
  if (vitalsMap["Temp"]) {
    vitalsParts.push(`Temp: ${vitalsMap["Temp"].value}${vitalsMap["Temp"].unit}`);
  }
  
  if (vitalsMap["Pulse"]) {
    vitalsParts.push(`Pulse: ${vitalsMap["Pulse"].value} ${vitalsMap["Pulse"].unit}`);
  }
  
  if (vitalsMap["BP"]?.systolic && vitalsMap["BP"]?.diastolic) {
    vitalsParts.push(`BP: ${vitalsMap["BP"].systolic}/${vitalsMap["BP"].diastolic} mmHg`);
  }
  
  if (vitalsMap["RR"]) {
    vitalsParts.push(`RR: ${vitalsMap["RR"].value} ${vitalsMap["RR"].unit}`);
  }
  
  if (vitalsMap["SPO2"]) {
    vitalsParts.push(`SPO2: ${vitalsMap["SPO2"].value}${vitalsMap["SPO2"].unit}`);
  }
  
  if (vitalsMap["F. Glucose"]) {
    vitalsParts.push(`F. Glucose: ${vitalsMap["F. Glucose"].value} ${vitalsMap["F. Glucose"].unit}`);
  }
  
  if (vitalsMap["P. Glucose"]) {
    vitalsParts.push(`P. Glucose: ${vitalsMap["P. Glucose"].value} ${vitalsMap["P. Glucose"].unit}`);
  }
  
  return vitalsParts.join(", ");
};

// Helper function for API vitals display names
const getVitalDisplayNameForAPI = (vitalName) => {
  const nameMap = {
    "Body Temperature": "Temp",
    "Body temperature": "Temp",
    "Pulse": "Pulse",
    "Heart Rate": "Pulse",
    "Respiratory Rate": "RR",
    "Respiratory rate": "RR",
    "Oxygen Saturation": "SPO2",
    "Fasting Blood Glucose": "F. Glucose",
    "Postprandial Blood Glucose": "P. Glucose",
    "Systolic Blood Pressure": "BP",
    "Diastolic Blood Pressure": "BP"
  };
  
  return nameMap[vitalName];
};
// Combined function to fetch all data
// const fetchAllDoctorNotesData = async () => {
//   const inputToFetch = {
//     input: {
//       patientid: patientId,
//       doctorid: doctorId,
//       appointmentid: appointmentId,
//     },
//   };

//   showLoader();
//   try {
//     const data = await GetDoctorNotes(inputToFetch.input);
    
//     // Set Chief Complaint data
//     const chiefComplaint = data?.output?.data?.chiefcomplaint?.chiefcomplaint || "";
//     setInitialText(chiefComplaint);
//     setChiefComplaintValue("textField", chiefComplaint);
    
//     // Set Diagnosis data
//     // setDoctorNotes(data?.output?.data);
//     // const doctorsassessment = data?.output?.data?.doctorsassessment || [];
    
//     // if (doctorsassessment.length === 0) {
//     //   doctorsassessment.push({
//     //     diagnosisid: 0,
//     //     diagnosis: "",
//     //     plan: "",
//     //     isSavedId: null,
//     //   });
//     // }

//     // setPanelsToExpand(doctorsassessment);
//     // setSelectedButton(data?.output?.data?.patientdiagnosis);
//     // setSelectedButtonInitial(data?.output?.data?.patientdiagnosis);
    
//     // setFormInputs(
//     //   doctorsassessment.map((assessment) => ({
//     //     ...assessment,
//     //     isSavedId: assessment.id || null,
//     //   }))
//     // );
//     // setFormInputsInitial(
//     //   doctorsassessment.map((assessment) => ({
//     //     ...assessment,
//     //     isSavedId: assessment.id || null,
//     //   }))
//     // );

//     // diagnosisReset({
//     //   doctorsassessment: doctorsassessment.map((assessment) => ({
//     //     diagnosis: assessment.diagnosis || "",
//     //     plan: assessment.plan || "",
//     //   })),
//     // });
//     // Set Diagnosis data - Updated to include IDs
//     if (!isSaving) {
//       setDoctorNotes(data?.output?.data);
//       const doctorsassessment = data?.output?.data?.doctorsassessment || [];
      
//       console.log("Fetched doctorsassessment:", doctorsassessment);
      
//       // Convert API data to tag format with IDs
//       const diagnosisTagsFromAPI = doctorsassessment
//         .map(assessment => ({
//           id: assessment.id, // Keep the actual ID from API
//           diagnosis: assessment.diagnosis
//         }))
//         .filter(item => item.diagnosis && item.diagnosis.trim() !== "");
      
//       setDiagnosisTags(diagnosisTagsFromAPI);
//     }
    
//     setSelectedButton(data?.output?.data?.patientdiagnosis);
//     setSelectedButtonInitial(data?.output?.data?.patientdiagnosis);

//     // Set Vitals data - Using the working logic from fetchDoctorNotes
//     const vitalsData = data?.output?.data?.vitals || [];
//     const formValues = {};
    
//     vitalsData.forEach((vital) => {
//       let vitalName = vital.vitalname;

//       // Check and adjust vital names if needed (this was missing!)
//       if (vitalName === "Body temperature") {
//         vitalName = "Body Temperature";
//       } else if (vitalName === "Respiratory rate") {
//         vitalName = "Respiratory Rate";
//       }
      
//       formValues[vitalName] = vital.vitalvalue;
//     });

//     // Handle temperature unit
//     const temperatureUnit =
//       vitalsData.find(
//         (vital) =>
//           vital.vitalname === "Body temperature" ||
//           vital.vitalname === "Body Temperature"
//       )?.vitalunit || "°F";
//     formValues["temperatureUnit"] = temperatureUnit;

//     // Handle Weight and Height separately for the state variables
//     const weightVital = vitalsData.find(vital => vital.vitalname === "Weight");
//     const heightVital = vitalsData.find(vital => vital.vitalname === "Height");

//     if (weightVital) {
//       setWeightValue(weightVital.vitalvalue || "");
//       // Set weight unit based on the vitalunit from API - store actual unit strings
//       if (weightVital.vitalunit === "kg") {
//         setWeightUnit("kg");
//       } else {
//         setWeightUnit("lbs"); // Default to lbs
//       }
//     }

//     if (heightVital) {
//       const heightValue = heightVital.vitalvalue || "";
//       // Set height unit based on the vitalunit from API - store actual unit strings
//       if (heightVital.vitalunit === "cm") {
//         setHeightUnit("cm");
//         setHeightValue(heightValue);
//         setHeightSubValue("");
//       } else {
//         setHeightUnit("ft"); // Default to ft
//         // Parse ft.in format
//         if (heightValue.includes('.')) {
//           const [feet, inches] = heightValue.split('.');
//           setHeightValue(feet || "");
//           setHeightSubValue(inches || "");
//         } else {
//           setHeightValue(heightValue);
//           setHeightSubValue("");
//         }
//       }
//     }

//     // Reset form with fetched values
//     reset(formValues);

//     console.log("Fetched form values: ", formValues);
//     console.log("Weight data:", { value: weightVital?.vitalvalue, unit: weightVital?.vitalunit });
//     console.log("Height data:", { value: heightVital?.vitalvalue, unit: heightVital?.vitalunit });


//   } catch (error) {
//     console.error("Error fetching Doctor Notes data:", error);
//   } finally {
//     dismissLoader();
//   }
// };

// Keep the old function for backward compatibility
const fetchDoctorNotes = async () => {
  await fetchAllDoctorNotesData();
};

const UpdateChiefComplaint = async (data) => {
  const inputToSave = {
    input: {
      doctorid: doctorId,
      patientid: patientId,
      appointmentid: appointmentId,
      chiefcomplaint: data.textField,
    },
  };

  showLoader();
  try {
    const result = await updateDoctorNotes(inputToSave.input);
    if (result) {
      showSuccessToast("Chief Complaint Saved successfully");
    }
  } catch (error) {
    console.error("Error in Update Doctor Notes:", error);
    showErrorToast("Error Happened While Saving.");
  } finally {
    dismissLoader();
  }
};

const correctChiefComplaint = async (cc_text) => {
  const inputToSave = {
    input: {
      text: cc_text,
    },
  };

  showLoader();
  try {
    const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
    if (result) {
      showSuccessToast("Updated Chief Complaint");
      setChiefComplaintValue("textField", result?.text);
    }
  } catch (error) {
    console.error("Error in Correct cc ai call:", error);
    showErrorToast("Error Happened While Correcting.");
  } finally {
    dismissLoader();
  }
};

const onSubmitChiefComplaint = (data) => {
  setIsButtonDisabled(true);
  UpdateChiefComplaint(data);
  fetchDoctorNotesEmptyIndication();
};

// submit on tab switch and submit button is enabled
// useEffect(() => {
//   if (!isButtonDisabled) {
//     handleChiefComplaintSubmit(onSubmitChiefComplaint)();
//   }
// }, [isButtonDisabled]);
// }, [isButtonDisabled, handleChiefComplaintSubmit]);

useEffect(() => {
  fetchAllDoctorNotesData(); // Use the combined function
}, []);

useEffect(() => {
  if (textFieldValue !== initialText) {
    setIsButtonDisabled(false);
  } else {
    setIsButtonDisabled(true);
  }
}, [textFieldValue, initialText]);

// ---------------------------- CC end -----------------------------------------------

// ---------------------------- Diagnosis start ------------------------------------------
const [doctorNotes, setDoctorNotes] = useState({});
const [selectedButton, setSelectedButton] = useState("");
const [selectedButtonInitial, setSelectedButtonInitial] = useState("");
const [SelectedDiagnosisLanguage, setSelectedDiagnosisLanguage] = useState("en-US");

// Diagnosis state - now including IDs from API
const [diagnosisTags, setDiagnosisTags] = useState([]); // Format: [{id: 3882, diagnosis: "kidney"}, {id: null, diagnosis: "new diagnosis"}]
const [diagnosisInput, setDiagnosisInput] = useState("");
const [isSaving, setIsSaving] = useState(false);

// Add active input state for voice recording
const [activeInputIndex, setActiveInputIndex] = useState(0); // 0 for main input, 1+ for tags if needed

const handleButtonClick = (buttonName) => {
  setSelectedButton(buttonName);
};

const onDiagnosisSubmit = async () => {
  if (isSaving) return;

  // If there's text in the input but user hasn't pressed Enter, add it first
  let finalDiagnosisTags = [...diagnosisTags];
  if (diagnosisInput.trim()) {
    finalDiagnosisTags = [...diagnosisTags, { id: null, diagnosis: diagnosisInput.trim() }];
    setDiagnosisTags(finalDiagnosisTags);
    setDiagnosisInput('');
  }

  if (finalDiagnosisTags.length === 0 && !selectedButton) {
    showErrorToast("Please enter some data");
    return;
  }

  const inputToSave = {
    input: {
      doctorid: doctorId,
      patientid: patientId,
      appointmentid: appointmentId,
      patientdiagnosis: selectedButton,
      doctorsassessment: finalDiagnosisTags.map((item) => ({
        diagnosis: item.diagnosis,
        plan: "", // Empty plan as per requirement
        diagnosisid: item.id, // Send actual ID for existing, null for new
      })),
    },
  };
  
  showLoader();
  try {
    // console.log("input send", inputToSave.input);
    const result = await updateDoctorNotes(inputToSave.input);
    if (result) {
      showSuccessToast("Diagnosis Saved successfully");
      fetchDoctorNotesEmptyIndication();
      await fetchAllDoctorNotesData();
    }
  } catch (error) {
    console.error("Error in Update Doctor Notes:", error);
    showErrorToast("Error Happened While Saving.");
  } finally {
    dismissLoader();
    setIsSaving(false);
  }
};

const [searchText, setSearchText] = useState("");
const [suggestions, setSuggestions] = useState([]);
const [isMenuOpen, setIsMenuOpen] = useState(false);
const inputRef = useRef(null);
const wrapperRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

// Handle adding diagnosis tags
const handleDiagnosisKeyDown = (event) => {
  if (event.key === 'Enter' && diagnosisInput.trim()) {
    event.preventDefault();
    const newTags = [...diagnosisTags, { id: null, diagnosis: diagnosisInput.trim() }];
    setDiagnosisTags(newTags);
    setDiagnosisInput('');
  }
};

// const removeDiagnosisTag = (index) => {
//   const newTags = diagnosisTags.filter((_, i) => i !== index);
//   setDiagnosisTags(newTags);
// };

const removeDiagnosisTag = async (index) => {
  const tagToRemove = diagnosisTags[index];
  const newTags = diagnosisTags.filter((_, i) => i !== index);
  setDiagnosisTags(newTags);
  
  // If this was the last tag, update the server with empty array
  if (diagnosisTags.length === 1) {
    setIsSaving(true);
    try {
      const inputToSave = {
        input: {
          doctorid: doctorId,
          patientid: patientId,
          appointmentid: appointmentId,
          patientdiagnosis: selectedButton,
          doctorsassessment: [], // Empty array to clear all diagnoses
        },
      };
      
      await updateDoctorNotes(inputToSave.input);
      showSuccessToast("Diagnosis removed successfully");
      await fetchAllDoctorNotesData();
    } catch (error) {
      console.error("Error updating empty diagnosis:", error);
      showErrorToast("Error removing diagnosis");
      // Revert local state if server update fails
      setDiagnosisTags(diagnosisTags);
    } finally {
      setIsSaving(false);
    }
  } else if (tagToRemove.id) {
    // If it's an existing diagnosis with an ID, delete it from server
    await deleteSelectedTreatmentPlan(tagToRemove.id);
  }
};

// Handle voice recording for diagnosis input - UPDATED
const handleDiagnosisTranscript = (transcript) => {
  // console.log("Voice transcript received:", transcript, "for active input:", activeInputIndex);
  
  if (activeInputIndex === 0) {
    // Main input field
    setDiagnosisInput(transcript);
  } else {
    // For tag editing (if implemented later)
    const tagIndex = activeInputIndex - 1;
    if (diagnosisTags[tagIndex]) {
      const updatedTags = [...diagnosisTags];
      updatedTags[tagIndex] = {
        ...updatedTags[tagIndex],
        diagnosis: transcript
      };
      setDiagnosisTags(updatedTags);
    }
  }
};

const [initialLoad, setInitialLoad] = useState(true);

const deleteSelectedTreatmentPlan = async (id) => {
  const inputForDelete = {
    input: {
      patientid: patientId,
      id: id,
      type: "treatmentplan",
    },
  };
  showLoader();
  try {
    const result = await DeleteOrder(inputForDelete.input);
    if (result.output.message === "Successfully Deleted") {
      showSuccessToast("Diagnosis has been deleted");
      fetchDoctorNotesEmptyIndication();
      setDiagnosisTags(prev => prev.filter(item => item.id !== id));
      setInitialLoad(true);
      
      // After deleting, we need to update the server to reflect the empty state
      // if (diagnosisTags.length === 1) { // If this was the last tag
      //   const inputToSave = {
      //     input: {
      //       doctorid: doctorId,
      //       patientid: patientId,
      //       appointmentid: appointmentId,
      //       patientdiagnosis: selectedButton,
      //       doctorsassessment: [], // Empty array to clear all diagnoses
      //     },
      //   };
        
      //   try {
      //     await updateDoctorNotes(inputToSave.input);
      //     await fetchAllDoctorNotesData();
      //   } catch (error) {
      //     console.error("Error updating empty diagnosis:", error);
      //   }
      // } else {
      //   fetchAllDoctorNotesData();
      // }
      await fetchAllDoctorNotesData();
    } else {
      showErrorToast("Something went wrong!");
    }
  } catch (error) {
    console.error("Error in delete order:", error);
  } finally {
    dismissLoader();
  }
};

const css = `
  .chakra-collapse {
    overflow: visible!important;
  }
`;

// Make sure this effect properly routes the diagnosis transcription:
const { transcriber: diagnosisTranscriber, mode: diagnosisMode } =
  useHybridTranscriber("speech", (text) => {
    setPlaceholder(text || "");
    setTyping(false);
  }, SelectedDiagnosisLanguage);

useEffect(() => {
  if (diagnosisTranscriber?.output?.text && activeInputIndex === 0) {
    const text = diagnosisTranscriber.output.text;
    setDiagnosisInput(text); // Update diagnosis input directly
    setPlaceholder(""); // Clear placeholder
    setTyping(false);
  }
}, [diagnosisTranscriber?.output?.text, activeInputIndex]);

const correctOrders = async (text) => {
  if (!text) {
    showErrorToast("No text available to correct");
    return;
  }
  const inputToSave = { input: { text, type: 'Doctor Assessment' } };
  showLoader();
  try {
    const result = await CorrectMedicalTermsUsingAI(inputToSave);
    if (result && result.text) {
      showSuccessToast("Updated Text");
      return result.text;
    }
  } catch (error) {
    showErrorToast("Error in Correct AI call.");
  } finally {
    dismissLoader();
  }
};

const handleClutterCorrection = async () => {
  if (diagnosisInput) {
    const correctedDiagnosis = await correctOrders(diagnosisInput);
    if (correctedDiagnosis) {
      setDiagnosisInput(correctedDiagnosis);
    }
  }
};

// Add diagnosis manually (for button click)
const addDiagnosis = () => {
  if (diagnosisInput.trim()) {
    const newTags = [...diagnosisTags, { id: null, diagnosis: diagnosisInput.trim() }];
    setDiagnosisTags(newTags);
    setDiagnosisInput('');
  }
};

// Function to edit existing tag
const editDiagnosisTag = (index, newDiagnosis) => {
  const updatedTags = [...diagnosisTags];
  updatedTags[index] = {
    ...updatedTags[index],
    diagnosis: newDiagnosis
  };
  setDiagnosisTags(updatedTags);
};
// ---------------------------- Diagnosis end ------------------------------------------

// ----------------------- Vitals start -----------------------------------
const {
  control: vitalsControl,
  register: vitalsRegister,
  handleSubmit,
  setValue,
  reset,
  formState: { isDirty, errors },
} = useForm();
const [isVitalsButtonDisabled, setIsVitalsButtonDisabled] = useState(true);

const temperatureUnit = useWatch({ control: vitalsControl, name: "temperatureUnit" });

// Use actual unit strings by default so UI shows correct units (lbs / ft)
const [weightUnit, setWeightUnit] = useState('lbs'); // actual unit string: 'lbs' or 'kg'
const [heightUnit, setHeightUnit] = useState('ft'); // actual unit string: 'ft' or 'cm'
const [weightValue, setWeightValue] = useState("");
const [heightValue, setHeightValue] = useState("");
const [heightSubValue, setHeightSubValue] = useState("");

function formatHeightNumber(input) {
  const parts = input.toString().split(".");
  return {
    height: parts[0], // Whole number (integer part)
    subHeight: parts[1] || "", // Decimal part (no padding)
  };
}

const handleUnitChange = (newUnit) => {
  // newUnit is either "Standard" or "Metric" from the Select
  const toStandard = newUnit === "Standard"; // Standard => lbs / ft

  // Convert weight based on actual current unit strings ('lbs' or 'kg')
  if (weightValue) {
    const numValue = parseFloat(weightValue);
    if (!isNaN(numValue)) {
      if (toStandard && weightUnit === "kg") {
        // kg -> lbs
        setWeightValue((numValue * 2.20462).toFixed(2));
      } else if (!toStandard && weightUnit === "lbs") {
        // lbs -> kg
        setWeightValue((numValue / 2.20462).toFixed(2));
      }
    }
  }

  // Convert height based on actual current unit strings ('ft' or 'cm')
  if (heightValue) {
    if (toStandard && heightUnit === "cm") {
      // cm -> ft + in
      const totalInches = parseFloat(heightValue) / 2.54;
      const feet = Math.floor(totalInches / 12);
      const inches = Math.round(totalInches % 12);
      setHeightValue(feet.toString());
      setHeightSubValue(inches.toString());
    } else if (!toStandard && heightUnit === "ft") {
      // ft + in -> cm
      const feet = parseFloat(heightValue) || 0;
      const inches = parseFloat(heightSubValue) || 0;
      const totalInches = (feet * 12) + inches;
      setHeightValue((totalInches * 2.54).toFixed(2));
      setHeightSubValue('');
    }
  }

  // Update units to actual unit strings
  setWeightUnit(toStandard ? "lbs" : "kg");
  setHeightUnit(toStandard ? "ft" : "cm");
};

const onVitalsSubmit = async (data) => {
  const vitals = [];

  const fields = [
    { name: "Systolic Blood Pressure", unit: "mmHg" },
    { name: "Diastolic Blood Pressure", unit: "mmHg" },
    { name: "Pulse", unit: "bpm" },
    { name: "Body Temperature", unit: data.temperatureUnit },
    { name: "Respiratory Rate", unit: "bpm" },
    { name: "Oxygen Saturation", unit: "%" },
    { name: "Fasting Blood Glucose", unit: "mg/dL" },
    { name: "Postprandial Blood Glucose", unit: "mg/dL" },
  ];

  fields.forEach((field) => {
    const value = data[field.name];
    const padZero = (num) => num.toString().padStart(2, "0");

    const now = new Date();
    const formattedDate = `${now.getFullYear()}-${padZero(
      now.getMonth() + 1
    )}-${padZero(now.getDate())} ${padZero(now.getHours())}:${padZero(
      now.getMinutes()
    )}:${padZero(now.getSeconds())}`;

    if (value !== undefined && value !== "") {
      vitals.push({
        vitalname: field.name,
        vitalvalue: value,
        vitalunit: field.unit,
        vitaltype_cd: "",
        vitaladdeddate: formattedDate,
      });
    }
  });

  const inputToSave = {
    input: {
      doctorid: doctorId,
      patientid: patientId,
      appointmentid: appointmentId,
      vitals: vitals,
    },
  };
  // console.log(inputToSave);
  showLoader();
  try {
    if (inputToSave.input.vitals && inputToSave.input.vitals.length > 0) {
      const result = await updateDoctorNotes(inputToSave.input);
      if (result) {
        showSuccessToast("Vitals saved successfully");
        fetchDoctorNotesEmptyIndication();
        setIsVitalsButtonDisabled(true); // Disable button after successful submission
        fetchAllDoctorNotesData(); // Refresh data after saving
      }
    }
  } catch (error) {
    console.error("Error in saving vitals:", error);
    showErrorToast("Error happened while saving vitals.");
  } finally {
    dismissLoader();
  }
};

const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
const [time, setTime] = useState(moment().format("HH:mm"));

// submit on tab switch and submit button is enabled
// useEffect(()=>{
//   if(!isVitalsButtonDisabled){
//     handleSubmit(onVitalsSubmit)();
//   }
// },[isVitalsButtonDisabled, handleSubmit, onVitalsSubmit])

const SubmitBMIform = async () => {
  // Validate inputs
  if (heightUnit === "ft" && heightValue && !heightSubValue) {
    showErrorToast("Please enter inches value");
    return;
  }

  let Weightinput = {
    patientid: patientId,
    appointment_id: appointmentId,
    vitals: [
      {
        vitalname: "Weight",
        vitalvalue: weightValue,
        vitalunit: weightUnit,
        vitaltype_cd: "",
        vitaladdeddate: `${date} ${time}`,
      },
    ],
  };
  let Heightinput = {
    patientid: patientId,
    appointment_id: appointmentId,
    vitals: [
      {
        vitalname: "Height",
        vitalvalue: heightUnit === "ft" 
        ? `${heightValue}.${heightSubValue || '0'}` 
        : heightValue,
        vitalunit: heightUnit,
        vitaltype_cd: "238",
        vitaladdeddate: `${date} ${time}`,
      },
    ],
  };
  if (moment(date, "DD-MM-YYYY", true).isValid()) {
    const formatteddate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    const vitaldate = formatteddate + " " + time;
    Weightinput.vitals[0].vitaladdeddate = vitaldate;
    Heightinput.vitals[0].vitaladdeddate = vitaldate;
  }
  try {
    if (weightValue) {
      // console.log("updating weight");
      const response = await AddVitalData(Weightinput);
    }
    if (heightValue) {
      // console.log("updating height");
      const result = await AddVitalData(Heightinput);
    }
    if (weightValue || heightValue) {
      // console.log("Refreshing patient data");
      fetchPatientHealthData();
      fetchAllDoctorNotesData(); // Refresh all data
    }
  } catch (error) {
    console.error("Error in SubmitFunction:", error);
  }
};
// ------------------------------- Vitals end -----------------------------------------------
// ------------------------------- Medicines start -------------------------------------
// Favorites section states
const [activeFavoriteTab, setActiveFavoriteTab] = useState('medicines');
const [medicineList, setMedicineList] = useState([]);
    // const [suggestions, setSuggestions] = useState([]);
    const [showMedicineNamesDropdown, setShowMedicineNamesDropdown] =
      useState(-1);
    const [boolValForSuggestions, setBoolValForSuggestions] = useState(true);
    const [focusedItemIndex, setFocusedItemIndex] = useState(-1);
    const suggestionsMenuRef = useRef(null);

    const [QuantityInStrip, setQuantityInStrip] = useState(0);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
      const [isSelectedEditModalOpen, setIsSelectedEditModalOpen] = useState(false);
      const [isCurrentEditModalOpen, setIsCurrentEditModalOpen] = useState(false);

    const handleSelect = (suggestion, index) => {
      // handleNewMedicineChange(
      //   "medicinename",
      //   suggestion.productname + " (" + suggestion.remainingquantity + " Qty)"
      // );
      handleNewMedicineChange("medicinename", suggestion.productname);
      handleNewMedicineChange("composition", suggestion.chemicalcomposition);
      handleNewMedicineChange("inventoryid", suggestion.inventoryid);
      // console.log(suggestion);

      setSuggestions([]);
      setBoolValForSuggestions(!boolValForSuggestions);
      setShowMedicineNamesDropdown(-1);
    };

    const handleEditSelect = (suggestion, index) => {
      // handleEditMedicineChange(
      //   "medicinename",
      //   suggestion.productname + " (" + suggestion.remainingquantity + " Qty)"
      // );
      handleEditMedicineChange("medicinename", suggestion.productname);
      handleEditMedicineChange("inventoryid", suggestion.inventoryid);
      setSuggestions([]);
      setBoolValForSuggestions(!boolValForSuggestions);
      setShowMedicineNamesDropdown(-1);
    };

    const handleKeyDown = (e, index) => {
      if (e.key === "ArrowDown") {
        setFocusedItemIndex(
          (prevIndex) => (prevIndex + 1) % suggestions.length
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "ArrowUp") {
        setFocusedItemIndex((prevIndex) =>
          prevIndex === 0 ? suggestions.length - 1 : prevIndex - 1
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "Enter" && focusedItemIndex !== -1) {
        const selectedItem = suggestions[focusedItemIndex];
        handleSelect(selectedItem, index);
      }
    };

    const handleEditKeyDown = (e, index) => {
      if (e.key === "ArrowDown") {
        setFocusedItemIndex(
          (prevIndex) => (prevIndex + 1) % suggestions.length
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "ArrowUp") {
        setFocusedItemIndex((prevIndex) =>
          prevIndex === 0 ? suggestions.length - 1 : prevIndex - 1
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "Enter" && focusedItemIndex !== -1) {
        const selectedItem = suggestions[focusedItemIndex];
        handleEditSelect(selectedItem, index);
      }
    };

    //-------------AI Insights
    const chatContainerRef = useRef(null);
    const [remainingquestions, setRemainingQuestions] = useState([]);
    const [aiquestion, setAIAnalysis] = useState(null);
    const [AiInput, setAiInput] = useState(null);
    const [initialRender, setInitialRender] = useState(true);
    const [showAIModal, setShowAIModal] = useState(true);

    //------------------alternative medicine
    const aiRecommendMedicineRef = useRef();

    const [recommendMedicinesAiResponse, setRecommendMedicinesAiResponse] =
      useState([]);

    const [
      selectedRecommendedMedicinesAiResponses,
      setSelectedRecommendedMedicinesAiResponses,
    ] = useState([]);

    const [drugInteractionAlerts, setDrugInteractionAlerts] = useState([]);

    const { showAlertToast } = QuickViewAlertToaster();

    //--------------------other functionality

    const [selectedTab, setSelectedTab] = useState("recurrent");
    const [selectedMedicines, setSelectedMedicines] = useState([]);
    const [showAddCard, setShowAddCard] = useState(false);
    const [isSavingMedications, setIsSavingMedications] = useState(false);

    const today = moment().format("DD-MM-YYYY");
    const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");

    const [newMedicine, setNewMedicine] = useState({
      id: null,
      inventoryid: null,
      medicinename: "",
      manufacturer: "",
      drugclass: "",
      therapeutic: "",
      composition: "",
      medicinetype: "Tablet",
      dosage: "",
      dosageunit: "mg",
      medicationstartdate: today, // SETTING DEFAULTS
      medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
      frequency: 1, // SETTING DEFAULTS
      frequencytime: "",
      frequencyvalue: "",
      morning: 1, // SETTING DEFAULTS
      afternoon: 0,
      evening: 0,
      night: 0,
      prescribedby: "",
      hospitalname: "",
      beforefood: 0, // SETTING DEFAULTS
      afterfood: 1,
      // beforefood: 1, // SETTING DEFAULTS
      // afterfood: 0,
      issaved: false,

      // new inputs

      frequencyduration: null,
      routeofadministration: null,
      timingofinjection: null,
      quantitytobeapplied: null,
      areaofapplication: null,
      diluent: null,
      additives: null,

      rateofinfusionvalue: null,
      rateofinfusionunit: "ml/hr",
      // duration: null,
      duration: "5 Days", // Set default duration value
  durationunit: "Days", // Add this new field
  durationvalue: 5, // Add this new field

      custommessage:null,
      sos:null
    });

    const [editMedicine, setEditMedicine] = useState(null);
    const [editCurrentMedicine, setEditCurrentMedicine] = useState(null);

    //-----Fetch Current and Recent Medicines

    const [currentMedicines, setCurrentMedicines] = useState([]);
    const [recentMedicines, setRecentMedicines] = useState([]);
    const [savedMedicines, setSavedMedicines] = useState([]);
    const [
      patientCurrentMedicinesForDoctor,
      setPatientCurrentMedicinesForDoctor,
    ] = useState([]);
    const [search, setSearch] = useState(""); // for recent medicine
    const screenType = useScreenType();
    const [doctorName, setDoctorName] = useState("");

    function processMedicationsData(medicationArray) {
      console.log(medicationArray, 'processMedicationsData medicationArray - 2: ');
      if (!medicationArray || medicationArray.length === 0) {
        return [];
      }

      const today = moment().format("DD-MM-YYYY");
      const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");

      return medicationArray.map((med) => {
        // Parse the duration string (e.g., "6 Days") into value and unit
        const durationParts = med.duration?.split(" ") || [];
        const durationValue = durationParts[0] ? parseInt(durationParts[0]) : 5;
        const durationUnit = durationParts[1] || "Days";

        // Normalise topical / application fields so favourites / recent meds
        // carry the same shape as saved medicines and DB prescriptions
        const normalizedQuantityToBeApplied =
          med.quantitytobeapplied !== undefined &&
          med.quantitytobeapplied !== null &&
          String(med.quantitytobeapplied).trim() !== ""
            ? med.quantitytobeapplied
            : med.quantity !== undefined && med.quantity !== null
            ? med.quantity
            : ["Syrup","Ointment", "Cream", "Gel"].includes(med.medicinetype)
            ? "1"
            : null;

        const normalizedAreaOfApplication =
          med.areaofapplication !== undefined && med.areaofapplication !== null
            ? med.areaofapplication
            : med.wheretoapply !== undefined && med.wheretoapply !== null
            ? med.wheretoapply
            : null;

        const normalizedApplicationTiming =
          med.timing ||
          (med.applicationtiming !== undefined && med.applicationtiming !== null
            ? med.applicationtiming
            : "");

        return {
          id: med.id,
          inventoryid: med?.inventoryid,
          remainingquantity: med?.remainingquantity ? med.remainingquantity : 0,
          medicinename: med.medicinename,
          medicinetype: med.medicinetype,
          dosage: med.dosage,
          dosageunit: med.dosageunit,
          medicationstartdate: med.medicationstartdate
            ? moment(med.medicationstartdate, "YYYY-MM-DD").format("DD-MM-YYYY")
            : today,
          medicationenddate: med.medicationenddate
            ? moment(med.medicationenddate, "YYYY-MM-DD").format("DD-MM-YYYY")
            : fiveDaysFromToday,
          duration:
            Math.abs(
              new Date(med.medicationstartdate) - new Date(med.medicationenddate)
            ) /
              (1000 * 60 * 60 * 24) +
            " days",
          frequency: med.frequency,
          frequencytime: med.frequencytime,
          frequencyvalue: med.frequencyvalue,
          morning: med.morning,
          afternoon: med.afternoon,
          evening: med.evening,
          night: med.night,
          beforefood: med.beforefood,
          afterfood: med.afterfood,
          composition: med.chemicalcomposition,
          issaved: false,

          // Original duration string plus parsed value/unit
          duration: med.duration,
          durationvalue: durationValue, // Add the parsed value
      durationunit: durationUnit, 

          manufacturer: med.manufacturer,
          drugclass: med.drugclass,
          therapeutic: med.therapeutic,
          custommessage: med.instructions,
          sos: med.sos,

        // Topical / application-related fields so edit modal can pre-populate
        quantitytobeapplied: normalizedQuantityToBeApplied,
        // do not default productQuantity here; let edit modal derive it from frequency when needed
        productQuantity: med.productQuantity,
        areaofapplication: normalizedAreaOfApplication,
        wheretoapply: normalizedAreaOfApplication,
        timing: normalizedApplicationTiming,
        applicationtiming: normalizedApplicationTiming,
        };
      });
    }

    function processSavedMedicationsData(medicationArray) {
  console.log('Adnan 1: ', medicationArray)
  if (!medicationArray || medicationArray.length === 0) {
    return [];
  }

  const today = moment().format("DD-MM-YYYY");
  const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");

  // FILTER: Only include medicines that are active
  const activeMedications = medicationArray.filter(med => 
    med.isactive === undefined || med.isactive !== 0
  );

  return activeMedications.map((med) => {
    console.log('Processing medicine:', med.medicinename, 'ID:', med.id);

    // Normalise topical / application fields coming from DB
    const normalizedQuantityToBeApplied =
      med.quantitytobeapplied !== undefined &&
      med.quantitytobeapplied !== null &&
      String(med.quantitytobeapplied).trim() !== ""
        ? med.quantitytobeapplied
        : med.quantity !== undefined && med.quantity !== null
        ? med.quantity
        : ["Syrup", "Ointment", "Cream", "Gel"].includes(med.medicinetype)
        ? "1"
        : null;

    const normalizedAreaOfApplication =
      (med.areaofapplication !== undefined && med.areaofapplication !== null
        ? med.areaofapplication
        : med.wheretoapply !== undefined && med.wheretoapply !== null
        ? med.wheretoapply
        : null);

    const normalizedApplicationTiming =
      med.timing ||
      (med.applicationtiming !== undefined && med.applicationtiming !== null
        ? med.applicationtiming
        : "");
    
    // Parse the duration string (e.g., "6 Days") into value and unit
    const durationParts = med.duration?.split(' ') || [];
    const durationValue = durationParts[0] ? parseInt(durationParts[0]) : 5;
    const durationUnit = durationParts[1] || 'Days';

    return {
      id: med.id, // Ensure this is getting the ID
      inventoryid: med?.inventoryid,
      medicinename: med.medicinename,
      medicinetype: med.medicinetype,
      dosage: med.dosage,
      dosageunit: med.dosageunit,
      medicationstartdate: med.medicationstartdate
        ? moment(med.medicationstartdate, "YYYY-MM-DD").format("DD-MM-YYYY")
        : today,
      medicationenddate: med.medicationenddate
        ? moment(med.medicationenddate, "YYYY-MM-DD").format("DD-MM-YYYY")
        : fiveDaysFromToday,
      duration: med.duration,
      frequency: parseInt(med.frequency) || 1,
      frequencytime: med.frequencytime,
      frequencyvalue: med.frequencyvalue,
      morning: med.morning,
      afternoon: med.afternoon,
      evening: med.evening,
      night: med.night,
      beforefood: med.beforefood,
      afterfood: med.afterfood,
      composition: med.chemicalcomposition,
      isactive: 1, // Always set to 1 since we filtered out inactive ones
      issaved: true,
      duration: med.duration,
      durationvalue: durationValue,
      durationunit: durationUnit,
      manufacturer: med.manufacturer,
      drugclass: med.drugclass,
      therapeutic: med.therapeuticcategory,
      custommessage: med.custommessage,
      sos: med.sos,
      // Topical medicine fields; for topical, backend may store Product Quantity in frequency
      quantitytobeapplied: normalizedQuantityToBeApplied,
      productQuantity: ["Syrup", "Ointment","Cream","Gel"].includes(med.medicinetype)
        ? (med.productQuantity || (["1","2","3","4"].includes(String(med.frequency)) ? String(med.frequency) : "1"))
        : (med.productQuantity || null),
      areaofapplication: normalizedAreaOfApplication,
      timing: normalizedApplicationTiming,
      applicationtiming: normalizedApplicationTiming,
      // Other medicine type fields
      routeofadministration: med.routeofadministration || null,
      timingofinjection: med.timingofinjection || null,
      diluent: med.diluent || null,
      additives: med.additives || null,
      rateofinfusionvalue: med.rateofinfusionvalue || null,
      rateofinfusionunit: med.rateofinfusionunit || "ml/hr"
    };
  });
}

    const fetchRecentMedicines = async () => {
      // console.log("Function called");
      const inputToFetch = {
        input: {
          doctorid: doctorId,
          type: 'favourite',
          "pageno": 1,
        "pagesize": 1000
        },
      };
      showLoader();
      try {
        // const data = await GetDoctorFavMedicine(inputToFetch.input);
        // setRecentMedicines(processMedicationsData(data?.output?.data));
        const data = await FetchMedicineViewDetails(inputToFetch.input);
        console.log(data?.data, "Recent Medicines - 1");
        setRecentMedicines(processMedicationsData(data?.data));
        // console.log(recentMedicines);
      } catch (error) {
        console.error("Error fetching Recent Medications data:", error);
      } finally {
        dismissLoader();
      }
    };

    let prescribedMedicines = [];

    const fetchSavedMedicines = async () => {
  const inputToFetch = {
    input: {
      patientid: patientId,
      doctorid: doctorId,
      appointmentid: appointmentId,
    },
  };

  console.log("fetching prescribed medicines");
  showLoader();
  try {
    const data = await GetDoctorNotes(inputToFetch.input);
    console.log("API Response for saved medicines - 3 :", data);
    
    const savedMeds = processSavedMedicationsData(data.output.data?.orders?.medication || []);
    console.log("Processed saved medicines: - 4 ", savedMeds);
    
    setSavedMedicines(savedMeds);
    
    setSelectedMedicines(prev => {
      // Create a map of unsaved medicines (medicines without issaved flag or with issaved: false)
      const unsavedMedicines = prev.filter(med => !med.issaved);
      
      // Merge saved medicines with unsaved ones
      const merged = [...savedMeds, ...unsavedMedicines];
      
      console.log("Updated selected medicines after fetch: - 5", merged);
      return merged;
    });
    // Update selectedMedicines with the saved medicines that have IDs
    // setSelectedMedicines(prev => {
    //   // Keep medicines that have IDs and are in savedMeds
    //   const medicinesWithIds = prev.filter(med => med.id && med.isactive !== 0);
      
    //   // Merge with saved medicines
    //   const merged = [...savedMeds];
      
    //   // Add any selected medicines that have IDs but aren't in savedMeds
    //   medicinesWithIds.forEach(med => {
    //     if (!merged.some(m => m.id === med.id)) {
    //       merged.push(med);
    //     }
    //   });
      
    //   console.log("Merged selected medicines:", merged);
    //   return merged;
    // });
    
  } catch (error) {
    console.error("Error fetching Doctor Notes data:", error);
  } finally {
    dismissLoader();
  }
};

    useEffect(() => {
      fetchRecentMedicines();
    }, []);

    useEffect(() => {
      fetchSavedMedicines()
    }, []);

    const [searchParams] = useSearchParams();
    const [redirectMedicine, setRedirectMedicine] = useState([])
    const medicineId = searchParams.get('medicineId');
    // console.log('medicineId: ', medicineId)
    useEffect(() => {
      // console.log(savedMedicines  , " savedMedicines")
      setSelectedMedicines(savedMedicines);
      setRedirectMedicine(savedMedicines)
      if(medicineId && savedMedicines.length > 0) {
        // const foundMedicine = redirectMedicine.find(med => med.id.toString() === medicineId);
        const foundMedicine = savedMedicines.find(med => 
          med.id.toString() === medicineId.toString() 
        );

        if (foundMedicine) {
          // console.log('Found medicine:', foundMedicine);
          handleEditMedicine(foundMedicine); 
        } else {
          console.warn(`Medicine with ID ${medicineId} not found`);
        }
      }
    }, [savedMedicines]);

    const handleTabChange = (tab) => {
      setSelectedTab(tab);
    };

    // let lastInteractionName = "";
    const [lastInteractionName, setLastInteractionName] = useState("");

// const handleCheckboxChange = (medicine) => {
//   // robust key to identify same medicine
//   const makeKey = (m) =>
//     `${(m?.medicinename || "").toString().toLowerCase().trim()}|${(m?.medicinetype || "").toString().trim()}|${(m?.dosage || "").toString().trim()}|${(m?.dosageunit || "").toString().trim()}`;

//   // refs for debouncing duplicate toasts
//   if (!handleCheckboxChange._lastDuplicateToast) {
//     handleCheckboxChange._lastDuplicateToast = { key: null, ts: 0 };
//   }

//   const key = makeKey(medicine);
//   const areSame = (a, b) =>
//     makeKey(a) === makeKey(b);

//   // Check existence in current patient meds or saved meds (active only)
//   const existsInCurrent = patientCurrentMedicinesForDoctor.some(
//     (m) => areSame(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
//   );
//   const existsInSaved = savedMedicines.some(
//     (m) => areSame(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
//   );
//   const existsInSelected = selectedMedicines.some(
//     (m) => areSame(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
//   );

//   if ((existsInCurrent || existsInSaved) && !existsInSelected) {
//     const last = handleCheckboxChange._lastDuplicateToast;
//     const now = Date.now();
//     // avoid showing multiple toasts for same medicine in short interval
//     if (last.key !== key || now - last.ts > 2000) {
//       showErrorToast && showErrorToast("This medicine is already present in the doctor's notes.");
//       handleCheckboxChange._lastDuplicateToast = { key, ts: now };
//     }
//     return;
//   }

//   // proceed with toggle/add behavior
//   setSelectedMedicines((prev) => {
//     const existingIndex = prev.findIndex((m) =>
//       areSame(m, medicine)
//     );

//     if (existingIndex >= 0) {
//       // Toggle isactive status
//       return prev.map((m, index) =>
//         index === existingIndex
//           ? { ...m, isactive: m.isactive === 0 ? 1 : 0 }
//           : m
//       );
//     } else {
//       // Add new medicine as active
//       return [...prev, { ...medicine, isactive: 1 }];
//     }
//   });
// };

const handleCheckboxChange = (medicine) => {
  // robust key to identify same medicine
  const makeKey = (m) =>
    `${(m?.medicinename || "").toString().toLowerCase().trim()}|${(m?.medicinetype || "").toString().trim()}|${(m?.dosage || "").toString().trim()}|${(m?.dosageunit || "").toString().trim()}`;

  // refs for debouncing duplicate toasts
  if (!handleCheckboxChange._lastDuplicateToast) {
    handleCheckboxChange._lastDuplicateToast = { key: null, ts: 0 };
  }

  const key = makeKey(medicine);
  const areSame = (a, b) =>
    makeKey(a) === makeKey(b);

  // Check existence in current patient meds or saved meds (active only)
  // const existsInCurrent = patientCurrentMedicinesForDoctor.some(
  //   (m) => areSame(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
  // );
  const existsInSaved = savedMedicines.some(
    (m) => areSame(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
  );
  const existsInSelected = selectedMedicines.some(
    (m) => areSame(m, medicine) && (m.isactive === undefined || m.isactive !== 0)
  );

  // if ((existsInCurrent || existsInSaved) && !existsInSelected) {
  if ((existsInSaved) && existsInSelected) {
    const last = handleCheckboxChange._lastDuplicateToast;
    const now = Date.now();
    // avoid showing multiple toasts for same medicine in short interval
    if (last.key !== key || now - last.ts > 2000) {
      showErrorToast && showErrorToast("This medicine is already present in the doctor's notes.");
      handleCheckboxChange._lastDuplicateToast = { key, ts: now };
    }
    return;
  }

  // proceed with toggle/add behavior
  setSelectedMedicines((prev) => {
    const existingIndex = prev.findIndex((m) =>
      areSame(m, medicine)
    );

    if (existingIndex >= 0) {
      // Toggle isactive status
      return prev.map((m, index) =>
        index === existingIndex
          ? { ...m, isactive: m.isactive === 0 ? 1 : 0 }
          : m
      );
    } else {
      // Add new medicine as active and mark as unsaved (from favorites)
      const topicalTypes = ["Syrup", "Ointment","Cream","Gel"];
      const medicineToAdd = {
        ...medicine,
        isactive: 1,
        issaved: false, // Mark as unsaved when selected from favorites
        // preserve descriptive topical quantity from API; default productQuantity to 1 for topicals
        quantitytobeapplied: medicine.quantitytobeapplied,
        productQuantity: topicalTypes.includes(medicine.medicinetype)
          ? (medicine.productQuantity || "1")
          : medicine.productQuantity,
        // Add default values if missing
        duration: medicine.duration || "5 Days",
        durationunit: medicine.durationunit || "Days",
        durationvalue: medicine.durationvalue || 5,
        frequency: medicine.frequency || 1,
        morning: medicine.morning ?? 1,
        afternoon: medicine.afternoon ?? 0,
        evening: medicine.evening ?? 0,
        night: medicine.night ?? 0,
        beforefood: medicine.beforefood ?? 1,
        afterfood: medicine.afterfood ?? 0,
        medicationstartdate: medicine.medicationstartdate || today,
        medicationenddate: medicine.medicationenddate || fiveDaysFromToday
      };
      return [...prev, medicineToAdd];
    }
  });
};
// const handleCheckboxChange = (medicine) => {
//   // Create a unique key for comparison
//   const makeKey = (m) =>
//     `${(m?.medicinename || "").toString().toLowerCase().trim()}|${(m?.medicinetype || "").toString().trim()}|${(m?.dosage || "").toString().trim()}|${(m?.dosageunit || "").toString().trim()}`;

//   const key = makeKey(medicine);
  
//   // DEBOUCE FOR DUPLICATE TOAST
//   if (!handleCheckboxChange._lastDuplicateToast) {
//     handleCheckboxChange._lastDuplicateToast = { key: null, ts: 0 };
//   }

//   // CHECK 1: Is this medicine already in savedMedicines (from database)?
//   const isInSavedMedicines = savedMedicines.some(
//     (m) => makeKey(m) === key && (m.isactive === undefined || m.isactive !== 0)
//   );

//   // CHECK 2: Is this medicine already in selectedMedicines as ACTIVE?
//   const isInSelectedMedicinesAsActive = selectedMedicines.some(
//     (m) => makeKey(m) === key && (m.isactive === undefined || m.isactive !== 0)
//   );

//   // CHECK 3: Is this medicine in selectedMedicines but INACTIVE?
//   const isInSelectedMedicinesAsInactive = selectedMedicines.some(
//     (m) => makeKey(m) === key && m.isactive === 0
//   );

//   // If medicine is in savedMedicines OR already active in selectedMedicines, show toast
//   if (isInSavedMedicines || isInSelectedMedicinesAsActive) {
//     const last = handleCheckboxChange._lastDuplicateToast;
//     const now = Date.now();
//     if (last.key !== key || now - last.ts > 2000) {
//       showErrorToast && showErrorToast("This medicine is already present in the doctor's notes.");
//       handleCheckboxChange._lastDuplicateToast = { key, ts: now };
//     }
//     return;
//   }

//   // If medicine is in selectedMedicines but INACTIVE, reactivate it
//   if (isInSelectedMedicinesAsInactive) {
//     setSelectedMedicines(prev =>
//       prev.map(m =>
//         makeKey(m) === key
//           ? { ...m, isactive: 1 }
//           : m
//       )
//     );
//     return;
//   }

//   // Otherwise, add as new medicine
//   const medicineToAdd = {
//     ...medicine,
//     id: null, // Ensure it doesn't have an ID if it's new
//     isactive: 1,
//     issaved: false,
//     duration: medicine.duration || "5 Days",
//     durationunit: medicine.durationunit || "Days",
//     durationvalue: medicine.durationvalue || 5,
//     frequency: medicine.frequency || 1,
//     morning: medicine.morning ?? 1,
//     afternoon: medicine.afternoon ?? 0,
//     evening: medicine.evening ?? 0,
//     night: medicine.night ?? 0,
//     beforefood: medicine.beforefood ?? 1,
//     afterfood: medicine.afterfood ?? 0,
//     medicationstartdate: medicine.medicationstartdate || today,
//     medicationenddate: medicine.medicationenddate || fiveDaysFromToday
//   };
  
//   setSelectedMedicines(prev => [...prev, medicineToAdd]);
// };

    const formatQuantity = (quantity) => {
      if (quantity === 0) {
        return "Out of Stock";
      } else {
        return quantity.toLocaleString(); // This formats the number with commas
      }
    };

    const handleSelectAll = () => {
      currentMedicines.forEach((medicine) => {
        if (!selectedMedicines.includes(medicine)) {
          handleCheckboxChange(medicine);
        }
      });
    };

    const [dropdownMedType, setDropdownMedType] = useState("");
const additionalMedicineTypes = [
  "Respules",
  "Suspension",
  "Foam",
  "Suppository",
  "EA",
  "Device",
  // "Sachet",
  "Box",
  "Spray",
  "Lotion",
  "Tube",
  "Gargle",
  "Powder",
  "Soap",
  "Aerosol",
  "Shampoo",
  "Topical Cleanser",
  "Custom"
];

const handleCurrentEditTypeChange = (value) => {
  if (additionalMedicineTypes.includes(value)) {
    setDropdownMedType(value);
    handleEditCurrentMedicineChange("medicinetype", value);
  } else {
    setDropdownMedType("");
    handleEditCurrentMedicineChange("medicinetype", value);
  }

  // Set default dosage units based on medicine type
  if (["Syrup", "Drops", "Suspension", "Respules", "Gargle", "Shampoo", "Topical Cleanser"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "ml");
  } else if (["Tablet", "Capsule", "Suppository", "Powder"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "mg");
  } else if (["Injection", "Nebulization", "IVFluids"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "ml");
  } else if (["Ointment", "Cream", "Gel", "Foam", "Lotion", "Tube", "Soap"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "grms");
  } else if (["Inhaler", "Spray", "Aerosol"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "puffs");
  } else if (["EA", "Device", "Box"].includes(value)) {
    handleEditCurrentMedicineChange("dosageunit", "each");
  } else if (value === "Sachet") {
    handleEditCurrentMedicineChange("dosageunit", "mg");
  } else if (value === "Custom") {
    handleEditCurrentMedicineChange("dosageunit", "");
  }
};

const handleEditTypeChange = (value) => {
  if (additionalMedicineTypes.includes(value)) {
    setDropdownMedType(value);
    handleEditMedicineChange("medicinetype", value);
  } else {
    setDropdownMedType("");
    handleEditMedicineChange("medicinetype", value);
  }

  // Set default dosage units based on medicine type
  if (["Syrup", "Drops", "Suspension", "Respules", "Gargle", "Shampoo", "Topical Cleanser"].includes(value)) {
    handleEditMedicineChange("dosageunit", "ml");
  } else if (["Tablet", "Capsule", "Suppository", "Powder"].includes(value)) {
    handleEditMedicineChange("dosageunit", "mg");
  } else if (["Injection", "Nebulization", "IVFluids"].includes(value)) {
    handleEditMedicineChange("dosageunit", "ml");
  } else if (["Ointment", "Cream", "Gel", "Foam", "Lotion", "Tube", "Soap"].includes(value)) {
    handleEditMedicineChange("dosageunit", "grms");
  } else if (["Inhaler", "Spray", "Aerosol"].includes(value)) {
    handleEditMedicineChange("dosageunit", "puffs");
  } else if (["EA", "Device", "Box"].includes(value)) {
    handleEditMedicineChange("dosageunit", "each");
  } else if (value === "Sachet") {
    handleEditMedicineChange("dosageunit", "mg");
  } else if (value === "Custom") {
    handleEditMedicineChange("dosageunit", "");
  }
};

const handleTypeChange = (value) => {
  if (additionalMedicineTypes.includes(value)) {
    setDropdownMedType(value);
    handleNewMedicineChange("medicinetype", value);
  } else {
    setDropdownMedType("");
    handleNewMedicineChange("medicinetype", value);
  }

  // Set default dosage units
  if (["Syrup", "Drops", "Suspension", "Respules", "Gargle", "Shampoo", "Topical Cleanser"].includes(value)) {
    handleNewMedicineChange("dosageunit", "ml");
  } else if (["Tablet", "Capsule", "Suppository", "Powder"].includes(value)) {
    handleNewMedicineChange("dosageunit", "mg");
  } else if (["Injection", "Nebulization", "IVFluids"].includes(value)) {
    handleNewMedicineChange("dosageunit", "ml");
  } else if (["Ointment", "Cream", "Gel", "Foam", "Lotion", "Tube", "Soap"].includes(value)) {
    handleNewMedicineChange("dosageunit", "grms");
  } else if (["Inhaler", "Spray", "Aerosol"].includes(value)) {
    handleNewMedicineChange("dosageunit", "puffs");
  } else if (["EA", "Device", "Box"].includes(value)) {
    handleNewMedicineChange("dosageunit", "each");
  } else if (value === "Sachet") {
    handleNewMedicineChange("dosageunit", "mg");
  } else if (value === "Custom") {
    handleNewMedicineChange("dosageunit", "");
  }
};

const [addMedicineInstructions, setAddMedicineInstructions] = useState("");
    const handleNewMedicineChange = (field, value) => {
      if (field === "custommessage") {
    setAddMedicineInstructions(value);
  }
      setNewMedicine((prev) => ({ ...prev, [field]: value }));
    };

  //   const handleAddMedicine = () => {
  //     if (newMedicine.medicinename === "") {
  //       showErrorToast("Please enter medicine name to continue");
  //       return;
  //     }
  //     if (newMedicine.frequencytime && !newMedicine.frequencyvalue) {
  //       showErrorToast("Please select the Value when Frequency is selected");
  //       return;
  //     }
  //     setSelectedMedicines((prev) => [...prev, newMedicine]);
  //     // DetectInteractionsUsingAI(newMedicine.medicinename);
  //     // setShowAddCard(false);
  //     // Reset the new medicine form
  //      setDropdownMedType("");
  //      setAddMedicineInstructions("");
  //     setNewMedicine({
  //       id: null,
  //       inventoryid: null,
  //       medicinename: "",
  //       manufacturer: "",
  //       drugclass: "",
  //       therapeutic: "",
  //       composition: "",
  //       medicinetype: "Tablet",
  //       dosage: "",
  //       dosageunit: "mg",
  //       medicationstartdate: today, // SETTING DEFAULTS
  //       medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
  //       frequency: 1, // SETTING DEFAULTS
  //       frequencytime: "",
  //       frequencyvalue: '',
  //       morning: 1, // SETTING DEFAULTS
  //       afternoon: 0,
  //       evening: 0,
  //       night: 0,
  //       prescribedby: "",
  //       hospitalname: "",
  //       beforefood: 1, // SETTING DEFAULTS
  //       afterfood: 0,
  //       issaved: false,

  //       // new inputs

  //       frequencyduration: null,
  //       routeofadministration: null,
  //       timingofinjection: null,
  //       quantitytobeapplied: null,
  //       areaofapplication: null,
  //       diluent: null,
  //       additives: null,

  //       rateofinfusionvalue: null,
  //       rateofinfusionunit: "ml/hr",
  //       // duration: null,
  //       duration: "",
  //       // duration: durationvalue + durationunit, // Set default duration value
  // durationunit: "Days", // Add this new field
  // durationvalue: 5,

  //       custommessage:null,
  //     sos:null
  //     });

  //     addPrescriptionMedication.current.closeModal();
  //     setIsAddModalOpen(false)

  //     // console.log(selectedMedicines);
  //   };

  const handleSaveMedicine = async () => {
  if (newMedicine.medicinename === "") {
    showErrorToast("Please enter medicine name to continue");
    return;
  }
  if (newMedicine.frequencytime && !newMedicine.frequencyvalue) {
    showErrorToast("Please select the Value when Frequency is selected");
    return;
  }

  try {
    showLoader();

    // Prepare medicine data for API
    const isTopical = (newMedicine.medicinetype === "Syrup" ||newMedicine.medicinetype === "Ointment" || newMedicine.medicinetype === "Cream" || newMedicine.medicinetype === "Gel");
    const medicinedetail = [{
      id: null,
      inventoryid: newMedicine.inventoryid,
      medicinename: newMedicine.medicinename,
      medicinetype: newMedicine.medicinetype,
      dosage: newMedicine.dosage,
      dosageunit: newMedicine.dosageunit,
      startdate: isTopical ? "" : null,
      enddate: isTopical ? "" : null,
      // For topical, dropdown binds to frequency (Product Quantity); for others, Consumption Quantity
      frequency: isTopical ? (newMedicine.frequency || "1") : newMedicine.frequency,
      frequencytime: newMedicine.frequencytime,
      frequencyvalue: newMedicine.frequencyvalue,
      morning: newMedicine.morning,
      afternoon: newMedicine.afternoon,
      evening: newMedicine.evening,
      night: newMedicine.night,
      beforefood: newMedicine.beforefood,
      afterfood: newMedicine.afterfood,
      chemical_composition: newMedicine.composition || "",
      Manufacturer: newMedicine.manufacturer || "",
      TherapeuticCategory: newMedicine.therapeutic || "",
      DrugClass: newMedicine.drugclass || "",
      prescribedby: newMedicine.prescribedby || "Viggu Netha",
      isactive: 1,
      routeofadministration: newMedicine.routeofadministration,
      timingofinjection: newMedicine.timingofinjection,
      // Always send the descriptive quantity selected in the UI
      quantitytobeapplied: newMedicine.quantitytobeapplied,
      areaofapplication: newMedicine.areaofapplication,
      diluent: newMedicine.diluent,
      additives: newMedicine.additives,
      rateofinfusionvalue: newMedicine.rateofinfusionvalue,
      rateofinfusionunit: newMedicine.rateofinfusionunit,
      duration: isTopical ? "" : newMedicine.duration,
      applicationtiming: newMedicine.timing || "",
      wheretoapply: newMedicine.areaofapplication || "",
      custommessage: newMedicine.custommessage,
      sos: newMedicine.sos,
      productQuantity: newMedicine.productQuantity || (isTopical ? "1" : undefined)
    }];

    const inputToSave = {
      input: {
        patientid: patientId,
        doctorid: doctorId,
        appointmentid: appointmentId || null,
        medicinedetail,
        // branchid: "273",
        // hospitalid: "48"
      },
    };

    console.log("Saving medicine to orders:", inputToSave);

    const result = await updateDoctorNotes(inputToSave.input);
    console.log('API Response: ', result);
    
    if (result && result.output?.result === "success") {
      showSuccessToast("Medicine saved successfully.");
      
      // Get the saved medicine data from API response
      // The structure is: result.output.data.orders.medication[0]
      const savedMedicineFromAPI = result.output.data?.orders?.medication?.[0];
      
      if (savedMedicineFromAPI) {
        console.log('Saved medicine from API:', savedMedicineFromAPI);
        console.log('Medicine ID from API:', savedMedicineFromAPI.id); // This should be 39779
        
        // Process the API response to match your local format
        const today = moment().format("DD-MM-YYYY");
        const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");
        
        // Parse duration
        const durationParts = savedMedicineFromAPI.duration?.split(' ') || [];
        const durationValue = durationParts[0] ? parseInt(durationParts[0]) : 5;
        const durationUnit = durationParts[1] || 'Days';

        const topicalTypes = ["Syrup", "Ointment","Cream","Gel"];

        const processedMedicine = {
          id: savedMedicineFromAPI.id, // This is the important ID
          inventoryid: savedMedicineFromAPI.inventoryid,
          remainingquantity: savedMedicineFromAPI.remainingquantity || 0,
          medicinename: savedMedicineFromAPI.medicinename,
          medicinetype: savedMedicineFromAPI.medicinetype,
          dosage: savedMedicineFromAPI.dosage,
          dosageunit: savedMedicineFromAPI.dosageunit,
          medicationstartdate: savedMedicineFromAPI.medicationstartdate
            ? moment(savedMedicineFromAPI.medicationstartdate, "YYYY-MM-DD").format("DD-MM-YYYY")
            : today,
          medicationenddate: savedMedicineFromAPI.medicationenddate
            ? moment(savedMedicineFromAPI.medicationenddate, "YYYY-MM-DD").format("DD-MM-YYYY")
            : fiveDaysFromToday,
          frequency: parseInt(savedMedicineFromAPI.frequency) || newMedicine.frequency,
          frequencytime: savedMedicineFromAPI.frequencytime || newMedicine.frequencytime,
          frequencyvalue: savedMedicineFromAPI.frequencyvalue || newMedicine.frequencyvalue,
          morning: savedMedicineFromAPI.morning,
          afternoon: savedMedicineFromAPI.afternoon,
          evening: savedMedicineFromAPI.evening,
          night: savedMedicineFromAPI.night,
          beforefood: savedMedicineFromAPI.beforefood,
          afterfood: savedMedicineFromAPI.afterfood,
          composition: savedMedicineFromAPI.chemicalcomposition || newMedicine.composition,
          manufacturer: savedMedicineFromAPI.manufacturer || newMedicine.manufacturer,
          drugclass: savedMedicineFromAPI.drugclass || newMedicine.drugclass,
          therapeutic: savedMedicineFromAPI.therapeuticcategory || newMedicine.therapeutic,
          custommessage: savedMedicineFromAPI.custommessage || newMedicine.custommessage,
          duration: savedMedicineFromAPI.duration || newMedicine.duration,
          durationvalue: durationValue,
          durationunit: durationUnit,
          sos: savedMedicineFromAPI.sos || newMedicine.sos,
          isactive: 1,
          issaved: true,
          // Preserve descriptive topical quantity from API if present; otherwise fall back to UI value
          quantitytobeapplied:
            savedMedicineFromAPI.quantitytobeapplied != null &&
            String(savedMedicineFromAPI.quantitytobeapplied).trim() !== ""
              ? savedMedicineFromAPI.quantitytobeapplied
              : (newMedicine.quantitytobeapplied || null),
          // Carry over productQuantity; default to 1 for topicals when missing
          productQuantity:
            savedMedicineFromAPI.productQuantity ||
            (topicalTypes.includes(savedMedicineFromAPI.medicinetype)
              ? (newMedicine.productQuantity || "1")
              : newMedicine.productQuantity)
        };

        // console.log('Processed medicine:', processedMedicine);
        // console.log('Processed medicine ID:', processedMedicine.id);
        
        // Add the saved medicine to selected medicines
        setSelectedMedicines((prev) => {
          // Remove any duplicate medicine (same name, type, dosage)
          const filteredPrev = prev.filter(med => 
            !(med.medicinename === processedMedicine.medicinename &&
              med.medicinetype === processedMedicine.medicinetype &&
              med.dosage === processedMedicine.dosage &&
              !med.id) // Remove if no ID (was just added)
          );
          
          const newSelected = [...filteredPrev, processedMedicine];
          console.log('Updated selectedMedicines:', newSelected);
          return newSelected;
        });

      } else {
        // Fallback if API structure is different
        console.warn('Unexpected API response structure:', result);
        const savedMedicine = {
          ...newMedicine,
          id: null, // Set to null temporarily
          isactive: 1,
          issaved: true,
          chemical_composition: newMedicine.composition || "",
          Manufacturer: newMedicine.manufacturer || "",
          TherapeuticCategory: newMedicine.therapeutic || "",
          DrugClass: newMedicine.drugclass || "",
          startdate: newMedicine.medicationstartdate,
          enddate: newMedicine.medicationenddate,
          prescribedby: newMedicine.prescribedby || "Viggu Netha"
        };
        
        console.log('Fallback saved medicine:', savedMedicine);
        setSelectedMedicines((prev) => {
          const newSelected = [...prev, savedMedicine];
          console.log('Fallback selectedMedicines:', newSelected);
          return newSelected;
        });
      }

      // Reset form and close modal
      setDropdownMedType("");
      setAddMedicineInstructions("");
      setNewMedicine({
        id: null,
        inventoryid: null,
        medicinename: "",
        manufacturer: "",
        drugclass: "",
        therapeutic: "",
        composition: "",
        medicinetype: "Tablet",
        dosage: "",
        dosageunit: "mg",
        medicationstartdate: today,
        medicationenddate: fiveDaysFromToday,
        frequency: 1,
        frequencytime: "",
        frequencyvalue: '',
        morning: 1,
        afternoon: 0,
        evening: 0,
        night: 0,
        prescribedby: "",
        hospitalname: "",
        beforefood: 0,
        afterfood: 1,
        // beforefood: 1,
        // afterfood: 0,
        issaved: false,
        frequencyduration: null,
        routeofadministration: null,
        timingofinjection: null,
        quantitytobeapplied: null,
        areaofapplication: null,
        diluent: null,
        additives: null,
        rateofinfusionvalue: null,
        rateofinfusionunit: "ml/hr",
        duration: "5 Days",
        durationunit: "Days",
        productQuantity: "1",
        durationvalue: 5,
        custommessage: null,
        sos: null
      });

      addPrescriptionMedication.current.closeModal();
      setIsAddModalOpen(false);

      // Refresh saved medicines - this will get the correct ID from database
      await fetchSavedMedicines();
      await fetchRecentMedicines();
      if (typeof fetchPatientHealthData === "function") {
        fetchPatientHealthData();
      }
      if (typeof fetchDoctorNotesEmptyIndication === "function") {
        fetchDoctorNotesEmptyIndication();
      }

    } else {
      showErrorToast(result?.output?.message || "Failed to save medicine.");
    }
  } catch (error) {
    console.error("Error saving medicine:", error);
    showErrorToast("An error occurred while saving medicine.");
  } finally {
    dismissLoader();
  }
};

    const handleCancelAddMedicine = () => {
      // setShowAddCard(false);
      // Reset the new medicine form
      setNewMedicine({
        id: null,
        medicinename: "",
        manufacturer: "",
        drugclass: "",
        therapeutic: "",
        composition: "",
        medicinetype: "Tablet",
        dosage: "",
        dosageunit: "mg",
        medicationstartdate: today, // SETTING DEFAULTS
        medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
        frequency: 1, // SETTING DEFAULTS
        frequencytime: "",
        frequencyvalue: "",
        morning: 1, // SETTING DEFAULTS
        afternoon: 0,
        evening: 0,
        night: 0,
        prescribedby: "",
        hospitalname: "",
        beforefood: 0, // SETTING DEFAULTS
        afterfood: 1,
        // beforefood: 1, // SETTING DEFAULTS
        // afterfood: 0,
        issaved: false,

        // new inputs

        frequencyduration: null,
        routeofadministration: null,
        timingofinjection: null,
        quantitytobeapplied: null,
        areaofapplication: null,
        diluent: null,
        additives: null,

        rateofinfusionvalue: null,
        rateofinfusionunit: "ml/hr",
        // duration: null,
        duration: "5 Days", // Set default duration value
        durationunit: "Days", // Add this new field
        durationvalue: 5,
        productQuantity: "1",

        custommessage:null,
      sos:null
      });

      addPrescriptionMedication.current.closeModal();
      setIsAddModalOpen(false)

      // console.log(selectedMedicines);
    };

    // newly added function to delete
    const handleDeleteMedicine = (medicine) => {
  setSelectedMedicines((prev) => {
    const isMatch = (m) => 
      m.medicinename === medicine.medicinename &&
      m.medicinetype === medicine.medicinetype &&
      m.dosage === medicine.dosage &&
      m.dosageunit === medicine.dosageunit;

    if (medicine.issaved) {
      return prev.map(m => isMatch(m) ? { ...m, isactive: 0 } : m);
    } else {
      return prev.filter(m => !isMatch(m));
    }
  });

  // Also clear edit medicine if it's the one being deleted
  if (editMedicine && editMedicine.id === medicine.id) {
    setEditMedicine(null);
  }
};
const [idToDelete, setIdToDelete] = useState(null);
const [medicationNameToDelete, setMedicationNameToDelete] = useState("");
const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const deleteMedicineModal = useRef();
const openDeleteModal = (medicine) => {
  console.log('medicine of deelete details: ', medicine)
  setIdToDelete(medicine.id);
  // Show formatted label (type prefix + name + dosage + unit) in the modal
  setMedicationNameToDelete(formatMedicineName(medicine));
  setIsDeleteModalOpen(true);
  deleteMedicineModal.current.openModal();
};
const deleteMedication = async () => {
  if (!idToDelete) return;

  const inputForDelete = {
    input: {
      doctorid: doctorId,
      patientid: patientId,
      appointmentid: appointmentId,
      type: "medications",
      prescribedmedicineid: idToDelete,
      medicineactive: 0,
    },
  };

  try {
    showLoader();
    const result = await updateCondition(inputForDelete.input);
    if (result.output.result === "success") {
      showSuccessToast(`${medicationNameToDelete} has been deleted`);
      
      // Remove the medicine from selected medicines
      setSelectedMedicines(prev => 
        prev.filter(medicine => medicine.id !== idToDelete)
      );
      
      // Clear edit medicine if it's the one being deleted
      if (editMedicine && editMedicine.id === idToDelete) {
        setEditMedicine(null);
      }
      
      // Refresh ALL data - IMPORTANT: This will update savedMedicines
      fetchDoctorNotesEmptyIndication();
      fetchDoctorNotes();
      fetchRecentMedicines();
      // await fetchSavedMedicines(); // ← ADD THIS LINE to refresh saved medicines
      
      // Close modal
      deleteMedicineModal.current?.closeModal();
      setIsDeleteModalOpen(false);
    } else {
      showErrorToast("Something went wrong!");
    }
  } catch (error) {
    console.error("Error deleting medication:", error);
    showErrorToast("An error occurred while deleting medication");
  } finally {
    dismissLoader();
  }
};

    const validationOfNumberWithOnly1Decimal = (inputValue, maxLength) => {
      // Remove all characters that are not digits or a decimal point
      let cleanedValue = inputValue.replace(/[^0-9.]/g, "");

      // Remove leading decimal point if present
      if (cleanedValue.startsWith(".")) {
        cleanedValue = cleanedValue.substring(1);
      }

      // Handle multiple decimal points
      const decimalIndex = cleanedValue.indexOf(".");
      if (decimalIndex !== -1) {
        const parts = cleanedValue.split(".");
        // Keep only the first two digits after the decimal point
        cleanedValue = parts[0] + "." + parts[1].slice(0, 2);
      }

      // Enforce the max length after cleaning and truncating
      if (cleanedValue.length > maxLength) {
        cleanedValue = cleanedValue.substring(0, maxLength);
      }

      // console.log("input", inputValue);
      // console.log("cleaned", cleanedValue);

      return cleanedValue;
    };

    const [initialMedicineText, setInitialMedicineText] = useState("");
    const handleEditMedicine = (medicine) => {
      console.log('medicine dtls: ', medicine)

      if (additionalMedicineTypes.includes(medicine.medicinetype)) {
    setDropdownMedType(medicine.medicinetype);
  } else {
    setDropdownMedType("");
  }

  setOutputMedicineLang("English")
      const isTopicalEdit = ["Syrup", "Ointment", "Cream", "Gel"].includes(medicine.medicinetype);

      // For topical: Product Quantity dropdown is driven purely by `frequency`.
      // Use the saved frequency (1–4) if valid, otherwise default to "1".
      let normalizedFrequency = medicine.frequency;
      if (isTopicalEdit) {
        normalizedFrequency =
          ["1", "2", "3", "4"].includes(String(medicine.frequency))
            ? String(medicine.frequency)
            : "1";
      }

      const normalizedQuantity = medicine.quantitytobeapplied
        ? String(medicine.quantitytobeapplied).trim()
        : "";
      const normalizedArea = medicine.areaofapplication
        ? String(medicine.areaofapplication).trim()
        : "";
      const normalizedTiming = medicine.timing || medicine.applicationtiming || "";

      setEditMedicine({
        ...medicine,
        frequency: normalizedFrequency,
        quantitytobeapplied: normalizedQuantity,
        areaofapplication: normalizedArea,
        timing: normalizedTiming,
      });

      setIsSelectedEditModalOpen(true)
      // Set the initial text to the current custommessage value
  setInitialMedicineText(medicine.custommessage || "");
  // Also set the form value
  setMedicineValue("textField", medicine.custommessage || "", {
    shouldDirty: true,
    shouldTouch: true,
    shouldValidate: true,
  });

  // Also update instructionsMap if needed
  if (medicine.id) {
    setSelectMedicineId(medicine.id);
    setInstructionsMap(prevMap => ({
      ...prevMap,
      [medicine.id]: initialText
    }));
  }
      editSelectedPrescriptionMedication.current.openModal();
      // setEditMedicine({
      //   ...medicine,
      //   frequencytime: medicine.frequencytime || "",
      //   frequencyvalue: medicine.frequencyvalue || "",
      // });
   };

    const handleEditCurrentMedicine = (medicine) => {
      if (additionalMedicineTypes.includes(medicine.medicinetype)) {
    setDropdownMedType(medicine.medicinetype);
  } else {
    setDropdownMedType("");
  }

  setEditCurrentMedicine(medicine);
  setIsCurrentEditModalOpen(true)
      editCurrentPrescriptionMedication.current.openModal();

      // console.log("Called")
    };

    const [selectMedicineId, setSelectMedicineId] = useState(null);
const [instructionsMap, setInstructionsMap] = useState({});
    useEffect(() => {
  if (editMedicine?.id) {
    setSelectMedicineId(editMedicine.id);
    // Initialize or set the current instruction
    // setValue("textField", editMedicine.custommessage || instructionsMap[editMedicine.id] || "");
    // setInitialText(editMedicine.custommessage || instructionsMap[editMedicine.id] || "");
  }
}, [editMedicine?.id]);

    const [currentMedicineId, setCurrentMedicineId] = useState(null);
const [currentInstructionsMap, setCurrentInstructionsMap] = useState({});
    useEffect(() => {
  if (editCurrentMedicine?.id) {
    setSelectMedicineId(editCurrentMedicine.id);
    // Initialize or set the current instruction
    setValue("textField", editCurrentMedicine.custommessage || instructionsMap[editCurrentMedicine.id] || "");
    setInitialText(editCurrentMedicine.custommessage || instructionsMap[editCurrentMedicine.id] || "");
  }
}, [editCurrentMedicine?.id]);

    const handleEditMedicineChange = (field, value) => {
      // setEditMedicine((prev) => ({ ...prev, [field]: value }));
      setEditMedicine((prev) => {
    const updated = { ...prev, [field]: value };
    // Update the instructions map when custommessage changes
    if (field === "custommessage" && selectMedicineId) {
      setInstructionsMap(prevMap => ({
        ...prevMap,
        [selectMedicineId]: value
      }));
    }
    return updated;
  });
  
  // Also update the form field
  if (field === "custommessage") {
    setMedicineValue("textField", value, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  }
    };

    const handleEditCurrentMedicineChange = (field, value) => {
      // setEditCurrentMedicine((prev) => ({ ...prev, [field]: value }));
      setEditCurrentMedicine((prev) => {
    const updated = { ...prev, [field]: value };
    // Update the instructions map when custommessage changes
    if (field === "custommessage" && currentMedicineId) {
      setCurrentInstructionsMap(prevMap => ({
        ...prevMap,
        [currentMedicineId]: value
      }));
    }
    return updated;
  });
  
  // Also update the form field
  if (field === "custommessage") {
    setValue("textField", value, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  }
    };

    // const handleSaveEditMedicine = () => {
    //   if (editMedicine.medicinename === "") {
    //     showErrorToast("Please enter medicine name to continue");
    //     return;
    //   }
    //   if (editMedicine.frequencytime && !editMedicine.frequencyvalue) {
    //     showErrorToast("Please select the Value when Frequency is selected");
    //     return;
    //   }
    //   setSelectedMedicines((prev) =>
    //     prev.map((m) => (m.id === editMedicine.id ? editMedicine : m))
    //   );

    //   // console.log(selectedMedicines);
    //   // editSelectedPrescriptionMedication.current.closeModal();
    //   setEditMedicine(null);
    //   setIsSelectedEditModalOpen(false)
    // };
    const handleSaveEditMedicine = async () => {
  if (!editMedicine.medicinename) {
    showErrorToast("Please enter medicine name to continue");
    return;
  }
  if (editMedicine.frequencytime && !editMedicine.frequencyvalue) {
    showErrorToast("Please select the Value when Frequency is selected");
    return;
  }

  try {
    // setIsMedicineButtonDisabled(true);
    showLoader();

    // Convert dates from DD-MM-YYYY to YYYY-MM-DD format
    const formatDateForAPI = (dateString) => {
      if (!dateString) return moment().format("YYYY-MM-DD");
      
      // Check if date is already in YYYY-MM-DD format
      if (moment(dateString, "YYYY-MM-DD", true).isValid()) {
        return dateString;
      }
      
      // Convert from DD-MM-YYYY to YYYY-MM-DD
      if (moment(dateString, "DD-MM-YYYY", true).isValid()) {
        return moment(dateString, "DD-MM-YYYY").format("YYYY-MM-DD");
      }
      
      // Default to today if invalid format
      return moment().format("YYYY-MM-DD");
    };

    // Prepare medicine data for API
    const isTopicalEdit = (editMedicine.medicinetype === "Syrup" || editMedicine.medicinetype === "Ointment" || editMedicine.medicinetype === "Cream" || editMedicine.medicinetype === "Gel");
    const medicinedetail = [{
      id: editMedicine.id, // Use the existing ID for update
      inventoryid: editMedicine.inventoryid,
      medicinename: editMedicine.medicinename,
      medicinetype: editMedicine.medicinetype,
      dosage: editMedicine.dosage,
      dosageunit: editMedicine.dosageunit,
      startdate: isTopicalEdit ? "" : formatDateForAPI(editMedicine.medicationstartdate),
      enddate: isTopicalEdit ? "" : formatDateForAPI(editMedicine.medicationenddate),
      // For topical medicines, `frequency` now directly carries the Product Quantity value
      frequency: editMedicine.frequency,
      frequencytime: editMedicine.frequencytime,
      frequencyvalue: editMedicine.frequencyvalue,
      morning: editMedicine.morning,
      afternoon: editMedicine.afternoon,
      evening: editMedicine.evening,
      night: editMedicine.night,
      beforefood: editMedicine.beforefood,
      afterfood: editMedicine.afterfood,
      chemical_composition: editMedicine.composition || "",
      Manufacturer: editMedicine.manufacturer || "",
      TherapeuticCategory: editMedicine.therapeutic || "",
      DrugClass: editMedicine.drugclass || "",
      prescribedby: editMedicine.prescribedby || "Viggu Netha",
      isactive: 1,
      routeofadministration: editMedicine.routeofadministration,
      timingofinjection: editMedicine.timingofinjection,
      quantitytobeapplied: editMedicine.quantitytobeapplied,
      areaofapplication: editMedicine.areaofapplication,
      diluent: editMedicine.diluent,
      additives: editMedicine.additives,
      rateofinfusionvalue: editMedicine.rateofinfusionvalue,
      rateofinfusionunit: editMedicine.rateofinfusionunit,
      duration: isTopicalEdit ? "" : editMedicine.duration,
      applicationtiming: editMedicine.timing || "",
      wheretoapply: editMedicine.areaofapplication || "",
      custommessage: editMedicine.custommessage,
      sos: editMedicine.sos,
      ...(isTopicalEdit && { productQuantity: editMedicine.productQuantity || "1" })
    }];

    const inputToSave = {
      input: {
        patientid: patientId,
        doctorid: doctorId,
        appointmentid: appointmentId || null,
        medicinedetail,
        // branchid: "273",
        // hospitalid: "48"
      },
    };

    console.log("Updating medicine:", JSON.stringify(inputToSave, null, 2));

    const result = await updateDoctorNotes(inputToSave.input);
    if (result && result.output?.result === "success") {
      showSuccessToast("Medicine updated successfully.");
      
      // Update the medicine in selected medicines
      setSelectedMedicines(prev => 
        prev.map(medicine => 
          medicine.id === editMedicine.id 
            ? { 
                ...editMedicine, 
                issaved: true,
                chemical_composition: editMedicine.composition || "",
                Manufacturer: editMedicine.manufacturer || "",
                TherapeuticCategory: editMedicine.therapeutic || "",
                DrugClass: editMedicine.drugclass || "",
                startdate: editMedicine.medicationstartdate,
                enddate: editMedicine.medicationenddate,
                prescribedby: editMedicine.prescribedby || "Viggu Netha"
              }
            : medicine
        )
      );

      // Close modal
      editSelectedPrescriptionMedication.current.closeModal();
      setIsSelectedEditModalOpen(false);
      setEditMedicine(null);

      // Refresh data
      await fetchDoctorNotes();
      await fetchRecentMedicines();
      if (typeof fetchPatientHealthData === "function") {
        fetchPatientHealthData();
      }
      if (typeof fetchDoctorNotesEmptyIndication === "function") {
        fetchDoctorNotesEmptyIndication();
      }

    } else {
      showErrorToast(result?.output?.message || "Failed to update medicine.");
    }
  } catch (error) {
    console.error("Error updating medicine:", error);
    showErrorToast("An error occurred while updating medicine.");
  } finally {
    dismissLoader();
    // setIsMedicineButtonDisabled(false);
  }
};

    const [key, setKey] = useState(0); // to rerender the composition input box
    const [compositionEditKey, setCompositionEditKey] = useState(0); // to rerender the composition input box

    const fetchComposition = async (medicineName) => {
      if (!medicineName) {
        showErrorToast("Please enter medicine name first to fetch composition");
      } else {
        const inputData = {
          input: {
            name: medicineName,
          },
        };

        // console.log(inputData.input);
        showLoader();
        try {
          // showLoader();
          // console.log(inputData);
          const result = await GetAIMedicineComposition(inputData.input);
          // console.log(result, "resutl for Fetch");
          if (result) {
            showSuccessToast("Fetched Medicine composition successfully");
            handleNewMedicineChange("composition", result.chemical_composition);
            // handleNewMedicineChange("manufacturer", result.Manufacturer);
            // handleNewMedicineChange("therapeutic", result.TherapeuticCategory);
            // handleNewMedicineChange("drugclass", result.DrugClass);

            if (Array.isArray(result.Manufacturer)) {
          handleNewMedicineChange("manufacturer", result.Manufacturer.join(", "));
        } else {
          handleNewMedicineChange("manufacturer", result.Manufacturer || ""); 
        }
        if (Array.isArray(result.TherapeuticCategory)) {
          handleNewMedicineChange("therapeutic", result.TherapeuticCategory.join(", "));
        } else {
          handleNewMedicineChange("therapeutic", result.TherapeuticCategory || "");
        }
        if (Array.isArray(result.DrugClass)) {
          handleNewMedicineChange("drugclass", result.DrugClass.join(", "));
        } else {
          handleNewMedicineChange("drugclass", result.DrugClass || ""); 
        }
            // handleNewMedicineChange("custommessage", result.InstructionsOfAdministration);
            // Bind InstructionsOfAdministration
        // handleNewMedicineChange("custommessage", result.InstructionsOfAdministration || "");
        if (result.InstructionsOfAdministration) {
          handleNewMedicineChange("custommessage", result.InstructionsOfAdministration);
        }

            setKey((prevKey) => prevKey + 1);
            // handleNewMedicineChange("medicinetype", result.type);
          }
          dismissLoader();
        } catch (error) {
          console.error("Error Fetching Medicine composition:", error);
          showErrorToast(
            "An error occurred while Fetching Medicine composition"
          );
        } finally {
          dismissLoader();
        }
      }
    };

    const fetchCompositionForEdit = async (medicineName) => {
      if (!medicineName) {
        showErrorToast("Please enter medicine name first to fetch composition");
      } else {
        const inputData = {
          input: {
            name: medicineName,
          },
        };

        // console.log(inputData.input);

        showLoader();
        try {
          // console.log(inputData);
          const result = await GetAIMedicineComposition(inputData.input);
          // console.log(result);
          if (result) {
            showSuccessToast("Fetched Medicine composition successfully");
            handleEditMedicineChange(
              "composition",
              result.chemical_composition
            );
            if (Array.isArray(result.Manufacturer)) {
          handleEditMedicineChange("manufacturer", result.Manufacturer.join(", "));
        } else {
          handleEditMedicineChange("manufacturer", result.Manufacturer || ""); 
        }
        if (Array.isArray(result.TherapeuticCategory)) {
          handleEditMedicineChange("therapeutic", result.TherapeuticCategory.join(", "));
        } else {
          handleEditMedicineChange("therapeutic", result.TherapeuticCategory || "");
        }
        if (Array.isArray(result.DrugClass)) {
          handleEditMedicineChange("drugclass", result.DrugClass.join(", "));
        } else {
          handleEditMedicineChange("drugclass", result.DrugClass || ""); 
        }

        // Bind InstructionsOfAdministration
        // handleEditMedicineChange("custommessage", result.InstructionsOfAdministration || "");
        if (result.InstructionsOfAdministration) {
          handleEditMedicineChange("custommessage", result.InstructionsOfAdministration);
        }

            setCompositionEditKey((prevKey) => prevKey + 1);
            // handleNewMedicineChange("medicinetype", result.type);
          }
          dismissLoader();
        } catch (error) {
          console.error("Error Fetching Medicine composition:", error);
          showErrorToast(
            "An error occurred while Fetching Medicine composition"
          );
        } finally {
          dismissLoader();
        }

        // fetchDoctorNotes();

        // console.log("Clicked");
      }
    };

    function flipCurrentAndFilterAndTransformMedicines(input) {
      // Filter the objects where "isactive" is not available or not zero
      const filtered = input.filter(
        (item) => item.isactive === undefined || item.isactive !== 0
      );
    //  console.log(filtered, "function called");
      // Transform the filtered objects
      const transformed = filtered.map((item) => ({
        ...item,
        id: item.id, // Set id to null
        inventoryid: null, // Add inventoryid key with value null
      }));

      return transformed;
    }

    const [sortOption, setSortOption] = useState(""); // this is for sorting medicines on doctor fav panel

    //--------------------Quick Dates Set Options

    //----------Edit card
    const [intervalOption, setIntervalOption] = useState("Days");

    const [intervalValue, setIntervalValue] = useState(5); // default value of 5

    const calculateEndDate = () => {
      // if (newMedicine?.medicationstartdate && intervalOption && intervalValue) {
        if (editMedicine?.medicationstartdate && editMedicine.durationunit && editMedicine.durationvalue) {
        const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
        // const intervalMultiplier = intervalMap[intervalNewOption];
        // const daysToAdd = intervalMultiplier * intervalNewValue - 1;
        const intervalMultiplier = intervalMap[editMedicine.durationunit];
        const daysToAdd = intervalMultiplier * editMedicine.durationvalue - 1;

        // Parse start date in DD-MM-YYYY format
        let medicationStartDate = editMedicine.medicationstartdate;

        // Check if the date is in DD-MM-YYYY format, if not, convert it

        if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
          medicationStartDate =
            moment(medicationStartDate).format("DD-MM-YYYY");
        }
        const [day, month, year] = medicationStartDate.split("-").map(Number);
        const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

        startDate.setDate(startDate.getDate() + daysToAdd);

        // Format new end date as DD-MM-YYYY
        const formattedEndDate = [
          String(startDate.getDate()).padStart(2, "0"),
          String(startDate.getMonth() + 1).padStart(2, "0"),
          startDate.getFullYear(),
        ].join("-");

        // console.log(formattedEndDate);

        // Update medicationenddate in editMedicine
        setEditMedicine((prev) => ({
          ...prev,
          medicationenddate: formattedEndDate,
        }));
      }
    };

    const handleIntervalChange = (value) => {
      handleEditMedicineChange("durationunit", value);
      // Update the combined duration string
      handleEditMedicineChange("duration", `${editMedicine.durationvalue} ${value}`);
    };
    
    const handleIntervalValueChange = (e) => {
      const value = parseInt(e.target.value, 10);
      const cleanValue = isNaN(value) ? "" : value;
      handleEditMedicineChange("durationvalue", cleanValue);
      // Update the combined duration string
      handleEditMedicineChange("duration", `${cleanValue} ${editMedicine.durationunit}`);
    };
    useEffect(() => {
      if (
        editMedicine?.medicationstartdate &&
        editMedicine?.durationunit &&
        editMedicine?.durationvalue
      ) {
        calculateSelectedEndDate();
      }
    }, [
      editMedicine?.medicationstartdate,
      editMedicine?.durationunit,
      editMedicine?.durationvalue
    ]);
    
    
    const calculateSelectedEndDate = () => {
      // if (newMedicine?.medicationstartdate && intervalOption && intervalValue) {
        if (editMedicine?.medicationstartdate && editMedicine.durationunit && editMedicine.durationvalue) {
        const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
        // const intervalMultiplier = intervalMap[intervalNewOption];
        // const daysToAdd = intervalMultiplier * intervalNewValue - 1;
        const intervalMultiplier = intervalMap[editMedicine.durationunit];
        const daysToAdd = intervalMultiplier * editMedicine.durationvalue - 1;

        // Parse start date in DD-MM-YYYY format
        let medicationStartDate = editMedicine.medicationstartdate;

        // Check if the date is in DD-MM-YYYY format, if not, convert it

        if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
          medicationStartDate =
            moment(medicationStartDate).format("DD-MM-YYYY");
        }
        const [day, month, year] = medicationStartDate.split("-").map(Number);
        const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

        startDate.setDate(startDate.getDate() + daysToAdd);

        // Format new end date as DD-MM-YYYY
        const formattedEndDate = [
          String(startDate.getDate()).padStart(2, "0"),
          String(startDate.getMonth() + 1).padStart(2, "0"),
          startDate.getFullYear(),
        ].join("-");

        // console.log(formattedEndDate);

        // Update medicationenddate in editMedicine
        setEditMedicine((prev) => ({
          ...prev,
          medicationenddate: formattedEndDate,
        }));
      }
    };

    const handleIntervalNewChange = (value) => {
      handleNewMedicineChange("durationunit", value);
      // Update the combined duration string
      handleNewMedicineChange("duration", `${newMedicine.durationvalue} ${value}`);
    };
    
    const handleIntervalNewValueChange = (e) => {
      const value = parseInt(e.target.value, 10);
      const cleanValue = isNaN(value) ? "" : value;
      handleNewMedicineChange("durationvalue", cleanValue);
      // Update the combined duration string
      handleNewMedicineChange("duration", `${cleanValue} ${newMedicine.durationunit}`);
    };

    const calculateNewEndDate = () => {
      // if (newMedicine?.medicationstartdate && intervalOption && intervalValue) {
        if (newMedicine?.medicationstartdate && newMedicine.durationunit && newMedicine.durationvalue) {
        const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
        // const intervalMultiplier = intervalMap[intervalNewOption];
        // const daysToAdd = intervalMultiplier * intervalNewValue - 1;
        const intervalMultiplier = intervalMap[newMedicine.durationunit];
        const daysToAdd = intervalMultiplier * newMedicine.durationvalue - 1;

        // Parse start date in DD-MM-YYYY format
        let medicationStartDate = newMedicine.medicationstartdate;

        // Check if the date is in DD-MM-YYYY format, if not, convert it

        if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
          medicationStartDate =
            moment(medicationStartDate).format("DD-MM-YYYY");
        }
        const [day, month, year] = medicationStartDate.split("-").map(Number);
        const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

        startDate.setDate(startDate.getDate() + daysToAdd);

        // Format new end date as DD-MM-YYYY
        const formattedEndDate = [
          String(startDate.getDate()).padStart(2, "0"),
          String(startDate.getMonth() + 1).padStart(2, "0"),
          startDate.getFullYear(),
        ].join("-");

        // console.log(formattedEndDate);

        // Update medicationenddate in editMedicine
        setNewMedicine((prev) => ({
          ...prev,
          medicationenddate: formattedEndDate,
        }));
      }
    };

    useEffect(() => {
      if (newMedicine.durationunit && newMedicine.durationvalue) {
        calculateNewEndDate();
      }
    }, [newMedicine.durationunit, newMedicine.durationvalue, newMedicine?.medicationstartdate]);

    //----------------------Current card
    const [intervalCurrentOption, setIntervalCurrentOption] = useState("Days");

    const [intervalCurrentValue, setIntervalCurrentValue] = useState(5); // default value of 5

    const calculateCurrentEndDate = () => {
      // if (newMedicine?.medicationstartdate && intervalOption && intervalValue) {
        if (editCurrentMedicine?.medicationstartdate && editCurrentMedicine.durationunit && editCurrentMedicine.durationvalue) {
        const intervalMap = { Days: 1, Weeks: 7, Months: 30, Years: 365 };
        // const intervalMultiplier = intervalMap[intervalNewOption];
        // const daysToAdd = intervalMultiplier * intervalNewValue - 1;
        const intervalMultiplier = intervalMap[editCurrentMedicine.durationunit];
        const daysToAdd = intervalMultiplier * editCurrentMedicine.durationvalue - 1;

        // Parse start date in DD-MM-YYYY format
        let medicationStartDate = editCurrentMedicine.medicationstartdate;

        // Check if the date is in DD-MM-YYYY format, if not, convert it

        if (!/^\d{2}-\d{2}-\d{4}$/.test(medicationStartDate)) {
          medicationStartDate =
            moment(medicationStartDate).format("DD-MM-YYYY");
        }
        const [day, month, year] = medicationStartDate.split("-").map(Number);
        const startDate = new Date(year, month - 1, day); // JS months are 0-indexed

        startDate.setDate(startDate.getDate() + daysToAdd);

        // Format new end date as DD-MM-YYYY
        const formattedEndDate = [
          String(startDate.getDate()).padStart(2, "0"),
          String(startDate.getMonth() + 1).padStart(2, "0"),
          startDate.getFullYear(),
        ].join("-");

        // console.log(formattedEndDate);

        // Update medicationenddate in editMedicine
        setEditCurrentMedicine((prev) => ({
          ...prev,
          medicationenddate: formattedEndDate,
        }));
      }
    };
    useEffect(() => {
      if (editCurrentMedicine?.durationunit && editCurrentMedicine?.durationvalue) {
        calculateCurrentEndDate();
      }
    }, [
      editCurrentMedicine?.durationunit,
      editCurrentMedicine?.durationvalue,
      editCurrentMedicine?.medicationstartdate,
    ]);

    const handleIntervalCurrentChange = (value) => {
      handleEditCurrentMedicineChange("durationunit", value);
      // Update the combined duration string
      handleEditCurrentMedicineChange("duration", `${editCurrentMedicine.durationvalue} ${value}`);
    };
    
    const handleIntervalCurrentValueChange = (e) => {
      const value = parseInt(e.target.value, 10);
      const cleanValue = isNaN(value) ? "" : value;
      handleEditCurrentMedicineChange("durationvalue", cleanValue);
      // Update the combined duration string
      handleEditCurrentMedicineChange("duration", `${cleanValue} ${editCurrentMedicine.durationunit}`);
    };

    // new functions
    function handleSOS(e) {
      // setSOS(e.target.value)
    } 
    function handleCustomMessage(e) {
      // setCustomMessage(e.target.value)
    }

// waves 
   const recorderRef = useRef(null);
     const [chunks, setChunks] = useState([]);
       const [recording, setRecording] = useState(false);
     
    const [stream, setStream] = useState(null);

    useEffect(() => {
        if (recorderRef.current) return;
    
        if (navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
              setStream(stream);
    
              recorderRef.current = new MediaRecorder(stream);
              // audioContextRef.current = new AudioContext({
              //   sampleRate: WHISPER_SAMPLING_RATE,
              // });
    
              recorderRef.current.onstart = () => {
                setRecording(true);
                setChunks([]);
              };
              recorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) {
                  setChunks((prev) => [...prev, e.data]);
                } else {
                  setTimeout(() => {
                    recorderRef.current.requestData();
                  }, 25);
                }
              };
    
              recorderRef.current.onstop = () => {
                setRecording(false);
              };
            })
            .catch((err) => console.error("The following error occurred: ", err));
        } else {
          console.error("getUserMedia not supported on your browser!");
        }
    
        return () => {
          recorderRef.current?.stop();
          recorderRef.current = null;
        };
      }, []);
    

  // ------------------------------------
  //Remove speech and keep Null to toggle between GPU and Speech
  const [SelectedLanguage, setSelectedLanguage] = useState("en-US");
  const [inpLang, setInpLang] = useState("English");
  
  const handleChangeLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; // Get the selected language
    setInpLang(selectedLanguage)
    const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found

    // Update the language in the transcriber
    setSelectedLanguage(languageCode);
    console.log("Selected Language: ", selectedLanguage);
    console.log("Language Code: ", languageCode);
  };

  const [outLang, setOutputLang] = useState("English")
  const handleChangeOutputLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; 
    // const languageCode = languageCodeMap[selectedLanguage] || "en-US"; 

    // Update the language in the transcriber
    setOutputLang(selectedLanguage);
    console.log("Selected Language OUTPUT: ", selectedLanguage);
    // console.log("Language Code OUTPUT: ", languageCode);
  };

  //medicines related
  const [SelectedMedicineLanguage, setSelectedMedicineLanguage] = useState("en-US");
  const [inpMedicineLang, setInpMedicineLang] = useState("English");
  
  const handleMedicineChangeLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; // Get the selected language
    setInpMedicineLang(selectedLanguage)
    const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found

    // Update the language in the transcriber
    setSelectedMedicineLanguage(languageCode);
    console.log("Selected Medicine Language: ", selectedLanguage);
    console.log("Language Medicine Code: ", languageCode);
  };

  const [outMedicineLang, setOutputMedicineLang] = useState("English")
  const handleChangeMedicineOutputLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; 
    // const languageCode = languageCodeMap[selectedLanguage] || "en-US"; 

    // Update the language in the transcriber
    setOutputMedicineLang(selectedLanguage);
    console.log("Selected Language MEdicine OUTPUT: ", selectedLanguage);
    // console.log("Language Code OUTPUT: ", languageCode);
  };

  // Add this state to your parent component
  const [isRecording, setIsRecording] = useState(false);
  
  // Add this function to handle recording state changes
  const handleRecordingStateChange = (recording) => {
    setIsRecording(recording);
  };

// const activeTranscriber = useGPUTranscriber();
//Remove speech and keep Null to toggle between GPU and Speech
  const { transcriber: medicineTranscriber, mode: medicineMode } =
    useHybridTranscriber("speech", (text) => {
      // called when speech recognition finishes
      setMedicinePlaceholder(text || "");
      setMedicineTyping(false);

      if (editMedicine) {
            handleEditMedicineChange("custommessage", text);
            setMedicineValue("textField", text, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
            });
        } else if (editCurrentMedicine) {
            handleEditCurrentMedicineChange("custommessage", text);
            setMedicineValue("textField", text, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
            });
        } else {
            handleNewMedicineChange("custommessage", text);
            setMedicineValue("textField", text, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
            });
        }
  },
  SelectedMedicineLanguage);

  const [medicineTyping, setMedicineTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");

  const [medicinePlaceholder, setMedicinePlaceholder] = useState(
    // "Click anywhere to start typing...."
    "Instructions"
  );
  const { register: registerMedicines, handleSubmit: handleMedicinesSubmit, watch: watchMedicines, setValue: setMedicineValue } = useForm();

  // newly added
  useEffect(() => {
  if (medicineTranscriber?.output?.text) {
    const text = medicineTranscriber.output.text;
    setMedicinePlaceholder("Instructions");
    setMedicineTyping(false);

    if (editMedicine) {
      handleEditMedicineChange("custommessage", text);
      setMedicineValue("textField", text, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    } else if (editCurrentMedicine) {
      handleEditCurrentMedicineChange("custommessage", text);
      setMedicineValue("textField", text, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    } else {
      handleNewMedicineChange("custommessage", text);
      setMedicineValue("textField", text, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    }
  }
}, [medicineTranscriber?.output?.text]);
// }, [activeTranscriber?.output?.text, isAddModalOpen, isSelectedEditModalOpen, isCurrentEditModalOpen, setValue]);

  const medicineTextFieldValue = watchMedicines("textField", "");
    // const [isMedicineButtonDisabled, setIsMedicineButtonDisabled] = useState(false);
    // Replace the current button logic with this simpler approach
const isMedicineButtonEnabled = medicineTextFieldValue && medicineTextFieldValue.trim().length > 0;
    // const [initialMedicineText, setInitialMedicineText] = useState("");
  
    useEffect(() => {
      if (medicineTextFieldValue !== initialMedicineText) {
        // setIsMedicineButtonDisabled(false); // Enable button if text field value changes
      } else {
        // setIsMedicineButtonDisabled(true); // Disable button if text field value is unchanged
      }
      }, [medicineTextFieldValue, initialMedicineText]); 
    // }, [isMedicineButtonDisabled, initialMedicineText]);

const correctMedOrders = async (formType) => {
    // const currentText = watch("textField");
    let currentText = "";
  if (formType === "edit") {
    currentText = editMedicine?.custommessage || "";
  } else if (formType === "currentedit") {
    currentText = editCurrentMedicine?.custommessage || "";
  } else {
    currentText = newMedicine?.custommessage || "";
  }
    
    if (!currentText) {
      showErrorToast("No text available to correct");
      return;
    }

    const inputToSave = {
      input: {
        text: currentText,
        // type: `medicine_instructions#ayurvedic, Psychiatry#99#Consultation Note#Urdu#Hindi`,
        type: `medicine_instructions#${doctorSpecialties}#${doctorExperience}#Consultation Note#${inpMedicineLang}#${outMedicineLang}`,
      },
    };

    showLoader();
    try {
      const result = await CorrectMedicalTermsUsingAI(inputToSave);
      // const result = await CorrectInstructionsUsingAI(inputToSave.input);
      if (result) {
        showSuccessToast("Updated Text");
        const updatedText = result?.text;

        if (formType === "add") {
        handleNewMedicineChange("custommessage", updatedText);
        setMedicineValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      } else if (formType === "edit") {
        handleEditMedicineChange("custommessage", updatedText);
        setMedicineValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      } else if (formType === "currentedit") {
        handleEditCurrentMedicineChange("custommessage", updatedText);
        setMedicineValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      }
        
        // setIsMedicineButtonDisabled(false);
      }
    } catch (error) {
      console.error("Error in Correct AI call:", error);
      showErrorToast("Error Happened While Correcting.");
    } finally {
      dismissLoader();
    }
};

//  const addPrescriptionMedication = useRef();
//   const editSelectedPrescriptionMedication = useRef();
//   const editCurrentPrescriptionMedication = useRef();
  const prescriptionComponentRef = useRef(null);

  // keep an edit state so modals can be reused
  const [quickEditMedicine, setQuickEditMedicine] = useState(null);
  const [quickEditCurrentMedicine, setQuickEditCurrentMedicine] = useState(null);

  // Utility: transform selected medicines state to API format (same shape used in PrescriptionComponent)
  const transformSelectedMedicinesToApiInput = (meds) => {
    const todayYYYYMMDD = moment().format("YYYY-MM-DD");
    return meds
      .filter((m) => m && (m.isactive === undefined || m.isactive !== 0))
      .map((m) => ({
        id: m.id ?? null,
        medicinename: m.medicinename,
        medicinetype: m.medicinetype,
        dosage: m.dosage,
        dosageunit: m.dosageunit,
        frequency: m.frequency ?? 1,
        morning: m.morning ?? 0,
        evening: m.evening ?? 0,
        night: m.night ?? 0,
        beforefood: m.beforefood ?? 1,
        afterfood: m.afterfood ?? 0,
        startdate:
          m.medicationstartdate && moment(m.medicationstartdate, ["DD-MM-YYYY", "YYYY-MM-DD"], true).isValid()
            ? moment(m.medicationstartdate, ["DD-MM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD")
            : todayYYYYMMDD,
        enddate:
          m.medicationenddate && moment(m.medicationenddate, ["DD-MM-YYYY", "YYYY-MM-DD"], true).isValid()
            ? moment(m.medicationenddate, ["DD-MM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD")
            : moment().add(5, "days").format("YYYY-MM-DD"),
        chemical_composition: m.composition ?? m.chemical_composition ?? "",
        Manufacturer: m.manufacturer ?? "",
        TherapeuticCategory: m.therapeutic ?? "",
        DrugClass: m.drugclass ?? "",
        isactive: m.isactive === 0 ? 0 : 1,
      }));
  };

  // Save selected medicines (used by Save button) - mirrors PrescriptionComponent.saveMedicineToOrders
  const saveSelectedMedicinesToOrders = async () => {
    try {
      // disable UI if needed
      setIsButtonDisabled(true);
      showLoader();

      const medicinedetail = transformSelectedMedicinesToApiInput(selectedMedicines);
      if (medicinedetail.length === 0) {
        showErrorToast("No medicines selected to save.");
        return;
      }

      const inputToSave = {
        input: {
          patientid: patientId,
          doctorid: doctorId,
          appointmentid: appointmentId || null,
          medicinedetail,
        },
      };

      const result = await updateDoctorNotes(inputToSave.input);
      if (result && result.output?.result === "success") {
        showSuccessToast("Medicines saved to orders successfully.");
        // refresh doctor notes and related UI (same calls used elsewhere)
        await fetchDoctorNotes();
        if (typeof fetchPatientHealthData === "function") {
          fetchPatientHealthData();
        }
        if (typeof fetchDoctorNotesEmptyIndication === "function") {
          fetchDoctorNotesEmptyIndication();
        }
        // close modals if open
        addPrescriptionMedication.current?.closeRight?.();
        editSelectedPrescriptionMedication.current?.closeModal?.();
        editCurrentPrescriptionMedication.current?.closeModal?.();
      } else {
        showErrorToast(result?.output?.message || "Failed to save medicines.");
      }
    } catch (error) {
      console.error("Error saving medicines:", error);
      showErrorToast("An error occurred while saving medicines.");
    } finally {
      dismissLoader();
      setIsButtonDisabled(false);
    }
  };

  // Open Add Prescription modal (reuses existing modal refs defined in this file)
  const openAddPrescription = () => {
    // Ensure medicines are loaded before opening
    // fetchMedicines?.();
    addPrescriptionMedication.current?.openRight?.();
    setIsAddModalOpen(true);
  };

  // Open Edit modal for a selected medicine (from favourites / recent)
  const openEditSelectedMedicineModal = (medicine) => {
    setQuickEditMedicine(medicine);
    // populate edit modal state same as PrescriptionComponent expects
    handleEditMedicine?.(medicine); // if local function exists it will set edit state
    editSelectedPrescriptionMedication.current?.openModal?.();
    setIsSelectedEditModalOpen(true);
  };

  // Open Edit modal for a current patient medicine
  const openEditCurrentMedicineModal = (medicine) => {
    setQuickEditCurrentMedicine(medicine);
    handleEditCurrentMedicine?.(medicine); // reuse existing handler if present
    editCurrentPrescriptionMedication.current?.openModal?.();
    setIsCurrentEditModalOpen(true);
  };

  // Expose save function to other parts (if parent expects a ref)
  useEffect(() => {
    // if parent or other components use prescriptionComponentRef, set methods
    if (prescriptionComponentRef) {
      prescriptionComponentRef.current = {
        saveSelectedMedicinesToOrders,
        openAddPrescription,
        openEditSelectedMedicineModal,
        openEditCurrentMedicineModal,
      };
    }
  }, [selectedMedicines]);

// -------------------------- Medicines End ------------------------------------------------
// -------------------------- Labs Start ------------------------------------------------
// Add these state variables
  const [favoriteLabs, setFavoriteLabs] = useState([]);
  const [favoriteImaging, setFavoriteImaging] = useState([]);
  const [favoriteProcedures, setFavoriteProcedures] = useState([]);
  const [favoriteVaccinations, setFavoriteVaccinations] = useState([]);
  const [selectedLabs, setSelectedLabs] = useState([]);
  const [selectedImaging, setSelectedImaging] = useState([]);
  const [selectedProcedures, setSelectedProcedures] = useState([]);
  const [selectedVaccines, setSelectedVaccines] = useState([]);
  const [labSearch, setLabSearch] = useState("");
  const [labSortOption, setLabSortOption] = useState("A-Z");
  const [vaccineSearch, setVaccineSearch] = useState("");
  // Add these state variables
const [savedLabs, setSavedLabs] = useState([]);
const [savedImaging, setSavedImaging] = useState([]);
const [savedProcedures, setSavedProcedures] = useState([]);
const [savedVaccines, setSavedVaccines] = useState([]);

  // API Functions for fetching data
  const fetchFavoriteLabs = async () => {
    try {
      const result = await GetDoctorFavLab({ 
        "doctorid": "",
        "type": "lab",
        "pageno": 1,
        "pagesize": 100
      });
      
      // Transform data: map testname to subtype for UI binding
      const filteredData = (result?.data || [])
        .map(item => ({ 
          ...item, 
          subtype: item.testname,
          type: "lab",
          category: "labs" 
        }));
      
      setFavoriteLabs(filteredData);
      return filteredData;
    } catch (error) {
      console.error("Error fetching Labs data:", error);
      showErrorToast("Error fetching labs data.");
      return [];
    }
  };

  const fetchFavoriteImaging = async () => {
    try {
      const result = await GetDoctorFavLab({ 
        "doctorid": "",
        "type": "imaging",
        "pageno": 1,
        "pagesize": 100
      });
      
      // Transform data: map testname to subtype for UI binding
      const filteredData = (result?.data || [])
        .map(item => ({ 
          ...item, 
          subtype: item.testname,
          type: "imaging",
          category: "imaging" 
        }));
      
      setFavoriteImaging(filteredData);
      return filteredData;
    } catch (error) {
      console.error("Error fetching Imaging data:", error);
      showErrorToast("Error fetching imaging data.");
      return [];
    }
  };

  const fetchFavoriteProcedures = async () => {
    try {
      const result = await GetDoctorFavLab({ 
        "doctorid": "",
        "type": "procedure",
        "pageno": 1,
        "pagesize": 100
      });
      
      // Transform data: map testname to subtype for UI binding
      const filteredData = (result?.data || [])
        .map(item => ({ 
          ...item, 
          subtype: item.testname,
          type: "procedure",
          category: "procedures" 
        }));
      
      setFavoriteProcedures(filteredData);
      return filteredData;
    } catch (error) {
      console.error("Error fetching Procedures data:", error);
      showErrorToast("Error fetching procedure data.");
      return [];
    }
  };

const fetchFavoriteVaccinations = async () => {
  try {
    const result = await GetDoctorFavVaccine({ 
      "doctorid": "",
      "pageno": 1,
      "pagesize": 100
    });
    
    // console.log("Raw vaccine result:", result);
    
    // Check which vaccines are already selected/saved
    const selectedVaccineIds = new Set([
      ...selectedVaccines.map(v => v.id),
      ...savedVaccines.map(v => v.id)
    ]);

    // Transform data: map vaccinename to subtype for UI binding
    const filteredData = (result?.data || [])
      .map(item => ({ 
        ...item, 
        subtype: item.vaccinename,
        type: "vaccine",
        category: "vaccine",
        isSelected: selectedVaccineIds.has(item.id) // Mark if already selected
      }));
    
    // console.log("Transformed vaccine data:", filteredData);
    setFavoriteVaccinations(filteredData);
    return filteredData;
  } catch (error) {
    console.error("Error fetching Vaccinations data:", error);
    showErrorToast("Error fetching vaccinations data.");
    return [];
  }
};

// Combined function to fetch all favorite data
const fetchAllFavoriteData = async () => {
  showLoader();
  try {
    const [labs, imaging, vaccinations, procedures] = await Promise.all([
      fetchFavoriteLabs(),
      fetchFavoriteImaging(),
      fetchFavoriteProcedures(),
      fetchFavoriteVaccinations()
    ]);
    
    // console.log("Fetched favorite data:", { labs, imaging, vaccinations });
    // Sync selected labs with favorite labs
    // setFavoriteLabs(prevLabs => 
    //   prevLabs.map(lab => ({
    //     ...lab,
    //     // This will help with highlighting but we need to handle selection separately
    //   }))
    // );

  } catch (error) {
    console.error("Error fetching all favorite data:", error);
  } finally {
    dismissLoader();
  }
};

// Handler functions
const handleLabSelect = (lab) => {
  setSelectedLabs(prev => {
    const exists = prev.some(l => l.id === lab.id);
    if (exists) {
      return prev.filter(l => l.id !== lab.id);
    } else {
      return [...prev, lab];
    }
  });
};

const handleImagingSelect = (imaging) => {
  setSelectedImaging(prev => {
    const exists = prev.some(i => i.id === imaging.id);
    if (exists) {
      return prev.filter(i => i.id !== imaging.id);
    } else {
      return [...prev, imaging];
    }
  });
};

const handleProcedureSelect = (procedure) => {
  setSelectedProcedures(prev => {
    const exists = prev.some(i => i.id === procedure.id);
    if (exists) {
      return prev.filter(i => i.id !== procedure.id);
    } else {
      return [...prev, procedure];
    }
  });
};

// const handleVaccineSelect = (vaccine) => {
//   setSelectedVaccines(prev => {
//     const exists = prev.some(v => v.id === vaccine.id);
//     if (exists) {
//       return prev.filter(v => v.id !== vaccine.id);
//     } else {
//       return [...prev, vaccine];
//     }
//   });
// };
const handleVaccineSelect = (vaccine) => {
  console.log("Selecting vaccine:", vaccine);
  
  setSelectedVaccines(prev => {
    const exists = prev.some(v => v.id === vaccine.id);
    if (exists) {
      return prev.filter(v => v.id !== vaccine.id);
    } else {
      // Add vaccine with proper structure
      return [...prev, {
        id: vaccine.id, // Use vaccine_cd for matching
        subtype: vaccine.vaccinename || vaccine.subtype,
        type: "vaccine",
        category: "vaccine",
        vaccine_cd: vaccine.id, // Store vaccine_cd for saving
        isSaved: false
      }];
    }
  });
};

// Delete handlers
const handleLabDelete = async (lab) => {
  setSelectedLabs(prev => prev.filter(item => item.id !== lab.id));

  const savedLab = savedLabs.find(
    saved => saved.id === lab.id || (lab.orderid && saved.orderid === lab.orderid)
  )
  if(savedLab) {
    setSavedLabs(prev => prev.filter(item => item.id !== savedLab.id));
    await handleDeleteSavedLab(savedLab.orderid, savedLab.subtype);
  }
};

const handleImagingDelete = async (imaging) => {
  setSelectedImaging(prev => prev.filter(item => item.id !== imaging.id));

  const savedImagings = savedImaging.find(
    saved => saved.id === imaging.id || (imaging.orderid && saved.orderid === imaging.orderid)
  )
  if(savedImagings) {
    setSavedImaging(prev => prev.filter(item => item.id !== savedImagings.id));
    await handleDeleteSavedImaging(savedImagings.orderid, savedImagings.subtype);
  }
};

const handleProcedureDelete = async (procedure) => {
  setSelectedProcedures(prev => prev.filter(item => item.id !== procedure.id));

  const savedProcedure = savedProcedures.find(
    saved => saved.id === procedure.id || (procedure.orderid && saved.orderid === procedure.orderid)
  )
  if(savedProcedure) {
    setSavedProcedures(prev => prev.filter(item => item.id !== savedProcedure.id));
    await handleDeleteSavedProcedures(savedProcedure.orderid, savedProcedure.subtype);
  }
};

// const handleVaccineDelete = async (vaccine) => {
//   setSelectedVaccines(prev => prev.filter(item => item.id !== vaccine.id));

//   const savedVaccine = savedVaccines.find(
//     saved => saved.id === vaccine.id || (vaccine.orderid && saved.orderid === vaccine.orderid)
//   )
//   if(savedVaccine) {
//     setSavedVaccines(prev => prev.filter(item => item.id !== savedVaccine.id));
//     await handleDeleteSavedVaccine(savedVaccine.orderid, savedVaccine.subtype);
//   }
// };
const handleVaccineDelete = async (vaccine) => {
  console.log("Deleting vaccine:", vaccine);
  
  // Remove from selectedVaccines
  setSelectedVaccines(prev => prev.filter(item => item.id !== vaccine.id));

  // Check if it's a saved vaccine
  const savedVaccine = savedVaccines.find(
    saved => saved.id === vaccine.id || (vaccine.dbId && saved.dbId === vaccine.dbId)
  );
  
  if(savedVaccine) {
    // Remove from savedVaccines
    setSavedVaccines(prev => prev.filter(item => item.dbId !== savedVaccine.dbId));
    
    // Call delete API with database ID
    await handleDeleteSavedVaccine(savedVaccine.dbId || savedVaccine.orderid, savedVaccine.subtype);
  }
  
  // Refresh favorites to update checkbox state
  await fetchFavoriteVaccinations();
};

// Fetch data on component mount
useEffect(() => {
  fetchAllFavoriteData();
}, [doctorId, appointmentId]);

// Add these state variables
const [isSavingLabs, setIsSavingLabs] = useState(false);
const [isSavingImaging, setIsSavingImaging] = useState(false);
const [isSavingProcedures, setIsSavingProcedures] = useState(false);
const [isSavingVaccines, setIsSavingVaccines] = useState(false);

// Save handler functions
// const handleSaveLabs = async () => {
//   if (selectedLabs.length === 0) {
//     showErrorToast("Please select labs to save");
//     return;
//   }

//   setIsSavingLabs(true);
//   try {
//     const inputToSave = {
//       input: {
//         doctorid: doctorId,
//         patientid: patientId,
//         appointmentid: appointmentId,
//         lab: selectedLabs.map(lab => ({
//           id: lab.id,
//           entitytype: "lab",
//           ordername: lab.subtype,
//         })),
//       },
//     };

//     console.log("Saving labs:", inputToSave);
//     const result = await updateDoctorNotes(inputToSave.input);
    
//     if (result) {
//       showSuccessToast("Labs saved successfully");
//       fetchDoctorNotesEmptyIndication();
//       // Clear selected labs after successful save if needed
//       // setSelectedLabs([]);
//     }
//   } catch (error) {
//     console.error("Error saving labs:", error);
//     showErrorToast("Error happened while saving labs.");
//   } finally {
//     setIsSavingLabs(false);
//   }
// };

// const handleSaveImaging = async () => {
//   if (selectedImaging.length === 0) {
//     showErrorToast("Please select imaging to save");
//     return;
//   }

//   setIsSavingImaging(true);
//   try {
//     const inputToSave = {
//       input: {
//         doctorid: doctorId,
//         patientid: patientId,
//         appointmentid: appointmentId,
//         imaging: selectedImaging.map(imaging => ({
//           id: imaging.id,
//           entitytype: "imaging",
//           ordername: imaging.subtype,
//         })),
//       },
//     };

//     console.log("Saving imaging:", inputToSave);
//     const result = await updateDoctorNotes(inputToSave.input);
    
//     if (result) {
//       showSuccessToast("Imaging saved successfully");
//       fetchDoctorNotesEmptyIndication();
//       // Clear selected imaging after successful save if needed
//       // setSelectedImaging([]);
//     }
//   } catch (error) {
//     console.error("Error saving imaging:", error);
//     showErrorToast("Error happened while saving imaging.");
//   } finally {
//     setIsSavingImaging(false);
//   }
// };

const handleSaveVaccines = async () => {
  if (selectedVaccines.length === 0) {
    showErrorToast("Please select vaccines to save");
    return;
  }

  setIsSavingVaccines(true);
  try {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        vaccine: selectedVaccines.map(vaccine => ({
          id: vaccine.id,
          entitytype: "vaccine",
          ordername: vaccine.subtype,
        })),
      },
    };

    console.log("Saving vaccines:", inputToSave);
    const result = await updateDoctorNotes(inputToSave.input);
    
    if (result) {
      showSuccessToast("Vaccines saved successfully");
      fetchDoctorNotesEmptyIndication();
      
      // Refresh the data to get updated orders
      await fetchOrdersDoctorNotesData();
      
      // Clear selected vaccines after successful save
      setSelectedVaccines([]);
    }
  } catch (error) {
    console.error("Error saving vaccines:", error);
    showErrorToast("Error happened while saving vaccines.");
  } finally {
    setIsSavingVaccines(false);
  }
};

const transformCheckedAIOrderStateToAPIFormat = async (selectedItems) => {
      // console.log(selectedItems);
      const transformedCategories = {};

      // Mapping for category name adjustments
      const categoryMappings = {
        labs: "lab",
        procedures: "procedure",
        imaging: "imaging",
        vaccinations: "vaccination",
      };

      selectedItems.forEach((item) => {
        let categoryKey = item.category;

        if (categoryMappings[item.category]) {
          categoryKey = categoryMappings[item.category];
        }

        if (!transformedCategories[categoryKey]) {
          transformedCategories[categoryKey] = [];
        }

        transformedCategories[categoryKey].push({
          // ordername_cd: item.id,
          // entitytype: item.type,
          id: null,
          entitytype: categoryKey,
          ordername: item.name,
        });
      });

      // console.log(transformedCategories);

      return transformedCategories;
    };

    function transformMedicineSearchStateToApiInput(med) {
          // console.log(med);
          const today = moment().format("YYYY-MM-DD");
          const fiveDaysFromToday = moment().add(5, "days").format("YYYY-MM-DD");
    
          const frequency =
            med.frequency ||
            (med.morning ? 1 : 0) + (med.evening ? 1 : 0) + (med.night ? 1 : 0);
    
          return {
            id: null,
            medicinename: med.medicinename,
            medicinetype: med.medicinetype,
            dosage: med.dosage,
            dosageunit: med.dosageunit,
            startdate: today,
            enddate: fiveDaysFromToday,
            frequency: frequency,
            morning: med.morning,
            evening: med.evening,
            night: med.night,
            beforefood: med.beforefood,
            afterfood: med.afterfood,
            chemical_composition: med.composition,
            Manufacturer: med.manufacturer,
            TherapeuticCategory: med.therapeutic,
            DrugClass: med.drugclass,
            isactive: 1,
          };
        }
const transformSearchStateToAPIFormat = (selectedItems) => {
      const transformedCategories = {};

      // Mapping for category name adjustments
      const categoryMappings = {
        labs: "lab",
        procedures: "procedure",
        medicine: "medicinedetail",
        vaccinations: "vaccination",
      };

      selectedItems.forEach((item) => {
        let categoryKey = item.category;
        let entityType = item.category;

        if (categoryMappings[item.category]) {
          categoryKey = categoryMappings[item.category];
          entityType = categoryMappings[item.category];
        }

        if (!transformedCategories[categoryKey]) {
          transformedCategories[categoryKey] = [];
        }

        if (categoryKey === "medicinedetail") {
          // console.log(item);
          const transformedMedicine =
            transformMedicineSearchStateToApiInput(item);
          transformedCategories[categoryKey].push(transformedMedicine);
        } else {
          transformedCategories[categoryKey].push({
            id: item.id,
            entitytype: entityType,
            ordername: item.subtype,
          });
        }
      });

      return transformedCategories;
    };

// Combined save function using your existing transform function
const handleSaveAll = async () => {
  const allSelectedItems = [
    ...selectedLabs.map(lab => ({ ...lab, category: "labs" })),
    ...selectedImaging.map(imaging => ({ ...imaging, category: "imaging" })),
    ...selectedVaccines.map(vaccine => ({ ...vaccine, category: "vaccine" })),
  ];

  if (allSelectedItems.length === 0) {
    showErrorToast("Please select items to save");
    return;
  }
  setIsSavingLabs(true);
  setIsSavingImaging(true);
  setIsSavingProcedures(true);
  setIsSavingVaccines(true);

  try {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        ...transformSearchStateToAPIFormat(allSelectedItems),
      },
    };

    console.log("Saving all items:", inputToSave);
    const result = await updateDoctorNotes(inputToSave.input);
    
    if (result) {
      showSuccessToast("All items saved successfully");
      fetchDoctorNotesEmptyIndication();
      // Clear all selections after successful save if needed
      // setSelectedLabs([]);
      // setSelectedImaging([]);
      // setSelectedVaccines([]);
    }
  } catch (error) {
    console.error("Error saving items:", error);
    showErrorToast("Error happened while saving items.");
  } finally {
    setIsSavingLabs(false);
    setIsSavingImaging(false);
    setIsSavingProcedures(false);
    setIsSavingVaccines(false);
  }
};

useEffect(() => {
  fetchOrdersDoctorNotesData(); // Use the combined function
}, []);

// Update the fetchOrdersDoctorNotesData function to extract saved orders
const fetchOrdersDoctorNotesData = async () => {
  const inputToFetch = {
    input: {
      patientid: patientId,
      doctorid: doctorId,
      appointmentid: appointmentId,
    },
  };

  showLoader();
  try {
    const data = await GetDoctorNotes(inputToFetch.input);
    // console.log('data: ', data)
    
    // Extract and set saved orders from the API response
    const orders = data?.output?.data?.orders || {};
    console.log('orders: - 6 ', orders)
    
    // Process saved labs
    if (orders.lab && orders.lab.length > 0) {
      const savedLabsData = orders.lab.map(lab => ({
        id: lab.ordername_cd,
        subtype: lab.ordername,
        type: "Lab",
        category: "labs",
        entitytype: lab.entitytype,
        orderid: lab.orderid,
        isSaved: true
      }));
      setSavedLabs(savedLabsData);

      // Only add to selectedLabs if not already there (avoid duplicates)
  setSelectedLabs(prev => {
    const existingIds = new Set(prev.map(lab => lab.id));
    const newLabs = savedLabsData.filter(lab => !existingIds.has(lab.id));
    return [...prev, ...newLabs];
  });
      // Also add saved labs to selectedLabs for highlighting
      // setSelectedLabs(prev => {
      //   const existingIds = prev.map(lab => lab.id);
      //   const newLabs = savedLabsData.filter(lab => !existingIds.includes(lab.id));
      //   return [...prev, ...newLabs];
      // });
    } else {
      setSavedLabs([]);
    }

    // Process saved imaging
    if (orders.imaging && orders.imaging.length > 0) {
      const savedImagingData = orders.imaging.map(imaging => ({
        id: imaging.ordername_cd,
        subtype: imaging.ordername,
        type: "Imaging",
        category: "imaging",
        entitytype: imaging.entitytype,
        orderid: imaging.orderid,
        isSaved: true // Mark as saved
      }));
      setSavedImaging(savedImagingData);

      // Only add to selectedImaging if not already there (avoid duplicates)
  setSelectedImaging(prev => {
    const existingIds = new Set(prev.map(imaging => imaging.id));
    const newImaging = savedImagingData.filter(imaging => !existingIds.has(imaging.id));
    return [...prev, ...newImaging];
  });

       // Also add saved imaging to selectedImaging for highlighting
      // setSelectedImaging(prev => {
      //   const existingIds = prev.map(imaging => imaging.id);
      //   const newImaging = savedImagingData.filter(imaging => !existingIds.includes(imaging.id));
      //   return [...prev, ...newImaging];
      // });
    } else {
      setSavedImaging([]);
    }

    // Process saved procedures
    if (orders.procedure && orders.procedure.length > 0) {
      const savedProceduresData = orders.procedure.map(procedure => ({
        id: procedure.ordername_cd,
        subtype: procedure.ordername,
        type: "Procedures",
        category: "procedure",
        entitytype: procedure.entitytype,
        orderid: procedure.orderid,
        isSaved: true // Mark as saved
      }));
      setSavedProcedures(savedProceduresData);

      // Only add to selectedImaging if not already there (avoid duplicates)
  setSelectedProcedures(prev => {
    const existingIds = new Set(prev.map(procedure => procedure.id));
    const newProcedures = savedProceduresData.filter(procedure => !existingIds.has(procedure.id));
    return [...prev, ...newProcedures];
  });
    } else {
      setSavedProcedures([]);
    }

    // Process saved vaccinations (if available in future)
    if (orders.vaccinationdetail && orders.vaccinationdetail.length > 0) {
      const savedVaccinesData = orders.vaccinationdetail.map(vaccine => ({
        id: vaccine.vaccine_cd, // Use vaccine_cd as ID for checking favorites
        dbId: vaccine.id, // Store the database ID for deletion
        subtype: vaccine.vaccinename,
        type: "Vaccination",
        category: "vaccines",
        entitytype: "vaccine",
        orderid: vaccine.id, // Use vaccine.id as orderid for deletion
        vaccine_cd: vaccine.vaccine_cd,
        isSaved: true
      }));
      // const savedVaccinesData = orders.vaccinationdetail.map(vaccine => ({
      //   id: vaccine.ordername_cd,
      //   subtype: vaccine.vaccinename,
      //   type: "Vaccination",
      //   category: "vaccines",
      //   entitytype: vaccine.entitytype,
      //   orderid: vaccine.orderid,
      //   isSaved: true // Mark as saved
      // }));
      // console.log('savedVaccinesDataaaaaaaaa: ', savedVaccinesData)
      setSavedVaccines(savedVaccinesData);

      // Update selectedVaccines with saved vaccines
      setSelectedVaccines(prev => {
        const existingIds = new Set(prev.map(vaccine => vaccine.id));
        const newVaccines = savedVaccinesData.filter(vaccine => !existingIds.has(vaccine.id));
        return [...prev, ...newVaccines];
      });
    } else {
      setSavedVaccines([]);
    }

  } catch (error) {
    console.error("Error fetching Doctor Notes data:", error);
  } finally {
    dismissLoader();
  }
};

// Update save handlers to refresh data after saving
const handleSaveLabs = async () => {
  if (selectedLabs.length === 0) {
    showErrorToast("Please select labs to save");
    return;
  }

  setIsSavingLabs(true);
  try {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        lab: selectedLabs.map(lab => ({
          id: lab.id,
          entitytype: "lab",
          ordername: lab.subtype,
        })),
      },
    };

    console.log("Saving labs:", inputToSave);
    const result = await updateDoctorNotes(inputToSave.input);
    
    if (result) {
      showSuccessToast("Labs saved successfully");
      fetchDoctorNotesEmptyIndication();
      
      // Refresh the data to get updated orders
      await fetchOrdersDoctorNotesData();
      
      // Optionally clear selected labs after successful save
      setSelectedLabs([]);
    }
  } catch (error) {
    console.error("Error saving labs:", error);
    showErrorToast("Error happened while saving labs.");
  } finally {
    setIsSavingLabs(false);
  }
};

// Combined save handler for Labs and Imaging
// const handleSaveLabsAndImaging = async () => {
//   if (selectedLabs.length === 0 && selectedImaging.length === 0) {
//     showErrorToast("Please select labs or imaging to save");
//     return;
//   }

//   setIsSavingLabs(true);
//   setIsSavingImaging(true);
  
//   try {
//     const inputToSave = {
//       input: {
//         doctorid: doctorId,
//         patientid: patientId,
//         appointmentid: appointmentId,
//         lab: selectedLabs.map(lab => ({
//           id: lab.id,
//           entitytype: "lab",
//           ordername: lab.subtype,
//         })),
//         imaging: selectedImaging.map(imaging => ({
//           id: imaging.id,
//           entitytype: "imaging",
//           ordername: imaging.subtype,
//         })),
//       },
//     };

//     console.log("Saving labs and imaging:", inputToSave);
//     const result = await updateDoctorNotes(inputToSave.input);
    
//     if (result) {
//       showSuccessToast("Orders saved successfully");
//       fetchDoctorNotesEmptyIndication();
      
//       // Refresh the data to get updated orders
//       await fetchOrdersDoctorNotesData();
      
//       // Clear selected items after successful save
//       setSelectedLabs([]);
//       setSelectedImaging([]);
//     }
//   } catch (error) {
//     console.error("Error saving orders:", error);
//     showErrorToast("Error happened while saving orders.");
//   } finally {
//     setIsSavingLabs(false);
//     setIsSavingImaging(false);
//   }
// };
// Combined save handler for Medicines, Labs and Imaging
const handleSaveAllOrders = async () => {
  // Only include medicines that are not already saved
  const activeMedications = selectedMedicines.filter(med => 
    med.isactive !== 0 && !med.issaved
  );
  console.log('activeMedications: ', activeMedications)
  
  // Only include labs that are not already saved
  const unsavedLabs = selectedLabs.filter(lab => 
    !savedLabs.some(savedLab => savedLab.id === lab.id)
  );
  
  // Only include imaging that are not already saved
  const unsavedImaging = selectedImaging.filter(imaging => 
    !savedImaging.some(savedImg => savedImg.id === imaging.id)
  );

  // Only include procedures that are not already saved
  const unsavedProcedures = selectedProcedures.filter(procedure => 
    !savedProcedures.some(savedPro => savedPro.id === procedure.id)
  );

  // Only include vaccines that are not already saved
  const unsavedVaccines = selectedVaccines.filter(vaccine => 
    !savedVaccines.some(savedVacc => savedVacc.id === vaccine.id)
  );

  const hasMedications = activeMedications.length > 0;
  const hasLabs = unsavedLabs.length > 0;
  const hasImaging = unsavedImaging.length > 0;
  const hasProcedures = unsavedProcedures.length > 0;
  const hasVaccines = unsavedVaccines.length > 0;

  if (!hasMedications && !hasLabs && !hasImaging && !hasVaccines && !hasProcedures) {
    showErrorToast("Please select new medications, labs, imaging, procedures or vaccines to save");
    return;
  }

  setIsSavingLabs(true);
  setIsSavingImaging(true);
  setIsSavingProcedures(true);
  setIsSavingVaccines(true);
  
  try {
    // Prepare medications data for API - only unsaved medicines
    const medicationsData = activeMedications.map(medicine => {
      // Format dates for API
      const formatDateForAPI = (dateString) => {
        if (!dateString) return moment().format("YYYY-MM-DD");
        
        // Check if date is already in YYYY-MM-DD format
        if (moment(dateString, "YYYY-MM-DD", true).isValid()) {
          return dateString;
        }
        
        // Convert from DD-MM-YYYY to YYYY-MM-DD
        if (moment(dateString, "DD-MM-YYYY", true).isValid()) {
          return moment(dateString, "DD-MM-YYYY").format("YYYY-MM-DD");
        }
        
        // Default to today if invalid format
        return moment().format("YYYY-MM-DD");
      };

      const topicalTypes = ["Syrup", "Ointment", "Cream", "Gel"];
      const isTopicalMed = topicalTypes.includes(medicine.medicinetype);
      const normalizedQty =
        medicine.quantitytobeapplied != null &&
        String(medicine.quantitytobeapplied).trim() !== ""
          ? medicine.quantitytobeapplied
          : (isTopicalMed ? "1" : null);

      return {
        // id: medicine.id || null, // Use null for new medicines
        id: null, // Use null for new medicines
        inventoryid: medicine.inventoryid || null,
        medicinename: medicine.medicinename,
        medicinetype: medicine.medicinetype,
        dosage: medicine.dosage || "",
        dosageunit: medicine.dosageunit || "",
        startdate: formatDateForAPI(medicine.medicationstartdate),
        enddate: formatDateForAPI(medicine.medicationenddate),
        // `frequency` always comes from medicine.frequency; for topical medicines
        // this field already holds the Product Quantity chosen in the UI.
        frequency: medicine.frequency || 1,
        frequencytime: medicine.frequencytime || "",
        frequencyvalue: medicine.frequencyvalue || "",
        morning: medicine.morning ?? 1,
        afternoon: medicine.afternoon ?? 0,
        evening: medicine.evening ?? 0,
        night: medicine.night ?? 0,
        beforefood: medicine.beforefood ?? 1,
        afterfood: medicine.afterfood ?? 0,
        chemical_composition: medicine.composition || "",
        Manufacturer: medicine.manufacturer || "",
        TherapeuticCategory: medicine.therapeutic || "",
        DrugClass: medicine.drugclass || "",
        prescribedby: medicine.prescribedby || "Viggu Netha",
        isactive: 1,
        routeofadministration: medicine.routeofadministration,
        timingofinjection: medicine.timingofinjection,
        quantitytobeapplied: normalizedQty,
        areaofapplication: medicine.areaofapplication,
        diluent: medicine.diluent,
        additives: medicine.additives,
        rateofinfusionvalue: medicine.rateofinfusionvalue,
        rateofinfusionunit: medicine.rateofinfusionunit,
        duration: medicine.duration || "5 Days",
      applicationtiming: medicine.timing || medicine.applicationtiming || "",
      wheretoapply: medicine.areaofapplication || medicine.wheretoapply || "",
        custommessage: medicine.custommessage,
        sos: medicine.sos,
        productQuantity: medicine.productQuantity || (isTopicalMed ? "1" : undefined)
      };
    });

    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        ...(hasMedications && { medicinedetail: medicationsData }),
        ...(hasLabs && { 
          lab: unsavedLabs.map(lab => ({
            id: lab.id,
            entitytype: "lab",
            ordername: lab.subtype,
          }))
        }),
        ...(hasImaging && { 
          imaging: unsavedImaging.map(imaging => ({
            id: imaging.id,
            entitytype: "imaging",
            ordername: imaging.subtype,
          }))
        }),
        ...(hasProcedures && { 
          procedure: unsavedProcedures.map(procedure => ({
            id: procedure.id,
            entitytype: "procedure",
            ordername: procedure.subtype,
          }))
        }),
        // vaccines are saved via dedicated `addVaccination` API below
        // branchid: "273",
        // hospitalid: "48"
      },
    };

    console.log("Saving only NEW orders:", {
      newMedications: activeMedications.length,
      newLabs: unsavedLabs.length,
      newImaging: unsavedImaging.length,
      newVaccines: unsavedVaccines.length,
      input: inputToSave
    });

    let result = { output: { result: "success" } };

    // Call updateDoctorNotes only when there are meds/labs/imaging to save
    if (hasMedications || hasLabs || hasImaging || hasProcedures) {
      result = await updateDoctorNotes(inputToSave.input);

      if (result && result.output?.result === "success") {
        showSuccessToast("New orders saved successfully");
        fetchDoctorNotesEmptyIndication();

        // ensure productQuantity has a sensible default for new unsaved topical medicines
        if (hasMedications) {
          const topicals = ["Syrup", "Ointment", "Cream", "Gel"];
          setSelectedMedicines(prev =>
            prev.map(medicine => {
              if (topicals.includes(medicine.medicinetype) && !medicine.issaved) {
                return {
                  ...medicine,
                  productQuantity: medicine.productQuantity || "1",
                };
              }
              return medicine;
            })
          );
        }

        // Refresh the data to get updated orders
        await fetchSavedMedicines();
        await fetchOrdersDoctorNotesData();

        // Mark medicines as saved and update their state
        // if (hasMedications) {
        //   setSelectedMedicines(prev => 
        //     prev.map(medicine => {
        //       const wasSaved = activeMedications.some(savedMed => 
        //         savedMed.medicinename === medicine.medicinename &&
        //         savedMed.medicinetype === medicine.medicinetype &&
        //         savedMed.dosage === medicine.dosage &&
        //         savedMed.dosageunit === medicine.dosageunit
        //       );
              
        //       if (wasSaved) {
        //         return {
        //           ...medicine,
        //           issaved: true,
        //           isactive: 1
        //         };
        //       }
        //       return medicine;
        //     })
        //   );
        // }

        console.log("Save successful - meds/labs/imaging saved");
      } else {
        showErrorToast(result?.output?.message || "Failed to save new orders.");
      }
    } else {
      console.log("No meds/labs/imaging to save — skipping updateDoctorNotes.");
    }

    // Save vaccines via dedicated API if present
    if (hasVaccines) {
      try {
        const vaccInput = {
          patientid: patientId,
          doctorid: doctorId,
          vaccineappointmentid: appointmentId,
          vaccination: unsavedVaccines.map(v => ({
            vaccine_cd: v.vaccine_cd || v.id,
            vaccinename: v.subtype || v.vaccinename || null,
            admindate: null,
            duedate: null,
            documents: []
          }))
        };

        console.log("Saving vaccinations payload:", vaccInput);
        const vaccResult = await addVaccination(vaccInput);
        if (vaccResult && vaccResult.output?.result === "success") {
          showSuccessToast("Vaccinations saved successfully");
          await fetchOrdersDoctorNotesData();
          setSelectedVaccines([]);
        } else {
          showErrorToast(vaccResult?.output?.message || "Failed to save vaccinations.");
        }
      } catch (err) {
        console.error("Error saving vaccinations:", err);
        showErrorToast("Error happened while saving vaccinations.");
      }
    }
  } catch (error) {
    console.error("Error saving new orders:", error);
    showErrorToast("Error happened while saving new orders.");
  } finally {
    setIsSavingLabs(false);
    setIsSavingImaging(false);
    setIsSavingProcedures(false);
    setIsSavingVaccines(false);
  }
};
// Combined save handler for Medicines, Labs and Imaging
// const handleSaveAllOrders = async () => {
//   const activeMedications = selectedMedicines.filter(med => 
//     med.isactive !== 0 && !med.issaved // Only save medicines that are not already saved
//   );
//   const hasMedications = activeMedications.length > 0;
//   const hasLabs = selectedLabs.length > 0;
//   const hasImaging = selectedImaging.length > 0;

//   if (!hasMedications && !hasLabs && !hasImaging) {
//     showErrorToast("Please select medications, labs or imaging to save");
//     return;
//   }

//   setIsSavingLabs(true);
//   setIsSavingImaging(true);
  
//   try {
//     // Prepare medications data for API - only unsaved medicines
//     const medicationsData = activeMedications.map(medicine => {
//       // Format dates for API
//       const formatDateForAPI = (dateString) => {
//         if (!dateString) return moment().format("YYYY-MM-DD");
        
//         // Check if date is already in YYYY-MM-DD format
//         if (moment(dateString, "YYYY-MM-DD", true).isValid()) {
//           return dateString;
//         }
        
//         // Convert from DD-MM-YYYY to YYYY-MM-DD
//         if (moment(dateString, "DD-MM-YYYY", true).isValid()) {
//           return moment(dateString, "DD-MM-YYYY").format("YYYY-MM-DD");
//         }
        
//         // Default to today if invalid format
//         return moment().format("YYYY-MM-DD");
//       };

//       return {
//         id: medicine.id || null, // Use null for new medicines
//         inventoryid: medicine.inventoryid || null,
//         medicinename: medicine.medicinename,
//         medicinetype: medicine.medicinetype,
//         dosage: medicine.dosage || "",
//         dosageunit: medicine.dosageunit || "",
//         startdate: formatDateForAPI(medicine.medicationstartdate),
//         enddate: formatDateForAPI(medicine.medicationenddate),
//         frequency: medicine.frequency || 1,
//         frequencytime: medicine.frequencytime || "",
//         frequencyvalue: medicine.frequencyvalue || "",
//         morning: medicine.morning ?? 1,
//         afternoon: medicine.afternoon ?? 0,
//         evening: medicine.evening ?? 0,
//         night: medicine.night ?? 0,
//         beforefood: medicine.beforefood ?? 1,
//         afterfood: medicine.afterfood ?? 0,
//         chemical_composition: medicine.composition || "",
//         Manufacturer: medicine.manufacturer || "",
//         TherapeuticCategory: medicine.therapeutic || "",
//         DrugClass: medicine.drugclass || "",
//         prescribedby: medicine.prescribedby || "Viggu Netha",
//         isactive: 1,
//         routeofadministration: medicine.routeofadministration,
//         timingofinjection: medicine.timingofinjection,
//         quantitytobeapplied: medicine.quantitytobeapplied,
//         areaofapplication: medicine.areaofapplication,
//         diluent: medicine.diluent,
//         additives: medicine.additives,
//         rateofinfusionvalue: medicine.rateofinfusionvalue,
//         rateofinfusionunit: medicine.rateofinfusionunit,
//         duration: medicine.duration || "5 Days",
//         custommessage: medicine.custommessage,
//         sos: medicine.sos
//       };
//     });

//     const inputToSave = {
//       input: {
//         doctorid: doctorId,
//         patientid: patientId,
//         appointmentid: appointmentId,
//         ...(hasMedications && { medicinedetail: medicationsData }),
//         ...(hasLabs && { 
//           lab: selectedLabs.map(lab => ({
//             id: lab.id,
//             entitytype: "lab",
//             ordername: lab.subtype,
//           }))
//         }),
//         ...(hasImaging && { 
//           imaging: selectedImaging.map(imaging => ({
//             id: imaging.id,
//             entitytype: "imaging",
//             ordername: imaging.subtype,
//           }))
//         }),
//         branchid: "273",
//         hospitalid: "48"
//       },
//     };

//     console.log("Saving all orders:", inputToSave);
//     const result = await updateDoctorNotes(inputToSave.input);
    
//     if (result && result.output?.result === "success") {
//       showSuccessToast("All orders saved successfully");
//       fetchDoctorNotesEmptyIndication();
      
//       // Refresh the data to get updated orders
//       await fetchOrdersDoctorNotesData();
      
//       // Mark medicines as saved and update their state
//       if (hasMedications) {
//         setSelectedMedicines(prev => 
//           prev.map(medicine => {
//             // Check if this medicine was in the saved batch
//             const wasSaved = activeMedications.some(savedMed => 
//               savedMed.medicinename === medicine.medicinename &&
//               savedMed.medicinetype === medicine.medicinetype &&
//               savedMed.dosage === medicine.dosage &&
//               savedMed.dosageunit === medicine.dosageunit
//             );
            
//             if (wasSaved) {
//               return {
//                 ...medicine,
//                 issaved: true,
//                 isactive: 1
//               };
//             }
//             return medicine;
//           })
//         );
//       }
      
//       // Clear labs and imaging after successful save
//       if (hasLabs) setSelectedLabs([]);
//       if (hasImaging) setSelectedImaging([]);
      
//     } else {
//       showErrorToast(result?.output?.message || "Failed to save orders.");
//     }
//   } catch (error) {
//     console.error("Error saving all orders:", error);
//     showErrorToast("Error happened while saving orders.");
//   } finally {
//     setIsSavingLabs(false);
//     setIsSavingImaging(false);
//   }
// };

const handleSaveImaging = async () => {
  if (selectedImaging.length === 0) {
    showErrorToast("Please select imaging to save");
    return;
  }

  setIsSavingImaging(true);
  try {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        imaging: selectedImaging.map(imaging => ({
          id: imaging.id,
          entitytype: "imaging",
          ordername: imaging.subtype,
        })),
      },
    };

    console.log("Saving imaging:", inputToSave);
    const result = await updateDoctorNotes(inputToSave.input);
    
    if (result) {
      showSuccessToast("Imaging saved successfully");
      fetchDoctorNotesEmptyIndication();
      
      // Refresh the data to get updated orders
      await fetchOrdersDoctorNotesData();
      
      // Optionally clear selected imaging after successful save
      setSelectedImaging([]);
    }
  } catch (error) {
    console.error("Error saving imaging:", error);
    showErrorToast("Error happened while saving imaging.");
  } finally {
    setIsSavingImaging(false);
  }
};

// Add delete handlers for saved items
const handleDeleteSavedLab = async (orderId, orderName) => {
  try {
    const inputToDelete = {
      input: {
        id: orderId,
        ordername: orderName,
        isactive: 0,
        // type: "lab"
      }
    };
    
    showLoader();
    const result = await updateOrderDoctorNotes(inputToDelete.input);
    
    if (result.output.message === "Successfully Updated") {
      showSuccessToast("Lab order deleted successfully");
      // showSuccessToast(`${doctorNotesOrderType}: ${orderName} has been deleted`);
      // Refresh the data
      await fetchOrdersDoctorNotesData();
    } else {
      showErrorToast("Failed to delete lab order");
    }
  } catch (error) {
    console.error("Error deleting lab order:", error);
    showErrorToast("Error happened while deleting lab order.");
  } finally {
    dismissLoader();
  }
};

const handleDeleteSavedImaging = async (orderId, orderName) => {
  try {
    const inputToDelete = {
      input: {
        id: orderId,
        ordername: orderName,
        isactive: 0,
        // type: "imaging"
      }
    };
    
    showLoader();
    const result = await updateOrderDoctorNotes(inputToDelete.input);
    
    if (result.output.message === "Successfully Updated") {
      showSuccessToast("Imaging order deleted successfully");
      // Refresh the data
      await fetchOrdersDoctorNotesData();
    } else {
      showErrorToast("Failed to delete imaging order");
    }
  } catch (error) {
    console.error("Error deleting imaging order:", error);
    showErrorToast("Error happened while deleting imaging order.");
  } finally {
    dismissLoader();
  }
};

const handleDeleteSavedProcedures = async (orderId, orderName) => {
  try {
    const inputToDelete = {
      input: {
        id: orderId,
        ordername: orderName,
        isactive: 0,
        // type: "imaging"
      }
    };
    
    showLoader();
    const result = await updateOrderDoctorNotes(inputToDelete.input);
    
    if (result.output.message === "Successfully Updated") {
      showSuccessToast("Procedure order deleted successfully");
      // Refresh the data
      await fetchOrdersDoctorNotesData();
    } else {
      showErrorToast("Failed to delete procedure order");
    }
  } catch (error) {
    console.error("Error deleting procedure order:", error);
    showErrorToast("Error happened while deleting procedure order.");
  } finally {
    dismissLoader();
  }
};

const handleDeleteSavedVaccine = async (dbId, orderName) => {
  try {
    const inputToDelete = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        type: "vaccinations", // Use "vaccinations" not "vaccine"
        appointmentid: appointmentId,
        vaccineid: dbId, // Use the database ID (vaccine.id from orders)
        vaccineactive: 0,
        // branchid: "273",
        // hospitalid: "48"
      }
    };
    // const inputToDelete = {
    //   input: {
    //     id: orderId,
    //     ordername: orderName,
    //     isactive: 0,
    //     // type: "vaccine"
    //   }
    // };
    
    showLoader();
    // const result = await updateOrderDoctorNotes(inputToDelete.input);
    const result = await updateCondition(inputToDelete.input);
    
    if (result.output.message === "Successfully Updated") {
      showSuccessToast("Vaccine order deleted successfully");
      // Refresh the data
      await fetchOrdersDoctorNotesData();
      // Refresh favorites to update selection state
      await fetchFavoriteVaccinations();
    } else {
      showErrorToast("Failed to delete vaccine order");
    }
  } catch (error) {
    console.error("Error deleting vaccine order:", error);
    showErrorToast("Error happened while deleting vaccine order.");
  } finally {
    dismissLoader();
  }
};

// Format medicine display name
const formatMedicineName = (medicine) => {
  if (!medicine) return "";
  
  const type = medicine.medicinetype?.toLowerCase() || "";
  const name = medicine.medicinename || "";
  const dosage = medicine.dosage || "";
  const dosageUnit = medicine.dosageunit || "";
  
  let formattedName = name;
  
  // Add type prefix
  if (type.includes("tab") || type === "tablet") {
    formattedName = `Tab. ${name}`;
  } else if (type.includes("cap") || type === "capsule") {
    formattedName = `Cap. ${name}`;
  } else if (type.includes("syr") || type === "syrup") {
    formattedName = `Syr. ${name}`;
  } else if (type.includes("inj") || type === "injection") {
    formattedName = `Inj. ${name}`;
  } else if (type.includes("oint") || type === "ointment") {
    formattedName = `Oint. ${name}`;
  } else if (type.includes("crm") || type === "cream") {
    formattedName = `Crm. ${name}`;
  } else if (type.includes("gel") || type === "gel") {
    formattedName = `Gel. ${name}`;
  } else if (type.includes("foam") || type === "foam") {
    formattedName = `Foam. ${name}`;
  } else if (type.includes("lotion") || type === "lotion") {
    formattedName = `Lotion. ${name}`;
  } else if (type.includes("tube") || type === "tube") {
    formattedName = `Tube. ${name}`;
  } else if (type.includes("soap") || type === "soap") {
    formattedName = `Soap. ${name}`;
  } else if (type.includes("shampoo") || type === "shampoo") {
    formattedName = `Shampoo. ${name}`;
  } else if (type.includes("topical cleanser") || type === "topical cleanser") {
    formattedName = `Topical Cleanser. ${name}`;
  } else if (type.includes("respules") || type === "respules") {
    formattedName = `Respules. ${name}`;
  } else if (type.includes("suspension") || type === "suspension") {
    formattedName = `Suspension. ${name}`;
  } else if (type.includes("gargle") || type === "gargle") {
    formattedName = `Gargle. ${name}`;
  } else if (type.includes("powder") || type === "powder") {
    formattedName = `Powder. ${name}`;
  } else if (type.includes("ea") || type === "ea") {
    formattedName = `EA. ${name}`;
  } else if (type.includes("device") || type === "device") {
    formattedName = `Device. ${name}`;
  } else if (type.includes("box") || type === "box") {
    formattedName = `Box. ${name}`;
  } else if (type.includes("sachet") || type === "sachet") {
    formattedName = `Sachet. ${name}`;
  } else if (type.includes("custom") || type === "custom") {
    formattedName = `Custom. ${name}`;
  } else if (type.includes("inhaler") || type === "inhaler") {
    formattedName = `Inhaler. ${name}`;
  } else if (type.includes("spray") || type === "spray") {
    formattedName = `Spray. ${name}`;
  } else if (type.includes("aerosol") || type === "aerosol") {
    formattedName = `Aerosol. ${name}`;
  } else if (type.includes("shampoo") || type === "shampoo") {
    formattedName = `Shampoo. ${name}`;
  }
  
  // Add dosage if available
  if (dosage) {
    formattedName += `-${dosage}${dosageUnit}`;
  }
  
  return formattedName;
};
// -------------------------- Labs end ------------------------------------------------
// __________________________________QUICK VISIT FUNCTIONALITY END_____________________________

  //----------------------------------------AI chatbot
  const [shouldCloseSocket, setShouldCloseSocket] = useState(false);
  const [actionAccessAssigning, setActionAccessAssigning] = useState(null);
  const [ShowAssignModal , SetShowAssignModal ] = useState(false)

  const closeChatBotOnEndVisit = () => {
    setShouldCloseSocket(true);
  };

  const resetCloseSocketCommand = () => {
    setShouldCloseSocket(false);
  };

  const useGPUChatbot = !!navigator.gpu;
  // const useGPUChatbot = false;

  // --------------------------------------- dummy data---------------------------
  const doctorAssessmentData = {
    remarks: [
      "Detected cancer cells in your body.",
      "You need urgent attention.",
    ],
    doctortype: "General physician",
    doctorname: "Dr. Mahroos Ali",
    date: "10th Jan, 2023",
    doctorimage: "/assets/imgs/no-image.png",
  };

  //------------------------

  // const location = useLocation();
  // const params = new URLSearchParams(location.search);

  // const patientId = params.get("patientId");
  // const appointmentId = params.get("appointmentId");
  // const doctorId = getLoginID();

  const timeToResume = params.get("timeContinue");
  const virtualVisit = params.get("virtualVisit");

  // console.log(virtualVisit);

  // const screenType = useScreenType();

  const audioCompatibilityDemo = useRef(null);

  //------------------------------------------ Virtual Visits

  // accepting virtual visit

  const acceptvisit = async () => {
    let input = {
      doctorid: doctorId,
      patientid: patientId,
      appointmentid: appointmentId,
      completed: "1",
    };
    try {
      const result = await AcceptVisit(input);
      // console.log(result);
      // console.log(input);
      if (result != null) {
        // do nothing
        return;
      } else {
      }
    } catch (error) {
      console.error("Error in Visit details accepting visit", error);
    }
  };

  //----------------------------
  const reAssignModal = useRef();
  var [DoctorList, setDoctorList] = useState([]);
  var [DoctorListForDropdown, setDoctorListForDropdown] = useState([]);
  
    var [DefaultDoctor, setDefaultDoctor] = useState(null);
    var [IsAssign, setIsAssign] = useState(null);

  const [askDoctorAIResponse, setAskDoctorAIResponse] = useState({});
  const [askADoctorAIRAChats, setAskADoctorAIRAChats] = useState([]);
  const [saveAIAskDoctorPrescription, setSaveAIAskDoctorPrescription] =
    useState(true);

  //-----------------------Formatting AI response

  function formatAIMedications(medications) {
    return medications.map((medication) => {
      const startDate = moment().format("YYYY-MM-DD");
      const endDate = moment()
        .add(parseInt(medication.duration) - 1, "days")
        .format("YYYY-MM-DD");

      return {
        id: null,
        inventoryid: null,
        medicinename: medication.medicinename || "",
        medicinetype: "Tablet", // Assuming default
        dosage: medication.dosage || "",
        dosageunit: "mg",
        startdate: startDate,
        enddate: endDate,
        frequency: parseInt(medication.frequency) || 1,
        morning: medication.morning === "yes" ? 1 : 0,
        evening: medication.evening === "yes" ? 1 : 0,
        night: medication.night === "yes" ? 1 : 0,
        beforefood: medication.beforefood === "yes" ? 1 : 0,
        afterfood: medication.afterfood === "yes" ? 1 : 0,
        chemical_composition: medication.chemicalcomposition || "",
        prescribedby: null, // Assuming default
        isactive: 1,
      };
    });
  }

  function formatAIVitals(vitals) {
    const currentTimestamp = moment().format("YYYY-MM-DD HH:mm:ss");

    return vitals.map((vital) => ({
      vitalname: vital.name,
      vitalvalue: vital.value,
      vitalunit:
        vital.unit === "F" ? "°F" : vital.unit === "C" ? "°C" : vital.unit, // Convert "F" to "°F" and "C" to "°C"
      vitaltype_cd: "",
      vitaladdeddate: currentTimestamp,
    }));
  }

  function formatAIDiagnoses(diagnoses) {
    return diagnoses.map((item, index) => ({
      diagnosis: item.diagnosis,
      plan: item.plan,
      diagnosisid: index,
    }));
  }

  function formatAIOrders(order, order_type) {
    return order.map((item, index) => ({
      id: null,
      entitytype: order_type,
      ordername: item.name,
    }));
  }

  const saveDoctorNotesForVirtualVisit = async (AIResponse) => {
    // console.log("input to format", AIResponse)
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        physicalexamtext: {
          description: AIResponse?.assessment_plan?.physical_exam,
          type: "other",
        },
        rostext: {
          description: AIResponse?.assessment_plan?.review_of_system,
          type: "other",
        },
        medicinedetail: AIResponse?.medicines?.recommended_medicines
          ? formatAIMedications(AIResponse?.medicines?.recommended_medicines)
          : [],
        vitals: AIResponse?.vitals?.vitals
          ? formatAIVitals(AIResponse?.vitals?.vitals)
          : [],
        doctorsassessment: AIResponse?.assessment_plan?.assessment_plan
          ? formatAIDiagnoses(AIResponse?.assessment_plan?.assessment_plan)
          : [],
        procedure: AIResponse?.procedures?.recommended_procedures
          ? formatAIOrders(
              AIResponse?.procedures?.recommended_procedures,
              "procedure"
            )
          : [],
        lab: AIResponse?.labs?.recommended_lab
          ? formatAIOrders(AIResponse?.labs?.recommended_lab, "lab")
          : [],
        imaging: AIResponse?.imaging?.recommended_imaging
          ? formatAIOrders(AIResponse?.imaging?.recommended_imaging, "imaging")
          : [],
      },
    };
    showLoader();
    // console.log(inputToSave.input);
    try {
      console.log();
      const result = await updateDoctorNotes(inputToSave.input);
      if (result) {
        showSuccessToast("AI Notes Saved successfully");
        setSaveAIAskDoctorPrescription(false);
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      dismissLoader();
    }
  };

  // ----------------------------------------- tabs section--------------------------------------

  const patientOverviewTabs = [
    "Overview",
    "Past Visits",
    "Vitals",
    "Medications",
    "Medical History",
    "Surgical History",
    "Family History",
    "Social History",
    // "Physical Exam", // THESE WILL NOT BE THERE IN PATIENT CURRENT VISIT OVERVIEW PANEL
    // "Treatment Plan", // THESE WILL NOT BE THERE IN PATIENT CURRENT VISIT OVERVIEW PANEL
    // "ROS", // THESE WILL NOT BE THERE IN PATIENT CURRENT VISIT OVERVIEW PANEL
    "Allergies",
    "Vaccinations",
    "Investigations",
    "Lab Tests",
    "Imaging Reports",
  ];

  const patientPastVisitTabs = [
    "Overview",
    "Vitals",
    "Medications",
    "Medical History",
    "Surgical History",
    "Family History",
    "Social History",
    "Physical Exam",
    "Treatment Plan",
    "ROS",
    "Allergies",
    "Vaccinations",
    "Investigations",
    "Lab Tests",
    "Imaging Reports",
  ];

  const [selectedPatientTabIndex, setSelectedPatientTabIndex] = useState(0);
  const tabListRef = useRef(null);

  const [viewPastVisitTabs, setViewPastVisitTabs] = useState(false);
  const [pastVisitTabsHeader, setPastVisitTabsHeader] = useState("");

  useEffect(() => {
    // Ensure the initial scroll position shows the very first tab
    if (tabListRef.current) {
      tabListRef.current.scrollTo({ left: 0, behavior: "smooth" });
    }
  }, []);

  const handlePatientTabClick = (index) => {
    setSelectedPatientTabIndex(index);
  };

  const scrollLeft = () => {
    if (tabListRef.current) {
      tabListRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (tabListRef.current) {
      tabListRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const handlePastVisitClick = async (appointmentid, date) => {
    // console.log("Appointment ID:", appointmentid);
    const formattedDate = moment(date).format("DD MMM, YYYY");
    const newHeader = `${formattedDate} - Visit`;
    setPastVisitTabsHeader(newHeader);
    setViewPastVisitTabs(true); // sets to true
    setSelectedPatientTabIndex(0);
    const inputData = {
      patientid: patientId,
      appointmentid: appointmentid.toString(), // pass appointment id here
      doctorid: doctorId,
    };

    // Fetch data directly with the constructed input data
    await fetchPatientSelectedVisitData(inputData, date);
  };

  const goToPatientCurrentVisit = (isVisible) => {
    setViewPastVisitTabs(isVisible);
    setSelectedPatientTabIndex(1); // 1 index is of past visit tab in patient overview of current visit
  };

  const doctorNoteTabs = [
    { name: "Chief complaint", id: 16, tabindex: 0 },
    { name: "HPI", id: 17, tabindex: 1 },
    { name: "ROS", id: 18, tabindex: 2 },
    { name: "Vitals", id: 19, tabindex: 3 },
    { name: "Physical Exam", id: 20, tabindex: 4 },
    { name: "Assessment", id: 21, tabindex: 5 },
    { name: "Orders", id: 22, tabindex: 6 },
    { name: "Documents", id: 23, tabindex: 7 },
  ];

  // Map to get the complete objects of accessible tabs
  const accessibleTabNames = doctorNoteTabs
    .filter((tab) => actionAccessMain(tab.id)?.read) // Check if the user has read access for the tab
    .map((tab) => tab); // This will return the entire tab object

  const [selectedDoctorTabIndex, setSelectedDoctorTabIndex] = useState(
    accessibleTabNames.length > 0 ? accessibleTabNames[0].tabindex : 0
  );

  // const [submitChiefComplaintTab, setSubmitChiefComplaintTab] = useState(false);
  const [submitHPITab, setSubmitHPITab] = useState(false);
  const [submitRosTab, setRosTab] = useState(false);
  // const [submitVitalsTab, setVitalsTab] = useState(false);
  const [submitPhysicalExamTab, setPhysicalExamTab] = useState(false);
  // const [submitAssessmentTab, setAssessmentTab] = useState(false);


  const doctorTabListRef = useRef(null);
  // const handleDoctorTabClick = (index) => {

  //   // when switched to other tabs, first submit current tab using below props, then after 10ms switch to the selected tab
  //   if(index != 0){
  //     setSubmitChiefComplaintTab(true)
  //   }
  //   if(index != 1){
  //     setSubmitHPITab(true)
  //   }
  //   if(index != 2){
  //     setRosTab(true)
  //   }
  //   if(index != 3){
  //     setVitalsTab(true)
  //   }
  //   if(index != 4){
  //     setPhysicalExamTab(true)
  //   }
  //   if(index != 5){
  //     setAssessmentTab(true)
  //   }
  //   setTimeout(() => {
  //     setSelectedDoctorTabIndex(index); // switch to the tab clicked

  //     // set all values to false after switching to the tab
  //     setSubmitChiefComplaintTab(false)
  //     setSubmitHPITab(false)
  //     setRosTab(false)
  //     setVitalsTab(false)
  //     setPhysicalExamTab(false)
  //     setAssessmentTab(false)
  //   }, 10);
  // };
  useEffect(() => {
    // Ensure the initial scroll position shows the very first tab
    if (doctorTabListRef.current) {
      doctorTabListRef.current.scrollTo({ left: 0, behavior: "smooth" });
    }
  }, []);

  const scrollDoctorTabsLeft = () => {
    if (doctorTabListRef.current) {
      doctorTabListRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollDoctorTabsRight = () => {
    if (doctorTabListRef.current) {
      doctorTabListRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const showEmptyIndicator = false;

  // existing function
  function checkDataPresence(data) {
    console.log('data: : : ', data)
    return {
      "Chief complaint": !!data.chiefcomplaint.chiefcomplaint,
      HPI:
        (Array.isArray(data.historyofpresentillness) &&
          data.historyofpresentillness.length > 0) ||
        !!data.hpitext?.description,
      ROS: Array.isArray(data.reviewofsystem) && data.reviewofsystem.length > 0,
      Vitals: Array.isArray(data.vitals) && data.vitals.length > 0,
      "Physical Exam":
        Array.isArray(data.physicalexam) && data.physicalexam.length > 0,
      Assessment:
        Array.isArray(data.doctorsassessment) &&
        data.doctorsassessment.length > 0,
      Orders:
        !!data.orders &&
        (data.orders.lab ||
          data.orders.imaging ||
          data.orders.procedure ||
          data.orders.medication),
    };
  }

  // newly added function
//   function checkDataPresence(data) {
//   // Return default empty object if no data
//   if (!data) {
//     return {
//       "Chief complaint": false,
//       HPI: false,
//       ROS: false,
//       "Vitals": false,
//       "Physical Exam": false,
//       "Assessment": false,
//       "Orders": false
//     };
//   }

//   return {
//     "Chief complaint": !!data?.chiefcomplaint?.chiefcomplaint, // Safe null checking
//     HPI:
//       (Array.isArray(data?.historyofpresentillness) &&
//         data.historyofpresentillness.length > 0) ||
//       !!data?.hpitext?.description,
//     ROS: Array.isArray(data?.reviewofsystem) && data.reviewofsystem.length > 0,
//     "Vitals": Array.isArray(data?.vitals) && data.vitals.length > 0,
//     "Physical Exam": Array.isArray(data?.physicalexam) && data.physicalexam.length > 0,
//     "Assessment": Array.isArray(data?.doctorsassessment) && data.doctorsassessment.length > 0,
//     "Orders":
//       !!data?.orders &&
//       (data.orders.lab ||
//         data.orders.imaging ||
//         data.orders.procedure ||
//         data.orders.medication),
//   };
// }

  const [doctorNotesEmptyMapping, setDoctorNotesEmptyMapping] = useState({});
  // Add new state for doctor experience
const [doctorExperience, setDoctorExperience] = useState("");
const [doctorSpecialties, setDoctorSpecialties] = useState("");

// Update the getDoctorSpecialties function to handle doctorspecialitylist
const getDoctorSpecialties = (specialtiesArray) => {
  if (!specialtiesArray || !Array.isArray(specialtiesArray) || specialtiesArray.length === 0) {
    return "";
  }
  
  const specialties = specialtiesArray.map(speciality => {
    if (speciality.specialityname === "Other" && speciality.othervalue) {
      return speciality.othervalue;
    }
    return speciality.specialityname;
  });
  
  return specialties.join(", ");
};

// Update the getDoctorDetails function to handle the new data structure
const getDoctorDetails = (info) => {
  if (!info) return { specialties: "", experience: "" };
  
  // Get specialties from doctorspecialitylist
  const specialties = getDoctorSpecialties(info.doctorspecialitylist);
  
  // Get experience
  const experience = info.experience || "";
  
  return { specialties, experience };
};

  const fetchDoctorNotesEmptyIndication = async () => {
    const inputToFetch = {
      input: {
        patientid: patientId,
        doctorid: doctorId,
        appointmentid: appointmentId,
      },
    };

    // showLoader();
    try {
      const result = await GetDoctorNotes(inputToFetch.input);
      // console.log(result?.output?.data, "fetchDoctorNotesEmptyIndication data");
      const data = result?.output?.data;
      setIsAssign(data?.isassign)
      const emptyMapping = checkDataPresence(data);
      // console.log(emptyMapping)
      setDoctorNotesEmptyMapping(emptyMapping);
      // Extract experience and specialties from the info object
    if (data?.info) {
      const doctorDetails = getDoctorDetails(data.info);
      
      // Set experience state
      setDoctorExperience(doctorDetails.experience);
      
      // Set specialties state
      setDoctorSpecialties(doctorDetails.specialties);
      
      // console.log("Doctor experience:", doctorDetails.experience);
      // console.log("Doctor specialties:", doctorDetails.specialties);
    }

      if (virtualVisit) {
        setAskADoctorAIRAChats(
          data?.virtualappointmentchatresults
            ? data?.virtualappointmentchatresults
            : []
        );
      }
    } catch (error) {
      console.error("Error fetching Doctor Notes data:", error);
    } finally {
      // dismissLoader();
    }
  };

  useEffect(() => {
    fetchDoctorNotesEmptyIndication();
  }, []);

  //--------------------------------------------------------------------------

  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { isSecondLoading, showSecondLoader, dismissSecondLoader } =
    useSecondLoader();
  const { showSuccessToast, showErrorToast } = QuickViewToaster();

  //---------------------------------Patient Entire Health Data Section - FOR PATIENT CURRENT VISIT-----------------------------------

  // Define state to store formatted input data - FOR PATIENT CURRENT VISIT
  const [patientHealthData, setPatientHealthData] = useState(null);
  const [navHeaderOverviewData, setNavHeaderOverviewData] = useState(null);

  // Define state to store input data - FOR PATIENT CURRENT VISIT
  const [inputData, setInputData] = useState({
    patientid: patientId,
    // appointmentid: appointmentId,
    doctorid: doctorId,
  });
  const [patientCountryId, setPatientCountryId] = useState(null);
  const [vaccinesRelatedData, setVaccinesRelatedData] = useState(null);
const [isPatientOver12, setIsPatientOver12] = useState(false);
const [patientDob, setPatientDob] = useState(null);

  // Function to fetch patient entire health data and update state - FOR PATIENT CURRENT VISIT
  const fetchPatientHealthData = async () => {
    showLoader();
    try {
      const data = await GetPatientHealthData(inputData);
      // console.log(data, 'check family data');
      if(data && data.patientinfo && data.patientinfo.countryid) {
        setPatientCountryId(data.patientinfo.countryid)
      }
      if(data && data.patientinfo && data.patientinfo.dob) {
        setPatientDob(data.patientinfo.dob);
        // Calculate age when setting DOB
        const age = calculateAge(data.patientinfo.dob);
        setIsPatientOver12(age > 12);
      }
      // console.log(data.patientinfo.countryid, "counrtyr id")
      setPatientHealthData(data);
      setVaccinesRelatedData(data.vaccinationchart)
    } catch (error) {
      console.error("Error fetching patient health data:", error);
    } finally {
      dismissLoader();
    }
  };

  /// Call fetchPatientHealthData function whenever inputData or formattedInput changes
  useEffect(() => {
    fetchPatientHealthData();
  }, [inputData]);

  function calculateAge(dob) {
    if (!dob) {
      return "";
    }

    const dobDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - dobDate.getFullYear();
    const monthDifference = today.getMonth() - dobDate.getMonth();
    const dayDifference = today.getDate() - dobDate.getDate();

    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age;
  }

  function formatHeightNumber(input) {
    const parts = input.toString().split(".");
    return {
      height: parts[0], // Whole number (integer part)
      subHeight: parts[1]?.padEnd(2, "0") || "0", // Decimal part (padded to 2 digits)
    };
  }

  useEffect(() => {
    // if (patientHealthData) {
      if (patientHealthData?.patientinfo) {
      const {
        gender,
        dob,
        bloodtype,
        countrycode,
        mobileno,
        height,
        heightunit,
        weight,
        weightunit,
        bmi,
      } = patientHealthData.patientinfo;
      // } = patientHealthData.patientinfo || {};

      const formattedGender = gender
        ? gender.charAt(0).toUpperCase() + gender.slice(1)
        : null;
      const dobInYears = dob ? calculateAge(dob) : null;
      const formattedBloodType = bloodtype || null;
      const formattedCountryCode = countrycode || null;
      const formattedMobileNo = mobileno || null;
      const formattedHeight =
        height && heightunit ? `${height} ${heightunit}` : null;
      const formattedWeight =
        weight && weightunit ? `${weight} ${weightunit}` : null;
      const formattedBMI = bmi || null;

      const overviewData = [
        formattedGender,
        dobInYears ? `${dobInYears} years` : null,
        formattedBloodType,
        formattedCountryCode && formattedMobileNo
          ? `(${formattedCountryCode}) ${formattedMobileNo}`
          : null,
        formattedHeight,
        formattedWeight,
        formattedBMI ? `${formattedBMI} BMI` : null,
      ]
        .filter((item) => item !== null)
        .join(", ");

      setNavHeaderOverviewData(overviewData);
    }
  }, [patientHealthData]);

  // Function to handle changes in input data
  const handleInputChange = (propertyName, value) => {
    setInputData((prevInputData) => ({
      ...prevInputData,
      [propertyName]: value,
    }));
  };

  //---------------------------------Patient Entire Health Data Section - FOR PATIENT SELECTED PAST VISIT-----------------------------------

  // Define state to store formatted input data - FOR PATIENT SELECTED PAST VISIT
  const [patientSelectedVisitHealthData, setPatientSelectedVisitHealthData] =
    useState(null);

  const fetchPatientSelectedVisitData = async (inputData, visitDate) => {
    showLoader();
    try {
      // console.log(inputData);
      const data = await GetPatientSelectedVisitData(inputData, visitDate);
      setPatientSelectedVisitHealthData(data);
      console.log('GetPatientSelectedVisitData', GetPatientSelectedVisitData)
      // console.log(data.socialhistory);
    } catch (error) {
      console.error(
        "Error fetching patient health data for selected past visit:",
        error
      );
    } finally {
      dismissLoader();
    }
  };

  //---------------------------------Timer Section-----------------------------------
  // const navRef = useRef();

  // const handleClick = (action) => {
  //   if (navRef.current) {
  //     navRef.current[action]();
  //   } else {
  //     console.error(`navRef is null. Cannot perform action: ${action}`);
  //   }
  // };

  // // Start the timer when the component mounts
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (navRef.current) {
  //       handleClick("start");
  //     }
  //   }, 2500); // Adjust the delay as needed

  //   // Cleanup function to clear the timeout if the component unmounts
  //   return () => clearTimeout(timer);
  // }, []);

  const navRef = useRef();

  const handleClick = (action) => {
    if (navRef.current) {
      navRef.current[action]();
    } else {
      console.error(`navRef is null. Cannot perform action: ${action}`);
    }
  };

  // Start the timer when the component mounts
  useEffect(() => {
    const interval = setInterval(() => {
      // console.log("attempt made");
      if (navRef.current) {
        handleClick("start");
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  //----------------------Refresh doctor notes from patient medication - on add to orders
  const medicationComponentRef = useRef();

  const handleRefreshDoctorNotes = () => {
    if (medicationComponentRef.current) {
      medicationComponentRef.current.updateOrderFromPatientMedication();
    }
  };

  //---------------------------------Add Medical Condition and Surgeries if they don't exist-------

  const NoMedicalConditionAdd = useRef();
  const NoMedicationAdd = useRef();
  const NoSurgeryAdd = useRef();
  const NoAllergeAdd = useRef();
  const NoSocialHistoryAdd = useRef();
  const NoVaccineAdd = useRef();
  const NoInvestigationAdd = useRef();

  const handleAddMedicalConditionModal = () => {
    if (NoMedicalConditionAdd.current) {
      console.log("calling");
      NoMedicalConditionAdd.current.openFromStartVisitOverview();
    } else {
      console.log("Not available");
    }
  };

  const handleAddMedicationModal = () => {
    if (NoMedicationAdd.current) {
      // console.log("calling");
      NoMedicationAdd.current.openFromStartVisitOverview();
    } else {
      console.log("Not available");
    }
  };

  const handleAddSurgeryConditionModal = () => {
    if (NoSurgeryAdd.current) {
      NoSurgeryAdd.current.openFromStartVisitOverview();
    }
  };

  const handleAddAllergyConditionModal = () => {
    if (NoAllergeAdd.current) {
      NoAllergeAdd.current.openFromStartVisitOverview();
    }
  };

  const handleAddVaccinationConditionModal = () => {
    if (NoVaccineAdd.current) {
      NoVaccineAdd.current.openFromStartVisitOverview();
    }
  };

  const handleAddInvestigationConditionModal = () => {
    if (NoInvestigationAdd.current) {
      NoInvestigationAdd.current.openFromStartVisitOverview();
    }
  };

  const handleAddSocialHistoryConditionModal = () => {
    if (NoSocialHistoryAdd.current) {
      NoSocialHistoryAdd.current.openFromStartVisitOverview();
    }
  };

  //---------------------------------Doctor Notes Search Section-----------------------------------
  const doctorNotesSearchOverlay = createRef();

  const openSearchPanel = () => {
    if (doctorNotesSearchOverlay.current) {
      doctorNotesSearchOverlay.current.openSearchOverlay();
    }
  };

  const [triggerAssessmentPlans, setTriggerAssessmentPlans] = useState(false);
  const [triggerRecommendMedicines, setTriggerRecommendMedicines] =
    useState(false);

  //---------------------------AIRA assist
  const openAssistPanel = () => {
    if (selectedDoctorTabIndex === 5) {
      setTriggerAssessmentPlans(true);
    }
    if (selectedDoctorTabIndex === 6) {
      setTriggerRecommendMedicines(true);
    }
  };

  // Reset triggers after they are handled
  useEffect(() => {
    if (triggerAssessmentPlans) {
      setTriggerAssessmentPlans(false);
    }
  }, [triggerAssessmentPlans]);

  useEffect(() => {
    if (triggerRecommendMedicines) {
      setTriggerRecommendMedicines(false);
    }
  }, [triggerRecommendMedicines]);

  //-------------------------AIRA Notes Transcription
  const airaTranscribeNotes = useRef(null);
  const airaTranscribeNotesForMobile = useRef(null);

  const handleAIRANotesClick = () => {
    if (!useGPUChatbot) {
      // Case 1: If useGPUChatbot is false
      airaTranscribeNotes.current.openModal();
    } else {
      // Case 2: If useGPUChatbot is true
      const capableGPU = localStorage.getItem("capableGPU");
      console.log("capableGPU is set to", capableGPU);
      
      // newly added block
      if (capableGPU === null || capableGPU === "false") {
      // Do NOT trigger audioCompatibilityDemo if "false"
      airaTranscribeNotes.current.openModal();
      } else {
        airaTranscribeNotes.current.openModal();
      }

      // existing block of code
      // if (capableGPU === null) {
      //   // If capableGPU does not exist
      //   audioCompatibilityDemo.current.openModal();
      // } else {
      //   // If capableGPU exists (either "true" or "false")
      //   airaTranscribeNotes.current.openModal();
      // }
    }
  };

  const handleAIRANotesClickForMobile = () => {
    airaTranscribeNotesForMobile.current.openModal();
  };

  //-------------------------------Sidebar Visit Interrupt
  const handleSidebarClick = (url) => {
    // console.log("Navigating to:", url);
    if (navRef.current) {
      navRef.current.openInterruptModalWithUrl(url);
    }
  };

  //---------------------------------Render Section-----------------------------------

  // useEffect(() => {
  //   if (!patientHealthData) {
  //     console.log("showing loader");
  //     showSecondLoader();
  //   } else {
  //     console.log("removing loader");
  //     dismissSecondLoader();
  //   }

  //   // Cleanup function to dismiss loader if component is unmounted
  //   return () => dismissSecondLoader();
  // }, [patientHealthData]);

  if (!patientHealthData) {
    return <Loader miniLoader={false} />;
  }
  // if (!patientSelectedVisitHealthData) {
  //   return null;
  // }

  //---------------------------------Render Section-----------------------------------


  // re assign Functionality start   ||--
  

    
    const handleReAssign = async () => {
      SetShowAssignModal(false);
      setTimeout(() => SetShowAssignModal(true), 10);
    }
  // re assign Functionality End   --||

  const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};

  const tableHeaders = [
    { label: "Age", key: "age" },
    { label: "Vaccines", key: "vaccines" },
    { label: "Trade Name", key: "tradeName" },
    { label: "Due Date", key: "dueDate" },
    { label: "Given Date", key: "givenDate" },
    { label: "Wt", key: "wt" },
    { label: "HC", key: "hc" },
    { label: "Lt", key: "lt" },
    { label: "Sign", key: "sign" }
  ];

  return (
    <>
      {isSecondLoading && <Loader miniLoader={false} />}

      {screenType == "web" ? (
        <Box w="100%" h="100vh">
          <Flex>
            <Box w="6rem">
              <MiniSideBar
                clickAction={true}
                invokeOnClick={handleSidebarClick}
              />
            </Box>
            <Box w="100%">
              <PatientVisitNav
                ref={navRef}
                patientName={`${patientHealthData?.patientinfo?.firstname ?? ""} ${
                  patientHealthData?.patientinfo?.lastname ?? ""
                }`.trim()}
                // patientName={
                //   patientHealthData?.patientinfo?.firstname +
                //   " " +
                //   patientHealthData?.patientinfo?.lastname
                // }
                patientImage={
                  patientHealthData?.patientinfo?.patientimage
                    ? patientHealthData?.patientinfo?.patientimage.startsWith(
                        "http"
                      )
                      ? patientHealthData?.patientinfo?.patientimage
                      : patientHealthData?.patientinfo?.imagepath +
                        patientHealthData?.patientinfo?.patientimage
                    : "/assets/imgs/no-image.png"
                }
                hasImage={patientHealthData?.patientinfo?.patientimage}
                patientInfoId={
                  patientHealthData?.patientinfo?.uniqueid
                    ? "#" + patientHealthData.patientinfo.uniqueid
                    : ""
                }
                subHeader={navHeaderOverviewData}
                doctorId={doctorId}
                pateintId={patientId}
                appointmentId={appointmentId}
                time={timeToResume}
                showSuccessToast={showSuccessToast}
                showErrorToast={showErrorToast}
                showLoader={showLoader}
                dismissLoader={dismissLoader}
                virtualVisit={virtualVisit}
                IsAssign={IsAssign}
              />
              <Flex w="calc(100vw - 6rem)" h="calc(100vh - 5rem)">
                {/* Left Panel */}
                {/* Left Panel */}
<Box width="30%" position="relative">
  {/* Patient Panel */}
  <Flex direction="column" h="100%" overflow="hidden">
    {/* Scrollable Content Area */}
    <Box 
      flex="1" 
      overflowY="auto" 
      bg="#fcfcfd"
      css={{
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#c1c1c1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#a8a8a8',
        }
      }}
    >
      {/* Single Combined Section for CC, HPI & Vitals */}
      <Box bg="#fcfcfd">
        <GrayCardQuickPrescription
          hasFooter={false}
          bodyStyle={{ p: "0" }}
          hasHeader={true}
          cardHeader={
            <Flex justifyContent="space-between" alignItems="center" width="100%">
              <Heading textTransform="uppercase" fontSize="12px" fontWeight="600">
                Record CC, HPI, Vitals, Assessment:
              </Heading>
            </Flex>
          }
          cardBody={
            <Box width="100%" p={2}>
  <form onSubmit={handleCombinedNotesSubmit}>
    <VStack spacing={3} width="100%">
      
      {/* AI Suggestions Section - Show saved data */}
{(aiSuggestions || (savedCc || savedHpi || savedVitals)) && (
  <Box width="100%" bg="blue.50" p={3} borderRadius="md" border="1px solid" borderColor="blue.200">
    <Flex justifyContent="space-between" alignItems="center" mb={2}>
      <Text fontWeight="600" fontSize="sm" color="blue.700">
        {aiSuggestions ? "AI Suggestions" : "Saved Data"} (Click to edit in textarea)
      </Text>
      <IconButton
        aria-label="Refresh saved data"
        icon={<FaSync />}
        size="sm"
        isLoading={isAiLoading}
        onClick={() => {
          fetchAllDoctorNotesData(); // Refresh from API
          showSuccessToast("Data refreshed");
        }}
        variant="ghost"
      />
    </Flex>
    
    
{(aiSuggestions?.cc || savedCc) && (
  <Box mb={2}>
    <Flex alignItems="center" gap={2} mb={1}>
      <Text fontSize="xs" fontWeight="600" color="gray.600">CC:</Text>
      <IconButton
        aria-label="Edit CC in textarea"
        icon={<FaEdit />}
        size="xs"
        onClick={() => handleEditSection('cc')}
        variant="ghost"
      />
    </Flex>
    <Text fontSize="xs" color="gray.700">{aiSuggestions?.cc || savedCc}</Text>
  </Box>
)}

{(aiSuggestions?.hpi || savedHpi) && (
  <Box mb={2}>
    <Flex alignItems="center" gap={2} mb={1}>
      <Text fontSize="xs" fontWeight="600" color="gray.600">HPI:</Text>
      <IconButton
        aria-label="Edit HPI in textarea"
        icon={<FaEdit />}
        size="xs"
        onClick={() => handleEditSection('hpi')}
        variant="ghost"
      />
    </Flex>
    <Text fontSize="xs" color="gray.700">{aiSuggestions?.hpi || savedHpi}</Text>
  </Box>
)}

{(aiSuggestions?.vitals || savedVitals) && (
  <Box>
    <Flex alignItems="center" gap={2} mb={1}>
      <Text fontSize="xs" fontWeight="600" color="gray.600">Vitals:</Text>
      <IconButton
        aria-label="Edit Vitals in modal"
        icon={<FaEdit />}
        size="xs"
        onClick={() => {
          const vitalsText = aiSuggestions?.vitals || savedVitals;
          openVitalsModal(vitalsText);
        }}
        variant="ghost"
      />
    </Flex>
    <Text fontSize="xs" color="gray.700">{aiSuggestions?.vitals || savedVitals}</Text>
  </Box>
)}
  </Box>
)}
      
      {/* Combined Text Area */}
<Box width="100%" position="relative">
  <Textarea
  value={combinedNotes}
  onChange={(e) => {
    const text = e.target.value;
    setCombinedNotes(text);
    
    // Only update transcriptionText if user is manually typing AND we're not in edit mode
    if (!notesTyping && text.trim() && !editingSection) {
      // Check if this is structured AI suggestions or raw text
      const isStructuredText = text.includes('Chief Complaint:') || 
                              text.includes('History of Present Illness:') || 
                              text.includes('Vitals:');
      
      if (!isStructuredText) {
        setTranscriptionText(text.trim());
      }
    }
  }}
  height="200px"
  placeholder={notesPlaceholder}
  resize="none"
  border="1px solid #e2e8f0"
  borderRadius="10px"
  bg="white"
  fontSize="14px"
  _focus={{
    borderColor: "blue.400",
    boxShadow: "0 0 0 1px blue.400"
  }}
  disabled={notesTyping}
/>
{editingSection && (
  <IconButton
    aria-label="Cancel editing"
    icon={<FaTimes />}
    size="sm"
    position="absolute"
    bottom="10px"
    right="10px"
    onClick={cancelEditing}
    variant="ghost"
    colorScheme="red"
    title="Clear text"
  />
)}
{/* {editingSection && (
  <IconButton
    aria-label="Cancel editing"
    icon={<FaTimes />}
    position="absolute"
    bottom="10px"
    right="10px"
    size="sm"
    onClick={() => {
      setEditingSection(null);
      setSectionBeingEdited(null);
      // Restore full notes view
      if (aiSuggestions) {
        const formattedText = formatAISuggestionsForTextarea(aiSuggestions);
        setCombinedNotes(formattedText);
      }
    }}
    variant="ghost"
    colorScheme="red"
  />
)} */}
  
  {/* Show loading indicator */}
  {isAiLoading && (
    <Box
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      bg="rgba(255,255,255,0.9)"
      p={4}
      borderRadius="md"
      zIndex={10}
      boxShadow="md"
    >
      <Flex alignItems="center" gap={2}>
        <Spinner size="sm" />
        <Text fontSize="sm">Generating AI suggestions...</Text>
      </Flex>
    </Box>
  )}
  
  {/* Clear Textarea Button - Only show when not typing */}
  {combinedNotes && !notesTyping && (
    <IconButton
      aria-label="Clear text"
      icon={<CgRemove />}
      size="sm"
      position="absolute"
      top="10px"
      right="10px"
      onClick={() => {
        setCombinedNotes("");
        setTranscriptionText("");
        setNotesPlaceholder("Enter Chief Complaint, History of Present Illness, Vitals, Assessment, Plan, etc...");
      }}
      variant="ghost"
      colorScheme="gray"
    />
  )}
</Box>
      
      {/* Buttons Container */}
{/* Buttons Container */}
{/* Buttons Container */}
<Box 
  width="100%" 
  display="flex" 
  alignItems="center" 
  justifyContent="space-between"
  gap="0.75rem"
  mt="1"
>
  {/* Single Combined Record & AI Button */}
  <GPUChatAudioManagerSpeechMode
    transcriber={notesTranscriber}
    mode={notesMode}
    setPlaceholder={setNotesPlaceholder}
    setTyping={setNotesTyping}
    onTranscript={(transcript) => {
      console.log("Transcript from GPUChat:", transcript);
      if (transcript && transcript.trim()) {
        // Update transcription text
        setTranscriptionText(prev => prev ? `${prev} ${transcript}` : transcript);
        
        // Don't immediately add to combinedNotes to avoid duplicates
        // The AI processing will handle formatting
        
        // Auto-trigger AI processing after recording ONLY if not in edit mode
        // In edit mode, the transcriber hook already handles updating combinedNotes with replaced section content
        if (!editingSection) {
          setTimeout(() => {
            processTranscriptionAndGetAI(transcript);
          }, 500);
        }
      }
    }}
    // Custom styling to match your design
    // customStyle={{
    //   border: "1px solid #E6E7E9",
    //   borderRadius: "full",
    //   width: "36px",
    //   height: "36px",
    //   padding: "10px",
    //   marginRight: "10px",
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center",
    //   cursor: "pointer",
    //   background: "transparent"
    // }}
    // Use voice icon instead of clutter icon
    // customIcon={<Image w="26px" src="/assets/svgs/mic-voice-icon.svg" />}
    // customIcon={<FaMicrophone size={20} color="#666" />}
    showLoading={isAiLoading}
  />
  
  {/* Conditionally render AI correction button when editing */}
  {editingSection && editingSection !== 'vitals' && (
    <Box
      as="button"
      type="button"
      border="1px solid #E6E7E9"
      borderRadius="full"
      w="36px"
      h="auto"
      p="10px"
      mr='10px'
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor="pointer"
      onClick={() => {
        // Extract the text from the current section
        const sections = parseNotesIntoSections(combinedNotes);
        const sectionText = sections[editingSection];
        if (sectionText) {
          callCorrectionAI(editingSection, sectionText);
        }
      }}
    >
      <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
    </Box>
  )}
  
  {/* Save Button - changes text based on mode */}
  <PrimaryButton
    type="button"
    buttonText={editingSection ? `Save ${getSectionLabel(editingSection)}` : "Save Notes"}
    variant="grayBtn"
    isDisabled={!combinedNotes.trim() || !actionAccessMain(16)?.create}
    onClick={editingSection ? saveIndividualSection : handleCombinedNotesSubmit}
    btnStyle={{
      h: "2.25rem",
      flex: "1",
      bg: COLORS.PRIMARY_GRADIENT,
      color: COLORS.PRIMARY_WHITE,
      _hover: { bg: COLORS.PRIMARY_COLOR },
      fontSize: "13px"
    }}
  />
</Box>
    </VStack>
  </form>
</Box>
          }
        />
      </Box>
      
      {/* Vitals Modal Component */}
{/* Vitals Modal Component */}
<Modal
  isOpen={isVitalsModalOpen}
  onClose={closeVitalsModal}
  size="lg"
>
  <ModalOverlay />
  <ModalContent>
    <ModalHeader>
      <Flex alignItems="center" gap={2}>
        <Text>Record Vitals</Text>
      </Flex>
    </ModalHeader>
    <ModalCloseButton />
    <ModalBody>
      <form onSubmit={handleSubmit(handleVitalsSubmit)}>
        <VStack spacing={4}>
          {/* Temperature, HR, RR */}
          <SimpleGrid columns={3} spacing={4} width="100%">
            <FormControl>
              <FormLabel fontSize="sm">Temp (°F)</FormLabel>
              <Input
                type="number"
                step="0.1"
                {...vitalsRegister("Body Temperature")}
                defaultValue={tempVitalsData ? parseVitalsFromDisplayText(tempVitalsData).find(v => v.name === "Body Temperature")?.value || "" : ""}
                placeholder="98.6"
                size="sm"
              />
            </FormControl>
            
            <FormControl>
              <FormLabel fontSize="sm">HR (bpm)</FormLabel>
              <Input
                type="number"
                {...vitalsRegister("Pulse")}
                defaultValue={tempVitalsData ? parseVitalsFromDisplayText(tempVitalsData).find(v => v.name === "Pulse")?.value || "" : ""}
                placeholder="72"
                size="sm"
              />
            </FormControl>
            
            <FormControl>
              <FormLabel fontSize="sm">RR (b/min)</FormLabel>
              <Input
                type="number"
                {...vitalsRegister("Respiratory Rate")}
                defaultValue={tempVitalsData ? parseVitalsFromDisplayText(tempVitalsData).find(v => v.name === "Respiratory Rate")?.value || "" : ""}
                placeholder="16"
                size="sm"
              />
            </FormControl>
          </SimpleGrid>
          
          {/* BP & SPO2 */}
          <SimpleGrid columns={2} spacing={4} width="100%">
            <FormControl>
              <FormLabel fontSize="sm">BP (mmHg)</FormLabel>
              <Flex gap={2}>
                <Input
                  type="number"
                  {...vitalsRegister("Systolic Blood Pressure")}
                  defaultValue={tempVitalsData ? parseVitalsFromDisplayText(tempVitalsData).find(v => v.name === "Systolic Blood Pressure")?.value || "" : ""}
                  placeholder="120"
                  size="sm"
                />
                <Text alignSelf="center">/</Text>
                <Input
                  type="number"
                  {...vitalsRegister("Diastolic Blood Pressure")}
                  defaultValue={tempVitalsData ? parseVitalsFromDisplayText(tempVitalsData).find(v => v.name === "Diastolic Blood Pressure")?.value || "" : ""}
                  placeholder="80"
                  size="sm"
                />
              </Flex>
            </FormControl>
            
            <FormControl>
              <FormLabel fontSize="sm">SPO2 (%)</FormLabel>
              <Input
                type="number"
                {...vitalsRegister("Oxygen Saturation")}
                defaultValue={tempVitalsData ? parseVitalsFromDisplayText(tempVitalsData).find(v => v.name === "Oxygen Saturation")?.value || "" : ""}
                placeholder="98"
                size="sm"
              />
            </FormControl>
          </SimpleGrid>
          
          {/* Glucose Levels */}
          <SimpleGrid columns={2} spacing={4} width="100%">
            <FormControl>
              <FormLabel fontSize="sm">F. Glucose (mg/dL)</FormLabel>
              <Input
                type="number"
                {...vitalsRegister("Fasting Blood Glucose")}
                defaultValue={tempVitalsData ? parseVitalsFromDisplayText(tempVitalsData).find(v => v.name === "Fasting Blood Glucose")?.value || "" : ""}
                placeholder="100"
                size="sm"
              />
            </FormControl>
            
            <FormControl>
              <FormLabel fontSize="sm">P. Glucose (mg/dL)</FormLabel>
              <Input
                type="number"
                {...vitalsRegister("Postprandial Blood Glucose")}
                defaultValue={tempVitalsData ? parseVitalsFromDisplayText(tempVitalsData).find(v => v.name === "Postprandial Blood Glucose")?.value || "" : ""}
                placeholder="140"
                size="sm"
              />
            </FormControl>
          </SimpleGrid>
          
          <PrimaryButton
            type="submit"
            buttonText="Save Vitals"
            width="100%"
            mt={4}
          />
        </VStack>
      </form>
    </ModalBody>
  </ModalContent>
</Modal>
    </Box>
  </Flex>
</Box>

                {/* ------------------------------------------------------------------------------- */}

                {/* Divider */}
                <Divider orientation="vertical" />
                <Divider
                  orientation="vertical"
                  borderWidth="3px"
                  borderColor="white"
                />
                <Flex alignItems="center" justifyContent="center">
                  <Divider
                    orientation="vertical"
                    borderWidth="3px"
                    borderColor="black"
                    borderRadius={4}
                    height="40px"
                  />
                </Flex>
                <Divider
                  orientation="vertical"
                  borderWidth="3px"
                  borderColor="white"
                />
                <Divider orientation="vertical" />

                {/* ------------------------------------------------------------------------- */}

                {/* Right Panel */}
                {/* Right Panel */}
<Box width="70%" p={0} position="relative">
  <Flex direction="column" h="100%" gap={4}>
  <Box 
      flex="1" 
      overflowY="auto" 
      bg="#fcfcfd"
      css={{
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#c1c1c1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#a8a8a8',
        }
      }}
    >
    {/* Favorites Section - Combined Medicines, Labs, Imaging */}
    <Tabs 
      variant="enclosed" 
      size="sm" 
      onChange={(index) => setActiveFavoriteTab(['medicines', 'labs', 'imaging', 'vaccines', 'procedures'][index])}
    >
    <GrayCardQuickPrescription
      hasFooter={false}
      bodyStyle={{ p: "0" }}
      customHeader={true}
      cardHeader={
        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
          <Flex alignItems="center" gap={4}>
            <Heading textTransform="uppercase" fontSize="12px" fontWeight="600">
              My Favourite:
            </Heading>
            {/* Tabs for Medicines, Labs, Imaging */}
            {/* <Tabs 
              variant="enclosed" 
              size="sm" 
              onChange={(index) => setActiveFavoriteTab(['medicines', 'labs', 'imaging', 'vaccines'][index])}
            > */}
              <TabList border="none">
                <Tab 
                  fontSize="11px" 
                  fontWeight="600" 
                  px={3}
                  py={1}
                  _selected={{ 
                    color: 'blue.500', 
                    bg: 'blue.50',
                    border: '1px solid',
                    borderColor: 'blue.200',
                    borderRadius: 'md'
                  }}
                >
                  Medicines ({recentMedicines.length})
                </Tab>
                <Tab 
                  fontSize="11px" 
                  fontWeight="600" 
                  px={3}
                  py={1}
                  _selected={{ 
                    color: 'green.500', 
                    bg: 'green.50',
                    border: '1px solid',
                    borderColor: 'green.200',
                    borderRadius: 'md'
                  }}
                >
                  Labs ({favoriteLabs.length})
                </Tab>
                <Tab 
                  fontSize="11px" 
                  fontWeight="600" 
                  px={3}
                  py={1}
                  _selected={{ 
                    color: 'purple.500', 
                    bg: 'purple.50',
                    border: '1px solid',
                    borderColor: 'purple.200',
                    borderRadius: 'md'
                  }}
                >
                  Imaging ({favoriteImaging.length})
                </Tab>
                <Tab 
                  fontSize="11px" 
                  fontWeight="600" 
                  px={3}
                  py={1}
                  _selected={{ 
                    color: 'orange.500', 
                    bg: 'orange.50',
                    border: '1px solid',
                    borderColor: 'orange.200',
                    borderRadius: 'md'
                  }}
                >
                  Vaccines ({favoriteVaccinations.length})
                </Tab>
                <Tab
                  fontSize="11px"
                  fontWeight="600"
                  px={3}
                  py={1}
                  _selected={{
                    color: 'teal.600',
                    bg: 'teal.50',
                    border: '1px solid',
                    borderColor: 'teal.200',
                    borderRadius: 'md',
                  }}
                >
                  Procedures ({favoriteProcedures.length})
                </Tab>
              </TabList>
            {/* </Tabs> */}
          </Flex>
          
          <Box display="flex" alignItems="center" gap={2} flexShrink={0}>
            {/* Sort by */}
            <Box width="100px">
              <Select
                placeholder="Sort by"
                onChange={(e) => {
                  const value = e.target.value;
                  if (activeFavoriteTab === 'medicines') setSortOption(value);
                  if (activeFavoriteTab === 'labs') setLabSortOption(value);
                }}
                width="100%"
                height="24px"
                size="xs"
                borderColor="gray.300"
                fontSize="11px"
              >
                <option value="A-Z">Name (A-Z)</option>
                {activeFavoriteTab === 'medicines' && <option value="availability">Availability</option>}
                {(activeFavoriteTab === 'labs' || activeFavoriteTab === 'vaccines') && <option value="type">Type</option>}
              </Select>
            </Box>

            {/* Search */}
            <Box width="150px">
              <InputGroup size="xs">
                <InputLeftElement pointerEvents="none" height="24px">
                  <SearchIcon color="gray.400" boxSize={2.5} />
                </InputLeftElement>
                <Input
                  placeholder="Search..."
                  value={activeFavoriteTab === 'medicines' ? search : activeFavoriteTab === 'vaccines' ? vaccineSearch : labSearch}
                  onChange={(e) => {
                    if (activeFavoriteTab === 'medicines') setSearch(e.target.value);
                    if (activeFavoriteTab === 'labs') setLabSearch(e.target.value);
                    if (activeFavoriteTab === 'vaccines') setVaccineSearch(e.target.value);
                  }}
                  height="24px"
                  borderColor="gray.300"
                  fontSize="11px"
                  pl={6}
                />
              </InputGroup>
            </Box>
          </Box>
        </Box>
      }
      cardBody={
        // <Box width="100%" pt={3}>
        <Box width="100%">
          <TabPanels>
            {/* Medicines Tab */}
            <TabPanel p={0}>
              <Box 
                height="300px" 
                overflowY="auto"
                // border="1px solid"
                // borderColor="gray.200"
                borderRadius="md"
              >
                {recentMedicines.length === 0 ? (
                  <Box 
                    width="100%" 
                    height="100%" 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    color="gray.500"
                    fontSize="sm"
                  >
                    No medicines found
                  </Box>
                ) : search.trim() !== "" &&
                  recentMedicines.filter((medicine) =>
                    medicine.medicinename?.toLowerCase()?.includes(search.toLowerCase()) ||
                    medicine.chemicalcomposition?.toLowerCase().includes(search.toLowerCase())
                  ).length === 0 ? (
                  <Box 
                    width="100%" 
                    height="100%" 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    color="gray.500"
                    fontSize="sm"
                  >
                    No medicines match your search
                  </Box>
                ) : (
                  <Grid
                    templateColumns={{
                      base: 'repeat(3, 1fr)',
                      sm: 'repeat(4, 1fr)',
                      md: 'repeat(5, 1fr)',
                      lg: 'repeat(6, 1fr)',
                      xl: 'repeat(7, 1fr)'
                    }}
                    gap={2}
                    width="100%"
                    p={2}
                  >
                    {recentMedicines
                      .filter((medicine) =>
                        medicine.medicinename
                          ?.toLowerCase()
                          ?.includes(search?.toLowerCase()) ||
                        medicine.chemicalcomposition?.toLowerCase().includes(search.toLowerCase())
                      )
                      .sort((a, b) => {
                        if (sortOption === "A-Z") {
                          return a.medicinename.localeCompare(b.medicinename);
                        } else if (sortOption === "availability") {
                          return (b.remainingquantity || 0) - (a.remainingquantity || 0);
                        }
                        return 0;
                      })
                      .map((medicine, index) => {
                        const isSelected = selectedMedicines.some(m => 
                          m.medicinename === medicine.medicinename &&
                          m.medicinetype === medicine.medicinetype &&
                          m.dosage === medicine.dosage &&
                          m.dosageunit === medicine.dosageunit &&
                          m.isactive === 1
                        );

                        const uniqueKey = medicine.id ? `${medicine.id}-${index}` : `medicine-${index}`;
                        
                        return (
                          <GridItem key={uniqueKey}>
                            <Box
                              as="button"
                              width="100%"
                              minH="40px"
                              p={1}
                              border="1px solid"
                              borderColor={isSelected ? "blue.300" : "transparent"}
                              borderRadius="sm"
                              bg={isSelected ? "blue.50" : "transparent"}
                              transition="all 0.1s"
                              _hover={{
                                bg: "gray.50",
                                borderColor: "gray.300"
                              }}
                              onClick={() => handleCheckboxChange(medicine)}
                              textAlign="center"
                              display="flex"
                              flexDirection="column"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <Text
                                fontWeight={isSelected ? "bold" : "normal"}
                                fontSize="xs"
                                color={isSelected ? "blue.600" : "gray.700"}
                                noOfLines={2}
                                lineHeight="short"
                              >
                                {formatMedicineName(medicine)}
                              </Text>
                            </Box>
                          </GridItem>
                        );
                      })}
                  </Grid>
                )}
              </Box>
            </TabPanel>

            {/* Labs Tab */}
            <TabPanel p={0}>
              <Box 
                height="300px" 
                overflowY="auto"
                // border="1px solid"
                // borderColor="gray.200"
                borderRadius="md"
              >
                {favoriteLabs.length === 0 ? (
                  <Box 
                    width="100%" 
                    height="100%" 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    color="gray.500"
                    fontSize="sm"
                  >
                    No labs found
                  </Box>
                ) : labSearch.trim() !== "" &&
                  favoriteLabs.filter((lab) =>
                    lab.subtype?.toLowerCase().includes(labSearch.toLowerCase()) ||
                    lab.type?.toLowerCase().includes(labSearch.toLowerCase())
                  ).length === 0 ? (
                  <Box 
                    width="100%" 
                    height="100%" 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    color="gray.500"
                    fontSize="sm"
                  >
                    No labs match your search
                  </Box>
                ) : (
                  <Grid
                    templateColumns={{
                      base: 'repeat(3, 1fr)',
                      sm: 'repeat(4, 1fr)',
                      md: 'repeat(5, 1fr)',
                      lg: 'repeat(6, 1fr)',
                      xl: 'repeat(7, 1fr)'
                    }}
                    gap={2}
                    width="100%"
                    p={2}
                  >
                    {favoriteLabs
                      .filter((lab) =>
                        lab.subtype?.toLowerCase().includes(labSearch.toLowerCase()) ||
                        lab.type?.toLowerCase().includes(labSearch.toLowerCase())
                      )
                      .sort((a, b) => {
                        if (labSortOption === "A-Z") {
                          return (a.subtype || "").localeCompare(b.subtype || "");
                        } else if (labSortOption === "type") {
                          return a.type.localeCompare(b.type);
                        }
                        return 0;
                      })
                      .map((lab, index) => {
                        const isSelected = selectedLabs.some(s => s.id === lab.id) || savedLabs.some(s => s.id === lab.id);
                        const uniqueKey = `lab-${lab.id}-${index}`;
                        
                        return (
                          <GridItem key={uniqueKey}>
                            <Box
                              as="button"
                              width="100%"
                              minH="40px"
                              p={1}
                              border="1px solid"
                              borderColor={isSelected ? "green.300" : "transparent"}
                              borderRadius="sm"
                              bg={isSelected ? "green.50" : "transparent"}
                              transition="all 0.1s"
                              _hover={{
                                bg: "gray.50",
                                borderColor: "gray.300"
                              }}
                              onClick={() => handleLabSelect(lab)}
                              textAlign="center"
                              display="flex"
                              flexDirection="column"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <Text
                                fontWeight={isSelected ? "bold" : "normal"}
                                fontSize="xs"
                                color={isSelected ? "green.600" : "gray.700"}
                                noOfLines={2}
                                lineHeight="short"
                              >
                                {lab.subtype}
                              </Text>
                            </Box>
                          </GridItem>
                        );
                      })}
                  </Grid>
                )}
              </Box>
            </TabPanel>

            {/* Imaging Tab */}
            <TabPanel p={0}>
              <Box 
                height="300px" 
                overflowY="auto"
                // border="1px solid"
                // borderColor="gray.200"
                borderRadius="md"
              >
                {favoriteImaging.length === 0 ? (
                  <Box 
                    width="100%" 
                    height="100%" 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    color="gray.500"
                    fontSize="sm"
                  >
                    No imaging studies found
                  </Box>
                ) : (
                  <Grid
                    templateColumns={{
                      base: 'repeat(3, 1fr)',
                      sm: 'repeat(4, 1fr)',
                      md: 'repeat(5, 1fr)',
                      lg: 'repeat(6, 1fr)',
                      xl: 'repeat(7, 1fr)'
                    }}
                    gap={2}
                    width="100%"
                    p={2}
                  >
                    {favoriteImaging.map((imaging, index) => {
                      const isSelected = selectedImaging.some(s => s.id === imaging.id) || savedImaging.some(s => s.id === imaging.id);
                      const uniqueKey = `imaging-${imaging.id}-${index}`;
                      
                      return (
                        <GridItem key={uniqueKey}>
                          <Box
                            as="button"
                            width="100%"
                            minH="40px"
                            p={1}
                            border="1px solid"
                            borderColor={isSelected ? "purple.300" : "transparent"}
                            borderRadius="sm"
                            bg={isSelected ? "purple.50" : "transparent"}
                            transition="all 0.1s"
                            _hover={{
                              bg: "gray.50",
                              borderColor: "gray.300"
                            }}
                            onClick={() => handleImagingSelect(imaging)}
                            textAlign="center"
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Text
                              fontWeight={isSelected ? "bold" : "normal"}
                              fontSize="xs"
                              color={isSelected ? "purple.600" : "gray.700"}
                              noOfLines={2}
                              lineHeight="short"
                            >
                              {imaging.subtype}
                            </Text>
                          </Box>
                        </GridItem>
                      );
                    })}
                  </Grid>
                )}
              </Box>
            </TabPanel>

            {/* Vaccines Tab */}
            <TabPanel p={0}>
              <Box 
                height="300px" 
                overflowY="auto"
                // border="1px solid"
                // borderColor="gray.200"
                borderRadius="md"
              >
                {favoriteVaccinations.length === 0 ? (
                  <Box 
                    width="100%" 
                    height="100%" 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    color="gray.500"
                    fontSize="sm"
                  >
                    No vaccines found
                  </Box>
                ) : vaccineSearch.trim() !== "" &&
                  favoriteVaccinations.filter((vaccine) =>
                    vaccine.subtype?.toLowerCase().includes(vaccineSearch.toLowerCase())
                  ).length === 0 ? (
                  <Box 
                    width="100%" 
                    height="100%" 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    color="gray.500"
                    fontSize="sm"
                  >
                    No vaccines match your search
                  </Box>
                ) : (
                  <Grid
                    templateColumns={{
                      base: 'repeat(3, 1fr)',
                      sm: 'repeat(4, 1fr)',
                      md: 'repeat(5, 1fr)',
                      lg: 'repeat(6, 1fr)',
                      xl: 'repeat(7, 1fr)'
                    }}
                    gap={2}
                    width="100%"
                    p={2}
                  >
                    {favoriteVaccinations
                      .filter((vaccine) =>
                        vaccine.subtype?.toLowerCase().includes(vaccineSearch.toLowerCase())
                      )
                      .sort((a, b) => {
                        return (a.subtype || "").localeCompare(b.subtype || "");
                      })
                      .map((vaccine, index) => {
                        const isSelected = selectedVaccines.some(s => s.id === vaccine.id) || savedVaccines.some(s => s.id === vaccine.id);
                        const uniqueKey = `vaccine-${vaccine.id}-${index}`;
                        
                        return (
                          <GridItem key={uniqueKey}>
                            <Box
                              as="button"
                              width="100%"
                              minH="40px"
                              p={1}
                              border="1px solid"
                              borderColor={isSelected ? "orange.300" : "transparent"}
                              borderRadius="sm"
                              bg={isSelected ? "orange.50" : "transparent"}
                              transition="all 0.1s"
                              _hover={{
                                bg: "gray.50",
                                borderColor: "gray.300"
                              }}
                              onClick={() => handleVaccineSelect(vaccine)}
                              textAlign="center"
                              display="flex"
                              flexDirection="column"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <Text
                                fontWeight={isSelected ? "bold" : "normal"}
                                fontSize="xs"
                                color={isSelected ? "orange.600" : "gray.700"}
                                noOfLines={2}
                                lineHeight="short"
                              >
                                {vaccine.subtype}
                              </Text>
                            </Box>
                          </GridItem>
                        );
                      })}
                  </Grid>
                )}
              </Box>
            </TabPanel>

            {/* Procedures Tab */}
            <TabPanel p={0}>
              <Box 
                height="300px" 
                overflowY="auto"
                // border="1px solid"
                // borderColor="gray.200"
                borderRadius="md"
              >
                {favoriteProcedures.length === 0 ? (
                  <Box 
                    width="100%" 
                    height="100%" 
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    color="gray.500"
                    fontSize="sm"
                  >
                    No procedure studies found
                  </Box>
                ) : (
                  <Grid
                    templateColumns={{
                      base: 'repeat(3, 1fr)',
                      sm: 'repeat(4, 1fr)',
                      md: 'repeat(5, 1fr)',
                      lg: 'repeat(6, 1fr)',
                      xl: 'repeat(7, 1fr)'
                    }}
                    gap={2}
                    width="100%"
                    p={2}
                  >
                    {favoriteProcedures.map((procedure, index) => {
                      const isSelected = selectedProcedures.some(s => s.id === procedure.id) || savedProcedures.some(s => s.id === procedure.id);
                      const uniqueKey = `procedure-${procedure.id}-${index}`;
                      
                      return (
                        <GridItem key={uniqueKey}>
                          <Box
                            as="button"
                            width="100%"
                            minH="40px"
                            p={1}
                            border="1px solid"
                            borderColor={isSelected ? "teal.300" : "transparent"}
                            borderRadius="sm"
                            bg={isSelected ? "teal.50" : "transparent"}
                            transition="all 0.1s"
                            _hover={{
                              bg: "gray.50",
                              borderColor: "gray.300"
                            }}
                            onClick={() => handleProcedureSelect(procedure)}
                            textAlign="center"
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Text
                              fontWeight={isSelected ? "bold" : "normal"}
                              fontSize="xs"
                              color={isSelected ? "teal.600" : "gray.700"}
                              noOfLines={2}
                              lineHeight="short"
                            >
                              {procedure.subtype}
                            </Text>
                          </Box>
                        </GridItem>
                      );
                    })}
                  </Grid>
                )}
              </Box>
            </TabPanel>
          </TabPanels>
        </Box>
      }
    />
    </Tabs>

    {/* Selected Items Section - Combined Medicines, Labs, Imaging, Vaccines */}
<GrayCardQuickPrescription
  hasFooter={false}
  bodyStyle={{ p: "0" }}
  customHeader={true}
  cardHeader={
    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
      <Heading textTransform="uppercase" fontSize="12px" fontWeight="600">
        Selected Items
      </Heading>
      <Button
        bg={"#fcfcfd"}
        color={"blue"}
        height={"2rem"}
        size="sm"
        onClick={() => {
          setIsAddModalOpen(true)
          addPrescriptionMedication.current.openModal();
          setAddMedicineInstructions("");
          setNewMedicine({
            id: null,
            inventoryid: null,
            medicinename: "",
            manufacturer: "",
            drugclass: "",
            therapeutic: "",
            composition: "",
            medicinetype: "Tablet",
            dosage: "",
            dosageunit: "mg",
            medicationstartdate: today,
            medicationenddate: fiveDaysFromToday,
            frequency: 1,
            frequencytime: "",
            frequencyvalue: "",
            morning: 1,
            afternoon: 0,
            evening: 0,
            night: 0,
            prescribedby: "",
            hospitalname: "",
            beforefood: 0,
            afterfood: 1,
            // beforefood: 1,
            // afterfood: 0,
            issaved: false,
            frequencyduration: null,
            routeofadministration: null,
            timingofinjection: null,
            quantitytobeapplied: null,
            areaofapplication: null,
            diluent: null,
            additives: null,
            rateofinfusionvalue: null,
            rateofinfusionunit: "ml/hr",
            duration: "5 Days",
            durationunit: "Days",
            durationvalue: 5,
            productQuantity: "1",
            custommessage: null,
            sos: null
          })
          setShowAddCard(true)
        }}
      >
        + Add medicine
      </Button>
    </Box>
  }
  cardBody={
    <Box width="100%">
      {/* Combined Grid for All Selected Items with Different Colors */}
      <Box 
        height="150px" 
        overflow="auto"
        borderRadius="md"
      >
        {selectedMedicines.filter(medicine => medicine.isactive !== 0).length === 0 && 
          selectedLabs.length === 0 && 
          selectedImaging.length === 0 && 
          selectedProcedures.length === 0 && 
          selectedVaccines.length === 0 && 
          savedLabs.length === 0 && 
          savedImaging.length === 0 && 
          savedProcedures.length === 0 && 
          savedVaccines.length === 0 ? (
          <Box 
            width="100%" 
            height="100%" 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
            color="gray.500"
            fontSize="sm"
          >
            No items selected
          </Box>
        ) : (
          <Grid
            templateColumns={{
              base: 'repeat(auto-fill, minmax(180px, 1fr))',
              sm: 'repeat(auto-fill, minmax(200px, 1fr))',
              md: 'repeat(auto-fill, minmax(220px, 1fr))'
            }}
            gap={2}
            width="100%"
            p={2}
          >
            {selectedMedicines
              .filter(medicine => medicine.isactive !== 0)
              .map((medicine, index) => {
                const uniqueKey = medicine.id ? `${medicine.id}-selected-${index}` : `selected-${index}`;
                const medicineName = formatMedicineName(medicine);
                
                return (
                  <GridItem key={uniqueKey} display="flex">
                    <Box
                      width="100%"
                      minH="40px"
                      p={2}
                      border="1px solid"
                      borderColor="blue.200"
                      borderRadius="md"
                      bg="blue.50"
                      transition="all 0.1s"
                      _hover={{
                        bg: "blue.100",
                        borderColor: "blue.300"
                      }}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      overflow="hidden"
                    >
                      {/* Medicine name - full text, scrollable with hidden scrollbar */}
                      <Box 
                        flex="1" 
                        minW="0"
                        mr={2}
                        overflowX="auto"
                        overflowY="hidden"
                        // with scrollbar
                        // css={{
                        //   scrollbarWidth: 'thin',
                        //   scrollbarColor: '#CBD5E0 transparent',
                        //   '&::-webkit-scrollbar': {
                        //     height: '3px',
                        //   },
                        //   '&::-webkit-scrollbar-track': {
                        //     background: 'transparent',
                        //   },
                        //   '&::-webkit-scrollbar-thumb': {
                        //     backgroundColor: '#CBD5E0',
                        //     borderRadius: '3px',
                        //   },
                        // }}

                        // without scrollbar
                        css={{
                          '&::-webkit-scrollbar': {
                            display: 'none', /* Hide scrollbar for Chrome, Safari and Opera */
                          },
                          '-ms-overflow-style': 'none', /* Hide scrollbar for IE and Edge */
                          'scrollbar-width': 'none', /* Hide scrollbar for Firefox */
                          cursor: 'grab',
                          '&:active': {
                            cursor: 'grabbing',
                          },
                        }}
                        onWheel={(e) => {
                          // Allow horizontal scrolling with mouse wheel while holding Shift
                          if (e.shiftKey) {
                            e.preventDefault();
                            e.currentTarget.scrollLeft += e.deltaY;
                          }
                        }}
                      >
                        <Text
                          fontWeight="medium"
                          fontSize="xs"
                          color="blue.700"
                          whiteSpace="nowrap"
                          display="inline-block"
                          minWidth="min-content"
                        >
                          {medicineName}
                        </Text>
                      </Box>

                      {/* Buttons */}
                      <Flex align="center" gap={1} flexShrink={0} ml={1}>
                        <Box
                          as="button"
                          w="16px"
                          h="16px"
                          minW="16px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexShrink={0}
                          _hover={{ opacity: 0.7 }}
                          onClick={() => handleEditMedicine(medicine)}
                        >
                          <Image w="10px" src="/assets/svgs/edit-gray.svg" />
                        </Box>

                        <Box
                          as="button"
                          w="16px"
                          h="16px"
                          minW="16px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexShrink={0}
                          _hover={{ opacity: 0.7 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            openDeleteModal(medicine);
                          }}
                        >
                          <Image w="10px" src="/assets/imgs/delete.png" />
                        </Box>
                      </Flex>
                    </Box>
                  </GridItem>
                );
              })}

            {/* Selected Labs - Green */}
            {selectedLabs
              .filter(lab => !savedLabs.some(savedLab => savedLab.id === lab.id))
              .map((lab, index) => (
                <GridItem key={`selected-lab-${lab.id}-${index}`} display="flex">
                  <Box
                    width="100%"
                    minH="40px"
                    p={2}
                    border="1px solid"
                    borderColor="green.200"
                    borderRadius="md"
                    bg="green.50"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    overflow="hidden"
                  >
                    <Box 
                      flex="1" 
                      minW="0"
                      mr={2}
                      overflowX="auto"
                      overflowY="hidden"
                      // with scrollbar
                        // css={{
                        //   scrollbarWidth: 'thin',
                        //   scrollbarColor: '#CBD5E0 transparent',
                        //   '&::-webkit-scrollbar': {
                        //     height: '3px',
                        //   },
                        //   '&::-webkit-scrollbar-track': {
                        //     background: 'transparent',
                        //   },
                        //   '&::-webkit-scrollbar-thumb': {
                        //     backgroundColor: '#CBD5E0',
                        //     borderRadius: '3px',
                        //   },
                        // }}

                        // without scrollbar
                      css={{
                        '&::-webkit-scrollbar': {
                          display: 'none',
                        },
                        '-ms-overflow-style': 'none',
                        'scrollbar-width': 'none',
                        cursor: 'grab',
                        '&:active': {
                          cursor: 'grabbing',
                        },
                      }}
                      onWheel={(e) => {
                        if (e.shiftKey) {
                          e.preventDefault();
                          e.currentTarget.scrollLeft += e.deltaY;
                        }
                      }}
                    >
                      <Text
                        fontWeight="medium"
                        fontSize="xs"
                        color="green.700"
                        whiteSpace="nowrap"
                        display="inline-block"
                        minWidth="min-content"
                      >
                        {lab.subtype}
                      </Text>
                    </Box>
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      flexShrink={0}
                      ml={1}
                    >
                      <Box
                        as="button"
                        w="16px"
                        h="16px"
                        minW="16px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleLabDelete(lab);
                        }}
                        _hover={{ opacity: 0.7 }}
                      >
                        <Image w="10px" src="/assets/imgs/delete.png" />
                      </Box>
                    </Box>
                  </Box>
                </GridItem>
              ))}                  

            {/* Saved Labs - Dark Green */}
            {savedLabs.map((lab, index) => (
              <GridItem key={`saved-lab-${lab.orderid}-${index}`} display="flex">
                <Box
                  width="100%"
                  minH="40px"
                  p={2}
                  border="2px solid"
                  borderColor="green.400"
                  borderRadius="md"
                  bg="green.50"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  overflow="hidden"
                >
                  <Box 
                    flex="1" 
                    minW="0"
                    mr={2}
                    overflowX="auto"
                    overflowY="hidden"
                    // with scrollbar
                        // css={{
                        //   scrollbarWidth: 'thin',
                        //   scrollbarColor: '#CBD5E0 transparent',
                        //   '&::-webkit-scrollbar': {
                        //     height: '3px',
                        //   },
                        //   '&::-webkit-scrollbar-track': {
                        //     background: 'transparent',
                        //   },
                        //   '&::-webkit-scrollbar-thumb': {
                        //     backgroundColor: '#CBD5E0',
                        //     borderRadius: '3px',
                        //   },
                        // }}

                        // without scrollbar
                    css={{
                      '&::-webkit-scrollbar': {
                        display: 'none',
                      },
                      '-ms-overflow-style': 'none',
                      'scrollbar-width': 'none',
                      cursor: 'grab',
                      '&:active': {
                        cursor: 'grabbing',
                      },
                    }}
                    onWheel={(e) => {
                      if (e.shiftKey) {
                        e.preventDefault();
                        e.currentTarget.scrollLeft += e.deltaY;
                      }
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontSize="xs"
                      color="green.800"
                      whiteSpace="nowrap"
                      display="inline-block"
                      minWidth="min-content"
                    >
                      {lab.subtype}
                    </Text>
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    flexShrink={0}
                    ml={1}
                  >
                    <Box
                      as="button"
                      w="16px"
                      h="16px"
                      minW="16px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLabDelete(lab);
                      }}
                      _hover={{ opacity: 0.7 }}
                    >
                      <Image w="10px" src="/assets/imgs/delete.png" />
                    </Box>
                  </Box>
                </Box>
              </GridItem>
            ))}

            {/* Selected Imaging - Purple */}
            {selectedImaging
              .filter(imaging => !savedImaging.some(savedImg => savedImg.id === imaging.id))
              .map((imaging, index) => (
                <GridItem key={`selected-imaging-${imaging.id}-${index}`} display="flex">
                  <Box
                    width="100%"
                    minH="40px"
                    p={2}
                    border="1px solid"
                    borderColor="purple.200"
                    borderRadius="md"
                    bg="purple.50"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    overflow="hidden"
                  >
                    <Box 
                      flex="1" 
                      minW="0"
                      mr={2}
                      overflowX="auto"
                      overflowY="hidden"
                      // with scrollbar
                        // css={{
                        //   scrollbarWidth: 'thin',
                        //   scrollbarColor: '#CBD5E0 transparent',
                        //   '&::-webkit-scrollbar': {
                        //     height: '3px',
                        //   },
                        //   '&::-webkit-scrollbar-track': {
                        //     background: 'transparent',
                        //   },
                        //   '&::-webkit-scrollbar-thumb': {
                        //     backgroundColor: '#CBD5E0',
                        //     borderRadius: '3px',
                        //   },
                        // }}

                        // without scrollbar
                      css={{
                        '&::-webkit-scrollbar': {
                          display: 'none',
                        },
                        '-ms-overflow-style': 'none',
                        'scrollbar-width': 'none',
                        cursor: 'grab',
                        '&:active': {
                          cursor: 'grabbing',
                        },
                      }}
                      onWheel={(e) => {
                        if (e.shiftKey) {
                          e.preventDefault();
                          e.currentTarget.scrollLeft += e.deltaY;
                        }
                      }}
                    >
                      <Text
                        fontWeight="medium"
                        fontSize="xs"
                        color="purple.700"
                        whiteSpace="nowrap"
                        display="inline-block"
                        minWidth="min-content"
                      >
                        {imaging.subtype}
                      </Text>
                    </Box>
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      flexShrink={0}
                      ml={1}
                    >
                      <Box
                        as="button"
                        w="16px"
                        h="16px"
                        minW="16px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImagingDelete(imaging);
                        }}
                        _hover={{ opacity: 0.7 }}
                      >
                        <Image w="10px" src="/assets/imgs/delete.png" />
                      </Box>
                    </Box>
                  </Box>
                </GridItem>
              ))}

            {/* Saved Imaging - Dark Purple */}
            {savedImaging.map((imaging, index) => (
              <GridItem key={`saved-imaging-${imaging.orderid}-${index}`} display="flex">
                <Box
                  width="100%"
                  minH="40px"
                  p={2}
                  border="2px solid"
                  borderColor="purple.400"
                  borderRadius="md"
                  bg="purple.50"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  overflow="hidden"
                >
                  <Box 
                    flex="1" 
                    minW="0"
                    mr={2}
                    overflowX="auto"
                    overflowY="hidden"
                    // with scrollbar
                        // css={{
                        //   scrollbarWidth: 'thin',
                        //   scrollbarColor: '#CBD5E0 transparent',
                        //   '&::-webkit-scrollbar': {
                        //     height: '3px',
                        //   },
                        //   '&::-webkit-scrollbar-track': {
                        //     background: 'transparent',
                        //   },
                        //   '&::-webkit-scrollbar-thumb': {
                        //     backgroundColor: '#CBD5E0',
                        //     borderRadius: '3px',
                        //   },
                        // }}

                        // without scrollbar
                    css={{
                      '&::-webkit-scrollbar': {
                        display: 'none',
                      },
                      '-ms-overflow-style': 'none',
                      'scrollbar-width': 'none',
                      cursor: 'grab',
                      '&:active': {
                        cursor: 'grabbing',
                      },
                    }}
                    onWheel={(e) => {
                      if (e.shiftKey) {
                        e.preventDefault();
                        e.currentTarget.scrollLeft += e.deltaY;
                      }
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontSize="xs"
                      color="purple.800"
                      whiteSpace="nowrap"
                      display="inline-block"
                      minWidth="min-content"
                    >
                      {imaging.subtype}
                    </Text>
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    flexShrink={0}
                    ml={1}
                  >
                    <Box
                      as="button"
                      w="16px"
                      h="16px"
                      minW="16px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleImagingDelete(imaging);
                      }}
                      _hover={{ opacity: 0.7 }}
                    >
                      <Image w="10px" src="/assets/imgs/delete.png" />
                    </Box>
                  </Box>
                </Box>
              </GridItem>
            ))}

            {/* Selected Vaccines - Orange */}
            {selectedVaccines
              .filter(vaccine => !savedVaccines.some(savedVaccine => savedVaccine.id === vaccine.id))
              .map((vaccine, index) => (
                <GridItem key={`selected-vaccine-${vaccine.id}-${index}`} display="flex">
                  <Box
                    width="100%"
                    minH="40px"
                    p={2}
                    border="1px solid"
                    borderColor="orange.200"
                    borderRadius="md"
                    bg="orange.50"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    overflow="hidden"
                  >
                    <Box 
                      flex="1" 
                      minW="0"
                      mr={2}
                      overflowX="auto"
                      overflowY="hidden"
                      // with scrollbar
                        // css={{
                        //   scrollbarWidth: 'thin',
                        //   scrollbarColor: '#CBD5E0 transparent',
                        //   '&::-webkit-scrollbar': {
                        //     height: '3px',
                        //   },
                        //   '&::-webkit-scrollbar-track': {
                        //     background: 'transparent',
                        //   },
                        //   '&::-webkit-scrollbar-thumb': {
                        //     backgroundColor: '#CBD5E0',
                        //     borderRadius: '3px',
                        //   },
                        // }}

                        // without scrollbar
                      css={{
                        '&::-webkit-scrollbar': {
                          display: 'none',
                        },
                        '-ms-overflow-style': 'none',
                        'scrollbar-width': 'none',
                        cursor: 'grab',
                        '&:active': {
                          cursor: 'grabbing',
                        },
                      }}
                      onWheel={(e) => {
                        if (e.shiftKey) {
                          e.preventDefault();
                          e.currentTarget.scrollLeft += e.deltaY;
                        }
                      }}
                    >
                      <Text
                        fontWeight="medium"
                        fontSize="xs"
                        color="orange.700"
                        whiteSpace="nowrap"
                        display="inline-block"
                        minWidth="min-content"
                      >
                        {vaccine.subtype}
                      </Text>
                    </Box>
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      flexShrink={0}
                      ml={1}
                    >
                      <Box
                        as="button"
                        w="16px"
                        h="16px"
                        minW="16px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleVaccineDelete(vaccine);
                        }}
                        _hover={{ opacity: 0.7 }}
                      >
                        <Image w="10px" src="/assets/imgs/delete.png" />
                      </Box>
                    </Box>
                  </Box>
                </GridItem>
              ))}

            {/* Saved Vaccines - Dark Orange */}
            {savedVaccines.map((vaccine, index) => (
              <GridItem key={`saved-vaccine-${vaccine.orderid}-${index}`} display="flex">
                <Box
                  width="100%"
                  minH="40px"
                  p={2}
                  border="2px solid"
                  borderColor="orange.400"
                  borderRadius="md"
                  bg="orange.50"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  overflow="hidden"
                >
                  <Box 
                    flex="1" 
                    minW="0"
                    mr={2}
                    overflowX="auto"
                    overflowY="hidden"
                    // with scrollbar
                        // css={{
                        //   scrollbarWidth: 'thin',
                        //   scrollbarColor: '#CBD5E0 transparent',
                        //   '&::-webkit-scrollbar': {
                        //     height: '3px',
                        //   },
                        //   '&::-webkit-scrollbar-track': {
                        //     background: 'transparent',
                        //   },
                        //   '&::-webkit-scrollbar-thumb': {
                        //     backgroundColor: '#CBD5E0',
                        //     borderRadius: '3px',
                        //   },
                        // }}

                        // without scrollbar
                    css={{
                      '&::-webkit-scrollbar': {
                        display: 'none',
                      },
                      '-ms-overflow-style': 'none',
                      'scrollbar-width': 'none',
                      cursor: 'grab',
                      '&:active': {
                        cursor: 'grabbing',
                      },
                    }}
                    onWheel={(e) => {
                      if (e.shiftKey) {
                        e.preventDefault();
                        e.currentTarget.scrollLeft += e.deltaY;
                      }
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontSize="xs"
                      color="orange.800"
                      whiteSpace="nowrap"
                      display="inline-block"
                      minWidth="min-content"
                    >
                      {vaccine.subtype}
                    </Text>
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    flexShrink={0}
                    ml={1}
                  >
                    <Box
                      as="button"
                      w="16px"
                      h="16px"
                      minW="16px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleVaccineDelete(vaccine);
                      }}
                      _hover={{ opacity: 0.7 }}
                    >
                      <Image w="10px" src="/assets/imgs/delete.png" />
                    </Box>
                  </Box>
                </Box>
              </GridItem>
            ))}

            {/* Selected Procedures - Teal */}
            {selectedProcedures
              .filter(procedure => !savedProcedures.some(savedPro => savedPro.id === procedure.id))
              .map((procedure, index) => (
                <GridItem key={`selected-procedure-${procedure.id}-${index}`} display="flex">
                  <Box
                    width="100%"
                    minH="40px"
                    p={2}
                    border="1px solid"
                    borderColor="teal.200"
                    borderRadius="md"
                    bg="teal.50"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    overflow="hidden"
                  >
                    <Box 
                      flex="1" 
                      minW="0"
                      mr={2}
                      overflowX="auto"
                      overflowY="hidden"
                      // with scrollbar
                        // css={{
                        //   scrollbarWidth: 'thin',
                        //   scrollbarColor: '#CBD5E0 transparent',
                        //   '&::-webkit-scrollbar': {
                        //     height: '3px',
                        //   },
                        //   '&::-webkit-scrollbar-track': {
                        //     background: 'transparent',
                        //   },
                        //   '&::-webkit-scrollbar-thumb': {
                        //     backgroundColor: '#CBD5E0',
                        //     borderRadius: '3px',
                        //   },
                        // }}

                        // without scrollbar
                      css={{
                        '&::-webkit-scrollbar': {
                          display: 'none',
                        },
                        '-ms-overflow-style': 'none',
                        'scrollbar-width': 'none',
                        cursor: 'grab',
                        '&:active': {
                          cursor: 'grabbing',
                        },
                      }}
                      onWheel={(e) => {
                        if (e.shiftKey) {
                          e.preventDefault();
                          e.currentTarget.scrollLeft += e.deltaY;
                        }
                      }}
                    >
                      <Text
                        fontWeight="medium"
                        fontSize="xs"
                        color="teal.700"
                        whiteSpace="nowrap"
                        display="inline-block"
                        minWidth="min-content"
                      >
                        {procedure.subtype}
                      </Text>
                    </Box>
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      flexShrink={0}
                      ml={1}
                    >
                      <Box
                        as="button"
                        w="16px"
                        h="16px"
                        minW="16px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleProcedureDelete(procedure);
                        }}
                        _hover={{ opacity: 0.7 }}
                      >
                        <Image w="10px" src="/assets/imgs/delete.png" />
                      </Box>
                    </Box>
                  </Box>
                </GridItem>
              ))}

            {/* Saved Procedures - Dark Purple */}
            {savedProcedures.map((procedure, index) => (
              <GridItem key={`saved-procedure-${procedure.orderid}-${index}`} display="flex">
                <Box
                  width="100%"
                  minH="40px"
                  p={2}
                  border="2px solid"
                  borderColor="teal.400"
                  borderRadius="md"
                  bg="teal.50"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  overflow="hidden"
                >
                  <Box 
                    flex="1" 
                    minW="0"
                    mr={2}
                    overflowX="auto"
                    overflowY="hidden"
                    // with scrollbar
                        // css={{
                        //   scrollbarWidth: 'thin',
                        //   scrollbarColor: '#CBD5E0 transparent',
                        //   '&::-webkit-scrollbar': {
                        //     height: '3px',
                        //   },
                        //   '&::-webkit-scrollbar-track': {
                        //     background: 'transparent',
                        //   },
                        //   '&::-webkit-scrollbar-thumb': {
                        //     backgroundColor: '#CBD5E0',
                        //     borderRadius: '3px',
                        //   },
                        // }}

                        // without scrollbar
                    css={{
                      '&::-webkit-scrollbar': {
                        display: 'none',
                      },
                      '-ms-overflow-style': 'none',
                      'scrollbar-width': 'none',
                      cursor: 'grab',
                      '&:active': {
                        cursor: 'grabbing',
                      },
                    }}
                    onWheel={(e) => {
                      if (e.shiftKey) {
                        e.preventDefault();
                        e.currentTarget.scrollLeft += e.deltaY;
                      }
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontSize="xs"
                      color="teal.800"
                      whiteSpace="nowrap"
                      display="inline-block"
                      minWidth="min-content"
                    >
                      {procedure.subtype}
                    </Text>
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    flexShrink={0}
                    ml={1}
                  >
                    <Box
                      as="button"
                      w="16px"
                      h="16px"
                      minW="16px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleProcedureDelete(procedure);
                      }}
                      _hover={{ opacity: 0.7 }}
                    >
                      <Image w="10px" src="/assets/imgs/delete.png" />
                    </Box>
                  </Box>
                </Box>
              </GridItem>
            ))}
          </Grid>
        )}
      </Box>
      
      {/* Save Buttons for Unsaved Items */}
      {(
        selectedMedicines.filter(med => med.isactive !== 0 && !med.issaved).length > 0 ||
        selectedLabs.filter(lab => !savedLabs.some(savedLab => savedLab.id === lab.id)).length > 0 ||
        selectedImaging.filter(imaging => !savedImaging.some(savedImg => savedImg.id === imaging.id)).length > 0 ||
        selectedProcedures.filter(procedure => !savedProcedures.some(savedPro => savedPro.id === procedure.id)).length > 0 ||
        selectedVaccines.filter(vaccine => !savedVaccines.some(savedVacc => savedVacc.id === vaccine.id)).length > 0
      ) && (
        <Box display="flex" justifyContent="flex-end" gap={2} mt={2} mb={1}>
          <Button
            size="sm"
            colorScheme="blue"
            onClick={handleSaveAllOrders}
            isLoading={isSavingLabs || isSavingImaging || isSavingVaccines || isSavingProcedures}
            loadingText="Saving New Orders..."
          >
            Save Orders
          </Button>
        </Box>
      )}
    </Box>
  }
/>
  </Box>
  </Flex>
</Box>
              </Flex>
            </Box>
          </Flex>

          {/* new modals */}
            {/* reAssign MOdal  */}
        <DynamicModal
        ref={reAssignModal}
        modalHeader="Re-Assign Appointment"
        modalBody={
          <>
            <Box>
            <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Doctor Name*"
                      options={DoctorListForDropdown}
                      id="Doctor Name"
                      // onClick={HandleEditDoctor}
                      // defaultOption={DefaultDoctor}
                      menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                      inputStyleCss={{ w: "100%" }}
                    />
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText="Re-Assign"
              // onClick={}
            />
          </>
        }
      />
        </Box>
      ) : (
        <>
        <MobileNavbar />
        </>
      )}

      <DynamicModal
                ref={addPrescriptionMedication}
                modalHeader="Add medication"
                // modalWidth="900px"
      modalWidth={{base:'100%', md: 'calc(100vw - 10%)'}}
                hasFooter= {true}
                modalBody={
                  <>
                  {showAddCard && (
                <Box
                  // p="20px"
                  // border="1px solid gray"
                  borderRadius="10px"
                  ml="0px"
                  // mb="10rem"
                >
                  <Stack spacing={4}>
                    {/* Row 1: MedicineName, Manufacturer, Composition,Fetch */}
                    <Flex
                      width="100%"
                      justifyContent="space-between"
                      alignItems="center"
                      flexDir={{ base: "column", md: "row" }}
                    >
                      <Box width={{ base: "100%", md: "45%" }}>
                        <Box w="100%" pos="relative" cursor="pointer">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace="Medicine name"
                            inputValue={newMedicine.medicinename}
                            onChange={(e) => {
                              handleNewMedicineChange(
                                "medicinename",
                                e.target.value
                              );
                              // filterMedicineNames(e.target.value);
                              setShowMedicineNamesDropdown(1);
                              setBoolValForSuggestions(!boolValForSuggestions);
                            }}
                            inputIdProp={"MedicineNameInAdd" + 1}
                            boolProp={boolValForSuggestions}
                            onKeyDown={(e) => handleKeyDown(e, 1)}
                            autoFocus={showMedicineNamesDropdown === 1}
                            autocomplete="off"
                          />
                          <Image
                            top="33%"
                            right="6.5%"
                            w="15px"
                            pos="absolute"
                            src="/assets/imgs/double-arrow.png"
                          />
                        </Box>
                        {showMedicineNamesDropdown === 1 &&
                          suggestions.length > 0 && (
                            <Menu isOpen={true}>
                              <MenuButton
                                as={Box}
                                w="100%"
                                display="block"
                                pos="relative"
                                zIndex="999"
                              >
                                <Box
                                  pos="absolute"
                                  top="100%"
                                  left="0"
                                  w="100%"
                                  bg="white"
                                  borderTop="none"
                                  border="1px solid #E6E7E9"
                                  borderRadius="0 0 12px 12px"
                                />
                              </MenuButton>
                              <MenuList
                                w="100%"
                                borderRadius="0 0 12px 12px"
                                zIndex="999"
                                bg="white"
                                maxH="150px"
                                overflow="hidden auto"
                                ref={suggestionsMenuRef}
                              >
                                {suggestions.map((suggestion, sIndex) => (
                                  <MenuItem
                                    key={sIndex}
                                    onClick={() => handleSelect(suggestion, 1)}
                                    cursor="pointer"
                                    p="1rem"
                                    py="0.5rem"
                                    borderBottom="1px solid #E6E7E9"
                                    bg={
                                      focusedItemIndex === sIndex
                                        ? "#f0f0f0"
                                        : "white"
                                    }
                                  >
                                    <Text fontSize="0.875rem" fontWeight="500">
                                      {suggestion.productname +
                                        " (" +
                                        suggestion.remainingquantity +
                                        " Qty)"}
                                    </Text>
                                  </MenuItem>
                                ))}
                              </MenuList>
                            </Menu>
                          )}
                      </Box>
                      <Box width={{ base: "100%", md: "45%" }}>
                        <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Manufacturer"
                          inputValue={newMedicine.manufacturer || ""}
                          onChange={(e) =>
                            handleNewMedicineChange(
                              "manufacturer",
                              e.target.value
                            )
                          }
                        />
                      </Box>
                      <Box width={{ base: "100%", md: "45%" }}>
                        <PrimaryInput
                          key={key}
                          type="text"
                          variant={"bothSide"}
                          inputPlace="Medicine Composition"
                          inputValue={newMedicine.composition}
                          onChange={(e) =>
                            handleNewMedicineChange(
                              "composition",
                              e.target.value
                            )
                          }
                        />{" "}
                      </Box>
                      <Box
                                as="button"
                                type="button"
                                border="1px solid #E6E7E9"
                                // borderRadius="full"
                                width={{ base: "100%", md: "10%" }}
                                // w="40px"
                                // h="40px"
                                p="8px"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                                // opacity={medicineTextFieldValue ? 1 : 0.5}
                                // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                                onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchComposition(newMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                bg="white"
                                _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                              >
                                <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                              </Box>
                      {/* <Box width={{ base: "100%", md: "10%" }}>
                        <PrimaryButton
                          buttonText="Fetch"
                          verticalAlign="bottom"
                          variant="grayBtn"
                          btnStyle={{
                            w: "100%",
                            color: COLORS.PRIMARY_COLOR,
                            verticalAlign: "bottom",
                            ml: { base: "0", md: "4px" },
                            mb: "0px",
                            h: "2.8rem",
                            opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                          }}
                          onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchComposition(newMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                        />
                      </Box> */}
                    </Flex>
                    
                    {/* Row 2: Medicine Type Selection */}
            <Box>
              <RadioGroup
                value={additionalMedicineTypes.includes(newMedicine.medicinetype) ? "" : newMedicine.medicinetype}
                onChange={(value) => handleTypeChange(value)}
              >
                <Flex direction="row" alignItems="center" flexWrap="wrap" gap="8px" fontSize="0.85rem">
                  <Radio colorScheme="green" value="Tablet" size="sm">Tablet</Radio>
                  <Radio colorScheme="green" value="Capsule" size="sm">Capsule</Radio>
                  <Radio colorScheme="green" value="Syrup" size="sm">Syrup</Radio>
                  <Radio colorScheme="green" value="Drops" size="sm">Drops</Radio>
                  <Radio colorScheme="green" value="Injection" size="sm">Injection</Radio>
                  <Radio colorScheme="green" value="Nebulization" size="sm">Nebulization</Radio>
                  <Radio colorScheme="green" value="IVFluids" size="sm">IV Fluids</Radio>
                  <Radio colorScheme="green" value="Inhaler" size="sm">Inhaler</Radio>
                  <Radio colorScheme="green" value="Sachet" size="sm">Sachet</Radio>
                  <Radio colorScheme="green" value="Ointment" size="sm">Ointment</Radio>
                  <Radio colorScheme="green" value="Cream" size="sm">Cream</Radio>
                  <Radio colorScheme="green" value="Gel" size="sm">Gel</Radio>
                  <Text fontSize="0.85rem" color="gray.500">-Or-</Text>
                  <Box width="160px">
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="More Types"
                      options={additionalMedicineTypes}
                      onClick={(value) => handleTypeChange(value)}
                      value={dropdownMedType}
                      defaultOption={dropdownMedType || "Select more types"}
                    />
                  </Box>
                </Flex>
              </RadioGroup>
            </Box>
            <Divider my={2} />

                    <Box>
                    {/* Row 3: DrugClass, Therapeutic, Strength, Quantity */}
                      <Box
                        display="flex"
                        flexDir={{ base: "column", md: "row" }}
                      >
                        <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Drug Class"
                          inputValue={newMedicine.drugclass || ""}
                          onChange={(e) =>
                            handleNewMedicineChange(
                              "drugclass",
                              e.target.value
                            )
                          }
                        />
                        <PrimaryInput
                          variant={"bothSide"}
                          // onChange={handleTherapeuticCategory}
                          inputPlace="Therapeutic category"
                          inputValue={newMedicine.therapeutic || ""}
                          onChange={(e) =>
                            handleNewMedicineChange(
                              "therapeutic",
                              e.target.value
                            )
                          }
                        />

                        {newMedicine.medicinetype === "Tablet" || 
 newMedicine.medicinetype === "Capsule" || 
 newMedicine.medicinetype === "Suppository" || 
 newMedicine.medicinetype === "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Inhaler" || 
    newMedicine.medicinetype === "Spray" || 
    newMedicine.medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Volume"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Syrup" ||
    newMedicine.medicinetype === "Drops" ||
    newMedicine.medicinetype === "Injection" ||
    newMedicine.medicinetype === "Nebulization" ||
    newMedicine.medicinetype === "IVFluids" ||
    newMedicine.medicinetype === "Suspension" ||
    newMedicine.medicinetype === "Respules" ||
    newMedicine.medicinetype === "Gargle" ||
    newMedicine.medicinetype === "Shampoo" ||
    newMedicine.medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Ointment" ||
    newMedicine.medicinetype === "Cream" ||
    newMedicine.medicinetype === "Gel" ||
    newMedicine.medicinetype === "Foam" ||
    newMedicine.medicinetype === "Lotion" ||
    newMedicine.medicinetype === "Tube" ||
    newMedicine.medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "grms", value: "grms" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Weight/Volume"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "EA" || 
    newMedicine.medicinetype === "Device" || 
    newMedicine.medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : (
  // Default case for CUSTOM and any other types
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp={newMedicine.medicinetype === "Custom" ? "Custom Unit" : "Strength/Volume"}
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
)}

                {/* {(newMedicine.medicinetype !== "Syrup" &&  */}
             {(newMedicine.medicinetype !== "Drops" && 
             newMedicine.medicinetype !== "IVFluids" && 
             newMedicine.medicinetype !== "Injection" && 
             newMedicine.medicinetype !== "Nebulization" && 
             newMedicine.medicinetype !== "Inhaler") && (
               <DropdownInput
                 variant="bothSide"
                 dropDownPlace={(newMedicine.medicinetype === "Syrup" || newMedicine.medicinetype === "Cream" || newMedicine.medicinetype === "Ointment" || newMedicine.medicinetype === "Gel") ? "Product Quantity" : "Consumption Quantity"}
                 options={(newMedicine.medicinetype === "Syrup" || newMedicine.medicinetype === "Cream" || newMedicine.medicinetype === "Ointment" || newMedicine.medicinetype === "Gel") ? ["1", "2", "3", "4"] : ["0.5", "1", "2", "3", "4"]}
                 onClick={(value) => {
                   handleNewMedicineChange("frequency", value);
                 }}
                 value={newMedicine.frequency}
               />

             )}
                        
                      </Box>

                    {/* Row 4: Duration, IntervalValue, StartDate, EndDate */}
                    {!(newMedicine.medicinetype === "Syrup" || newMedicine.medicinetype === "Cream" || newMedicine.medicinetype === "Ointment" || newMedicine.medicinetype === "Gel") && (
                      <Box display="flex" flexDir="row">
                        <Box width="25%">
                          <DropdownInput
                            variant="bothSide"
                            dropDownPlace={
                              newMedicine.medicinetype === "IVFluids"
                                ? "Infusion Frequency"
                                : newMedicine.medicinetype === "Ointment"
                                ? "Application Duration"
                                : "Duration"
                            }
                            options={["Days", "Weeks", "Months", "Years"]} 
                            onClick={handleIntervalNewChange}
                            value={newMedicine.durationunit} // Use from newMedicine state
                          />
                        </Box>
                        <Box width="25%">
                          <PrimaryInput
                            variant={"bothSide"}
                            inputType="number"
                            inputValue={newMedicine.durationvalue} // Controlled input
                            onChange={handleIntervalNewValueChange}
                            inputPlace={
                              newMedicine.medicinetype === "IVFluids"
                                ? "Infusion Duration"
                                : "Interval Value"
                            }
                          />
                        </Box>
                        {/* Start date, End date */}
                        <Box width={"50%"} display="flex" flexDir="row">
                          <DatePicker
                            dateWidth="50%"
                            defaultDate={newMedicine.medicationstartdate}
                            minDate={newMedicine.medicationstartdate}
                            onDateChange={(selectedDateValue) =>
                              handleNewMedicineChange(
                                "medicationstartdate",
                                selectedDateValue
                              )
                            }
                            placeholderProp={"Start Date"}
                            calendarStlye={{
                              left: "-18px",
                              right: "unset",
                            }}
                          />
                          <DatePicker
                            dateWidth="50%"
                            key={newMedicine.medicationenddate}
                            defaultDate={newMedicine.medicationenddate}
                            disableDatePicker={true}
                            minDate={newMedicine.medicationstartdate}
                            onDateChange={(selectedDateValue) =>
                              handleNewMedicineChange(
                                "medicationenddate",
                                selectedDateValue
                              )
                            }
                            placeholderProp={"End Date"}
                            calendarStlye={{
                              transform: "scale(0.9)",
                              right: "-22px",
                              top: "30px",
                              pointerEvents: "none", // Disable interaction
                              opacity: 0.5, // Visually indicate disabled state
                            }}
                          />
                        </Box>
                      </Box>
                    )}
                    
                    {/* Row 5: RouteAdministration, Timing / Quantity, AreaApplication / Diluent, RateInfusion / Additives */}
                      <Box display="flex" flexDir="row">
                        {newMedicine.medicinetype == "Injection" && (
                          <>
                            <Box width={"50%"}>
                              <DropdownInput
                                variant="downSide"
                                dropDownPlace="Route of Administration"
                                options={[
                                  "Intravenous (IV)",
                                  "Intramuscular (IM)",
                                  "Subcutaneous (SC)",
                                ]}
                                onClick={(value) =>
                                  handleNewMedicineChange(
                                    "routeofadministration",
                                    value
                                  )
                                }
                              />
                            </Box>
                            <Box width={"50%"}>
                              <PrimaryInput
                                variant={"bothSide"}
                                onChange={(e) =>
                                  handleNewMedicineChange(
                                    "timingofinjection",
                                    e.target.value
                                  )
                                }
                                inputPlace="Timing"
                              />
                            </Box>
                          </>
                        )}
                        {(newMedicine.medicinetype == "Ointment" || newMedicine.medicinetype == "Cream" || newMedicine.medicinetype == "Gel") && (
                          <>
                            {/* Topical descriptive Quantity (legacy) - restored */}
                            <DropdownInput
                              variant="downSide"
                              dropDownPlace="Quantity"
                              options={[
                                "Pea-sized",
                                "Thin layer",
                                "Fingertip unit (FTU)",
                                "Half a fingertip",
                              ]}
                              onClick={(value) =>
                                handleNewMedicineChange(
                                  "quantitytobeapplied",
                                  value
                                )
                              }
                              // show previous value if any
                              value={newMedicine.quantitytobeapplied || ""}
                            />
                            <DropdownInput
                              variant="downSide"
                              dropDownPlace="Area of Application"
                              options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                              onClick={(value) => handleNewMedicineChange("areaofapplication", value)}
                              value={newMedicine.areaofapplication || ""}
                            />
                          </>
                        )}

                        {newMedicine.medicinetype == "Nebulization" && (
                          <>
                            <DropdownInput
                              variant="downSide"
                              dropDownPlace="Diluent"
                              options={["Normal saline", "Distilled water","3% saline"]}
                              onClick={(value) =>
                                handleNewMedicineChange("diluent", value)
                              }
                            />
                          </>
                        )}

                        {newMedicine.medicinetype == "IVFluids" && (
                          <>
                            <MiniDropdownInput
                              variant="bothside"
                              options={[
                                { label: "ml/hr", value: "ml/hr" },
                                { label: "ml/min", value: "ml/min" },
                                // { label: "mg/hr", value: "mg/hr" },
                                // { label: "grms/hr", value: "grms/hr" },
                              ]}
                              handleInputChange={(e) =>
                                handleNewMedicineChange(
                                  "rateofinfusionvalue",
                                  validationOfNumberWithOnly1Decimal(
                                    e.target.value
                                  )
                                )
                              }
                              placeholderProp={"Rate of Infusion"}
                              onSelect={(selectedOption) =>
                                handleEditMedicineChange(
                                  "rateofinfusionunit",
                                  selectedOption.label
                                )
                              }
                              maxLength="6"
                            />
                            <PrimaryInput
                              variant={"bothSide"}
                              onChange={(e) =>
                                handleNewMedicineChange(
                                  "additives",
                                  e.target.value
                                )
                              }
                              inputPlace="Additives"
                            />
                          </>
                        )}
                      </Box>

                    {/* Row 6: MealTiming or Frequency / Before/AfterFood / ApplicationTiming, WhereToApply */}
                      <CheckboxGroup colorScheme="green">
  <Stack
    spacing={2}
    pt="20px"
    direction="row"
    alignItems='center'
    flexWrap={{ base: "wrap", md: "nowrap" }}
  >
    {/* COMMENTED OUT - Replaced with dropdown */}
    {/* <Checkbox
      isChecked={newMedicine.morning === 1}
      onChange={() => {
        // Uncheck frequency inputs when checking a time checkbox
        if (newMedicine.morning !== 1) {
          handleNewMedicineChange("frequencytime", "");
          handleNewMedicineChange("frequencyvalue", "");
        }
        handleNewMedicineChange(
          "morning",
          newMedicine.morning === 1 ? 0 : 1
        );
      }}
    >
      Morning
    </Checkbox>
    <Checkbox
      isChecked={newMedicine.afternoon === 1}
      onChange={() => {
        // Uncheck frequency inputs when checking a time checkbox
        if (newMedicine.afternoon !== 1) {
          handleNewMedicineChange("frequencytime", "");
          handleNewMedicineChange("frequencyvalue", "");
        }
        handleNewMedicineChange(
          "afternoon",
          newMedicine.afternoon === 1 ? 0 : 1
        );
      }}
    >
      Afternoon
    </Checkbox>
    <Checkbox
      isChecked={newMedicine.night === 1}
      onChange={() => {
        // Uncheck frequency inputs when checking a time checkbox
        if (newMedicine.night !== 1) {
          handleNewMedicineChange("frequencytime", "");
          handleNewMedicineChange("frequencyvalue", "");
        }
        handleNewMedicineChange(
          "night",
          newMedicine.night === 1 ? 0 : 1
        );
      }}
    >
      Night
    </Checkbox> */}

    {/* Dropdown for Meal Timing */}
    <Box width='180px'>
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Meal Timing"
        arrowCSS={{pr:0}}
        options={[
          "1-0-0",
          "0-1-0",
          "0-0-1",
          "1-1-0",
          "1-0-1",
          "0-1-1",
          "1-1-1",
          "0-0-0"
          // "1-0-0 (Morning)",
          // "0-1-0 (Afternoon)",
          // "0-0-1 (Night)",
          // "1-1-0 (Morning & Afternoon)",
          // "1-0-1 (Morning & Night)",
          // "0-1-1 (Afternoon & Night)",
          // "1-1-1 (All three)",
          // "0-0-0 (None)"
        ]}
        onClick={(value) => {
          if (value) {
            const { morning, afternoon, night } = parseMealTiming(value);
            handleNewMedicineChange("morning", morning);
            handleNewMedicineChange("afternoon", afternoon);
            handleNewMedicineChange("night", night);
            // Clear frequency inputs when selecting meal timing
            handleNewMedicineChange("frequencytime", "");
            handleNewMedicineChange("frequencyvalue", "");
          }
        }}
        value={getMealTimingLabel(newMedicine.morning, newMedicine.afternoon, newMedicine.night)}
      />
    </Box>

    <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>
    <Box display='flex'>
    <Box width='120px'>
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Frequency"
        arrowCSS={{pr:0}}
        options={["Hours", "Daily", "Weekly"]}
        onClick={(value) => {
          // Uncheck time checkboxes when selecting frequency
          if (value) {
            handleNewMedicineChange("morning", 0);
            handleNewMedicineChange("afternoon", 0);
            handleNewMedicineChange("night", 0);
          }
          handleNewMedicineChange("frequencytime", value || "");
        }}
        // defaultOption={"Hours"}
        value={newMedicine.frequencytime || ""}
      />
    </Box>

    <Box width='80px'>
      <DropdownInputForVitals
        variant="bothSide"
        dropDownPlace="Value"
        arrowCSS={{pr:0}}
        options={["1", "2", "3", "4", "8"]}
        readOnly=""
        maxLength={2}
        onClick={(value) => {
          // Uncheck time checkboxes when selecting value
          if (value) {
            handleNewMedicineChange("morning", 0);
            handleNewMedicineChange("afternoon", 0);
            handleNewMedicineChange("night", 0);
            handleNewMedicineChange("frequencyvalue", value);
          }
        }}
        onChange={(e) => {
          // Handle manual text input for value
          const value = e.target.value;
          console.log('e, ', e)
          if (value) {
            handleNewMedicineChange("morning", 0);
            handleNewMedicineChange("afternoon", 0);
            handleNewMedicineChange("night", 0);
          }
          handleNewMedicineChange("frequencyvalue", value);
        }}
        value={newMedicine.frequencyvalue}
        inputValueProp={newMedicine.frequencyvalue}
        
      />
    </Box>
    </Box>
    <Spacer />
    {/* <RadioGroup
      value={newMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
      display='flex'
      justifyItems='start'
      flexWrap='wrap'
      gap='0.5rem'
      onChange={(value) => {
        if (value === "beforefood") {
          handleNewMedicineChange("beforefood", 1);
          handleNewMedicineChange("afterfood", 0);
        } else if (value === "afterfood") {
          handleNewMedicineChange("beforefood", 0);
          handleNewMedicineChange("afterfood", 1);
        }
      }}
    >
      <Radio value="beforefood" colorScheme="green">Before Food</Radio>
      <Radio value="afterfood" colorScheme="green">After Food</Radio>
    </RadioGroup> */}
    {/* Timing options: for topical medicines (Cream/Ointment) show topical timing + apply-to, otherwise food timing */}
    {(newMedicine.medicinetype === "Cream" || newMedicine.medicinetype === "Ointment" || newMedicine.medicinetype === "Gel") ? (
      <Box>
        {/* <Text fontSize="sm" mb={1}>Application Timing</Text> */}
        <DropdownInput
          variant="downSide"
          dropDownPlace="Application Timing"
          options={[
            "After Bath",
            "Before Bath",
            "After Sun",
            "Before Sun",
            "Time-based",
          ]}
          onClick={(value) => {
            // topical timing stored in timing; clear food flags
            handleNewMedicineChange("timing", value);
            handleNewMedicineChange("beforefood", 0);
            handleNewMedicineChange("afterfood", 0);
          }}
          value={newMedicine.timing || ""}
        />
      </Box>
    ) : (
      <RadioGroup
        value={newMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
        display='flex'
        justifyItems='start'
        flexWrap='wrap'
        gap='0.5rem'
        onChange={(value) => {
          if (value === "beforefood") {
            handleNewMedicineChange("beforefood", 1);
            handleNewMedicineChange("afterfood", 0);
            handleNewMedicineChange("timing", "Before Food");
          } else if (value === "afterfood") {
            handleNewMedicineChange("beforefood", 0);
            handleNewMedicineChange("afterfood", 1);
            handleNewMedicineChange("timing", "After Food");
          }
        }}
      >
        <Radio value="beforefood" colorScheme="green">Before Food</Radio>
        <Radio value="afterfood" colorScheme="green">After Food</Radio>
      </RadioGroup>
    )}
  </Stack>
</CheckboxGroup>

                      <Divider my="10px" />

                    {/* Row 7: Instructions Text area */}
<Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
  <Box
    as="form"
    width='100%'
    bg="white"
    pt={"2px"}
  >
    <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
      <Textarea
        borderRadius='0'
        value={newMedicine.custommessage || ''}
        onChange={(e) => {
    handleNewMedicineChange("custommessage", e.target.value);
    setMedicineValue("textField", e.target.value); // Keep form sync if needed
  }}
        height="100%"
        padding="2"
        resize="none"
        // disabled={typing} // Disable when AI typing is true
        style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
      />
      
      {!newMedicine.custommessage && (
        <Text
          position="absolute"
          bottom="2"
          left="50%"
          transform="translateX(-50%)"
          fontSize="sm"
          color="gray.500"
          w={{ base: "100%", md: "unset" }}
          textAlign={{ base: "center", md: "unset" }}
        >
          {medicinePlaceholder}
        </Text>
      )}
    </Box>
    
  </Box>
</Box>

                    {/* Row 8: Input/Output Language, AudioRecorder */}
{/* Audio & Language Controls Row - Highlighted Section */}
                    <Box
                      bg="#f8f9fa"
                      border="1px solid #e9ecef"
                      borderRadius="8px"
                      p="0.5rem"
                      mt="1rem"
                      // mb="1rem"
                    >
                      <Flex
                        alignItems="center"
                        justifyContent="space-around"
                        // justifyContent="space-between"
                        gap="1rem"
                        flexWrap={{ base: "wrap", md: "nowrap" }}
                      >
                        {/* Input Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleMedicineChangeLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Input Language"
                          />
                        </Box>
                        
                        {/* Audio Controls and Wave Display */}
                        <Box 
                    flex="1"
                    display="flex" 
                    alignItems="center" 
                    justifyContent="center"
                    gap="0.75rem"
                    minH="50px"
                    px="1rem"
                  >
                    <GPUChatAudioManagerSpeechMode
                      transcriber={medicineTranscriber}
                      mode={medicineMode}
                      setPlaceholder={setMedicinePlaceholder}
                      setTyping={setMedicineTyping}
                      onTranscribedText={(text) => {
                        handleNewMedicineChange("custommessage", text);
                        setMedicineValue("textField", text); 
                      }}
                      onRecordingStateChange={handleRecordingStateChange} 
                    />
              
                    {isRecording && (
                      <Box flex="1" minW="180px" maxW="250px">
                        <AudioDisplayForClutter
                          borderRadius="lg"
                          stream={stream}
                          width="100%"
                        />
                      </Box>
                    )}
                  </Box>
              
                        {/* Output Language Dropdown */}
                        <Box flex="1" minW="120px">
                          <DropdownWithMultiLingual 
                            menuList={{pos:'relative', right:'75px'}}
                            placeholder="English"
                            onClick={handleChangeMedicineOutputLanguage}
                            options={languageOptions.map(value => ({ value }))}
                            title="Output Language"
                          />
                        </Box>
              
                        {/* AI Correction Button */}
                        <Box
                          as="button"
                          type="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="40px"
                          h="40px"
                          p="8px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                          opacity={medicineTextFieldValue ? 1 : 0.5}
                          pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                          onClick={() => medicineTextFieldValue && correctMedOrders("add")}
                          flexShrink="0"
                          bg="white"
                          _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                        >
                          <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                        </Box>
                      </Flex>
                    </Box>

<Divider my="10px" />
                    </Box>
                  </Stack>
                </Box>
              )}    
                  </>
                }
                modalFooterBtn={
    <HStack width="100%" justifyContent="flex-end" gap="1rem">
      <PrimaryButton
        buttonText="Cancel"
        variant="grayBtn"
        btnStyle={{
          w: "auto",
          h: "2.5rem",
          px: "2rem",
        }}
        onClick={() => addPrescriptionMedication.current?.closeModal?.()}
      />
      <PrimaryButton
        buttonText="Save Medicines"
        btnStyle={{
          w: "auto",
          h: "2.5rem",
          px: "2rem",
        }}
        onClick={handleSaveMedicine}
      isDisabled={!newMedicine.medicinename}
        // onClick={saveSelectedMedicinesToOrders}
      />
    </HStack>
  }
              />
      <DynamicModal
                      ref={editSelectedPrescriptionMedication}
                      modalHeader="Edit medication"
                      // modalWidth="900px"
            modalWidth={{base:'100%', md: 'calc(100vw - 10%)'}}
                      hasFooter= {true}
                      modalBody={
                        <>
                        {selectedMedicines
                      .filter((medicine) => medicine.isactive !== 0)
                      .map((medicine) => (
                        <Box key={medicine.id}>
                          {/* {editMedicine && editMedicine.id === medicine.id && ( */}
                          {editMedicine && editMedicine.id === medicine.id && (
                            <Box
                              // p="20px"
                              // border="1px solid gray"
                              borderRadius="10px"
                              mt="10px" // Add some margin-top to separate from the above row
                            >
                              <Stack spacing={4}>

                    {/* Row 1: MedicineName, Manufacturer, Composition,Fetch */}
                                <Flex
                                  width="100%"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box width="45%">
                                    <Box w="100%" pos="relative" cursor="pointer">
                                      <PrimaryInput
                                        variant="bothSide"
                                        inputPlace="Medicine name"
                                        inputValue={editMedicine.medicinename}
                                        onChange={(e) => {
                                          handleEditMedicineChange(
                                            "medicinename",
                                            e.target.value
                                          );
                                          // filterMedicineNames(e.target.value);
                                          setShowMedicineNamesDropdown(0);
                                          setBoolValForSuggestions(
                                            !boolValForSuggestions
                                          );
                                        }}
                                        inputIdProp={"MedicineNameInAdd" + 0}
                                        boolProp={boolValForSuggestions}
                                        onKeyDown={(e) => handleEditKeyDown(e, 0)}
                                        autoFocus={showMedicineNamesDropdown === 0}
                                        autocomplete="off"
                                      />
                                      <Image
                                        top="33%"
                                        right="6.5%"
                                        w="15px"
                                        pos="absolute"
                                        src="/assets/imgs/double-arrow.png"
                                      />
                                    </Box>
                                    {showMedicineNamesDropdown === 0 &&
                                      suggestions.length > 0 && (
                                        <Menu isOpen={true}>
                                          <MenuButton
                                            as={Box}
                                            w="100%"
                                            display="block"
                                            pos="relative"
                                            zIndex="999"
                                          >
                                            <Box
                                              pos="absolute"
                                              top="100%"
                                              left="0"
                                              w="100%"
                                              bg="white"
                                              borderTop="none"
                                              border="1px solid #E6E7E9"
                                              borderRadius="0 0 12px 12px"
                                            />
                                          </MenuButton>
                                          <MenuList
                                            w="100%"
                                            borderRadius="0 0 12px 12px"
                                            zIndex="999"
                                            bg="white"
                                            maxH="150px"
                                            overflow="hidden auto"
                                            ref={suggestionsMenuRef}
                                          >
                                            {suggestions.map((suggestion, sIndex) => (
                                              <MenuItem
                                                key={sIndex}
                                                onClick={() =>
                                                  handleEditSelect(suggestion, 0)
                                                }
                                                cursor="pointer"
                                                p="1rem"
                                                py="0.5rem"
                                                borderBottom="1px solid #E6E7E9"
                                                bg={
                                                  focusedItemIndex === sIndex
                                                    ? "#f0f0f0"
                                                    : "white"
                                                }
                                              >
                                                <Text
                                                  fontSize="0.875rem"
                                                  fontWeight="500"
                                                >
                                                  {suggestion.productname +
                                                    " (" +
                                                    suggestion.remainingquantity +
                                                    " Qty)"}
                                                </Text>
                                              </MenuItem>
                                            ))}
                                          </MenuList>
                                        </Menu>
                                      )}
                                  </Box>
                                  <Box width={{ base: "100%", md: "45%" }}>
                              <PrimaryInput
                                key={key}
                                type="text"
                                variant={"bothSide"}
                                inputPlace="Manufacturer"
                                defaultValue={editMedicine.manufacturer || ""}
                                inputValue={editMedicine.manufacturer || ""}
                                onChange={(e) =>
                                  handleEditMedicineChange(
                                    "manufacturer",
                                    e.target.value
                                  )
                                }
                              />{" "}
                            </Box>
                                  <Box width="45%">
                                    <PrimaryInput
                                      key={compositionEditKey}
                                      type="text"
                                      variant="bothSide"
                                      inputPlace="Medicine Composition"
                                      defaultValue={editMedicine.composition}
                                      onChange={(e) =>
                                        handleEditMedicineChange(
                                          "composition",
                                          e.target.value
                                        )
                                      }
                                    />{" "}
                                  </Box>
                              <Box
                                as="button"
                                type="button"
                                border="1px solid #E6E7E9"
                                // borderRadius="full"
                                width={{ base: "100%", md: "10%" }}
                                // w="40px"
                                // h="40px"
                                p="8px"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                                // opacity={medicineTextFieldValue ? 1 : 0.5}
                                // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                                onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchCompositionForEdit(editMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                bg="white"
                                _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                              >
                                <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                              </Box>
                                </Flex>

                    {/* Row 2: Medicine Type Selection */}
            <Box>
              <RadioGroup
                value={additionalMedicineTypes.includes(editMedicine.medicinetype) ? "" : editMedicine.medicinetype}
                onChange={(value) => handleEditTypeChange(value)}
              >
                <Flex direction="row" alignItems="center" flexWrap="wrap" gap="8px" fontSize="0.85rem">
                  <Radio colorScheme="green" value="Tablet" size="sm">Tablet</Radio>
                  <Radio colorScheme="green" value="Capsule" size="sm">Capsule</Radio>
                  <Radio colorScheme="green" value="Syrup" size="sm">Syrup</Radio>
                  <Radio colorScheme="green" value="Drops" size="sm">Drops</Radio>
                  <Radio colorScheme="green" value="Injection" size="sm">Injection</Radio>
                  <Radio colorScheme="green" value="Nebulization" size="sm">Nebulization</Radio>
                  <Radio colorScheme="green" value="IVFluids" size="sm">IV Fluids</Radio>
                  <Radio colorScheme="green" value="Inhaler" size="sm">Inhaler</Radio>
                  <Radio colorScheme="green" value="Sachet" size="sm">Sachet</Radio>
                  <Radio colorScheme="green" value="Ointment" size="sm">Ointment</Radio>
                  <Radio colorScheme="green" value="Cream" size="sm">Cream</Radio>
                  <Radio colorScheme="green" value="Gel" size="sm">Gel</Radio>
                  <Text fontSize="0.85rem" color="gray.500">-Or-</Text>
                  <Box width="160px">
                    <DropdownInput
                      variant="bothSide"
                      dropDownPlace="More Types"
                      options={additionalMedicineTypes}
                      onClick={(value) => handleEditTypeChange(value)}
                      value={dropdownMedType}
                      defaultOption={dropdownMedType || "Select more types"}
                    />
                  </Box>
                </Flex>
              </RadioGroup>
            </Box>
            <Divider my={2} />

                  <Box>
                    {/* Row 3: DrugClass, Therapeutic, Strength, Quantity */}
                                  <Box display="flex" flexDir="row">
                                    <PrimaryInput
                                variant={"bothSide"}
                                inputPlace="Drug Class"
                                defaultValue={editMedicine.drugclass || ""}
                                inputValue={editMedicine.drugclass || ""}
                                onChange={(e) =>
                                  handleEditMedicineChange(
                                    "drugclass",
                                    e.target.value
                                  )
                                }
                              />
                              <PrimaryInput
                                variant={"bothSide"}
                                inputPlace="Therapeutic category"
                                defaultValue={editMedicine.therapeutic || ""}
                                inputValue={editMedicine.therapeutic || ""}
                                onChange={(e) =>
                                  handleEditMedicineChange(
                                    "therapeutic",
                                    e.target.value
                                  )
                                }
                              />

                              {editMedicine.medicinetype === "Tablet" || 
       editMedicine.medicinetype === "Capsule" || 
       editMedicine.medicinetype === "Suppository" || 
       editMedicine.medicinetype === "Powder" ? (
        <MiniDropdownInput
          variant="bothSide"
          options={[
            { label: "mg", value: "mg" },
            { label: "mcg", value: "mcg" },
            { label: "g", value: "g" },
          ]}
          placeholderProp="Strength"
          defaultValue={editMedicine.dosage}
          defaultOptionProp={editMedicine.dosageunit}
          onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
          handleInputChange={(event) =>
            handleEditMedicineChange(
              "dosage",
              validationOfNumberWithOnly1Decimal(event.target.value)
            )
          }
          inputVal={editMedicine.dosage}
          maxLength="6"
        />
      ) : editMedicine.medicinetype === "Inhaler" || 
          editMedicine.medicinetype === "Spray" || 
          editMedicine.medicinetype === "Aerosol" ? (
        <MiniDropdownInput
          variant="bothSide"
          options={[
            { label: "puffs", value: "puffs" },
            { label: "ml", value: "ml" },
          ]}
          placeholderProp="Volume"
          defaultValue={editMedicine.dosage}
          defaultOptionProp={editMedicine.dosageunit}
          onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
          handleInputChange={(event) =>
            handleEditMedicineChange(
              "dosage",
              validationOfNumberWithOnly1Decimal(event.target.value)
            )
          }
          inputVal={editMedicine.dosage}
          maxLength="6"
        />
      ) : editMedicine.medicinetype === "Syrup" ||
          editMedicine.medicinetype === "Drops" ||
          editMedicine.medicinetype === "Injection" ||
          editMedicine.medicinetype === "Nebulization" ||
          editMedicine.medicinetype === "IVFluids" ||
          editMedicine.medicinetype === "Suspension" ||
          editMedicine.medicinetype === "Respules" ||
          editMedicine.medicinetype === "Gargle" ||
          editMedicine.medicinetype === "Shampoo" ||
          editMedicine.medicinetype === "Topical Cleanser" ? (
        <MiniDropdownInput
          variant="bothSide"
          options={[{ label: "ml", value: "ml" }]}
          placeholderProp="Volume"
          defaultValue={editMedicine.dosage}
          defaultOptionProp={editMedicine.dosageunit}
          onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
          handleInputChange={(event) =>
            handleEditMedicineChange(
              "dosage",
              validationOfNumberWithOnly1Decimal(event.target.value)
            )
          }
          inputVal={editMedicine.dosage}
          maxLength="6"
        />
      ) : editMedicine.medicinetype === "Ointment" ||
          editMedicine.medicinetype === "Cream" ||
          editMedicine.medicinetype === "Gel" ||
          editMedicine.medicinetype === "Foam" ||
          editMedicine.medicinetype === "Lotion" ||
          editMedicine.medicinetype === "Tube" ||
          editMedicine.medicinetype === "Soap" ? (
        <MiniDropdownInput
          variant="bothSide"
          options={[
            { label: "grms", value: "grms" },
            { label: "ml", value: "ml" },
          ]}
          placeholderProp="Weight/Volume"
          defaultValue={editMedicine.dosage}
          defaultOptionProp={editMedicine.dosageunit}
          onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
          handleInputChange={(event) =>
            handleEditMedicineChange(
              "dosage",
              validationOfNumberWithOnly1Decimal(event.target.value)
            )
          }
          inputVal={editMedicine.dosage}
          maxLength="6"
        />
      ) : editMedicine.medicinetype === "EA" || 
          editMedicine.medicinetype === "Device" || 
          editMedicine.medicinetype === "Box" ? (
        <MiniDropdownInput
          variant="bothSide"
          options={[{ label: "each", value: "each" }]}
          placeholderProp="Count"
          defaultValue={editMedicine.dosage}
          defaultOptionProp={editMedicine.dosageunit}
          onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
          handleInputChange={(event) =>
            handleEditMedicineChange(
              "dosage",
              validationOfNumberWithOnly1Decimal(event.target.value)
            )
          }
          inputVal={editMedicine.dosage}
          maxLength="6"
        />
      ) : editMedicine.medicinetype === "Sachet" ? (
        <MiniDropdownInput
          variant="bothSide"
          options={[
            { label: "mg", value: "mg" },
            { label: "g", value: "g" },
          ]}
          placeholderProp="Strength"
          defaultValue={editMedicine.dosage}
          defaultOptionProp={editMedicine.dosageunit}
          onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
          handleInputChange={(event) =>
            handleEditMedicineChange(
              "dosage",
              validationOfNumberWithOnly1Decimal(event.target.value)
            )
          }
          inputVal={editMedicine.dosage}
          maxLength="6"
        />
      ) : (
        // Default case for CUSTOM and any other types
        <MiniDropdownInput
          variant="bothSide"
          options={[
            { label: "mg", value: "mg" },
            { label: "ml", value: "ml" },
            { label: "grms", value: "grms" },
            { label: "puffs", value: "puffs" },
            { label: "each", value: "each" },
          ]}
          placeholderProp={editMedicine.medicinetype === "Custom" ? "Custom Unit" : "Strength/Volume"}
          defaultValue={editMedicine.dosage}
          defaultOptionProp={editMedicine.dosageunit}
          onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
          handleInputChange={(event) =>
            handleEditMedicineChange(
              "dosage",
              validationOfNumberWithOnly1Decimal(event.target.value)
            )
          }
          inputVal={editMedicine.dosage}
          maxLength="6"
        />
      )}

    {/* {(editMedicine.medicinetype !== "Syrup" &&  */}
 {(editMedicine.medicinetype !== "Drops" && 
 editMedicine.medicinetype !== "IVFluids" && 
 editMedicine.medicinetype !== "Injection" && 
 editMedicine.medicinetype !== "Nebulization" && 
 editMedicine.medicinetype !== "Inhaler") && (
      <DropdownInput
          variant="bothSide"
          dropDownPlace={(editMedicine.medicinetype === "Syrup" || editMedicine.medicinetype === "Cream" || editMedicine.medicinetype === "Ointment" || editMedicine.medicinetype === "Gel") ? "Product Quantity" : "Consumption Quantity"}
          options={(editMedicine.medicinetype === "Syrup" || editMedicine.medicinetype === "Cream" || editMedicine.medicinetype === "Ointment" || editMedicine.medicinetype === "Gel") ? ["1", "2", "3", "4"] : ["0.5", "1", "2", "3", "4"]}
          onClick={(value) => {
            handleEditMedicineChange("frequency", value);
          }}
          value={editMedicine.frequency}
          />
        )}
          </Box>
      
                    {/* Row 4: Duration, IntervalValue, StartDate, EndDate */}
                    {!(editMedicine.medicinetype === "Syrup" || editMedicine.medicinetype === "Cream" || editMedicine.medicinetype === "Ointment" || editMedicine.medicinetype === "Gel") && (
                                <Box width='100%' display="flex" flexDir="row">
                                    <Box width="25%">
                                      <DropdownInput
                                        variant="bothSide"
                                        dropDownPlace={
                                          editMedicine.medicinetype === "IVFluids"
                                            ? "Infusion Frequency"
                                            : editMedicine.medicinetype === "Ointment"
                                            ? "Application Duration"
                                            : "Duration"
                                        }
                                        options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                                        onClick={handleIntervalChange}
                                        value={editMedicine.durationunit}
                                      />
                                    </Box>
                                    <Box width="25%">
                                      <PrimaryInput
                                        variant={"bothSide"}
                                        inputType="number"
                                        inputValue={editMedicine.durationvalue} // Controlled input
                                        onChange={handleIntervalValueChange}
                                        inputPlace={
                                          editMedicine.medicinetype === "IVFluids"
                                            ? "Infusion Duration"
                                            : "Interval Value"
                                        }
                                      />
                                    </Box>
                                    <Box width={"50%"} display="flex" flexDir="row">
                                      <DatePicker
                                        dateWidth="50%"
                                        defaultDate={editMedicine.medicationstartdate}
                                        minDate={newMedicine.medicationstartdate}
                                        onDateChange={(selectedDateValue) =>
                                          handleEditMedicineChange(
                                            "medicationstartdate",
                                            selectedDateValue
                                          )
                                        }
                                        placeholderProp={"Start Date"}
                                        calendarStlye={{
                                          left: "-18px",
                                          right: "unset",
                                        }}
                                      />
                                      <DatePicker
                                        dateWidth="50%"
                                        key={editMedicine.medicationenddate}
                                        defaultDate={editMedicine.medicationenddate}
                                        disableDatePicker={true}
                                        minDate={newMedicine.medicationstartdate}
                                        onDateChange={(selectedDateValue) =>
                                          handleEditMedicineChange(
                                            "medicationenddate",
                                            selectedDateValue
                                          )
                                        }
                                        placeholderProp={"End Date"}
                                        calendarStlye={{
                                          transform: "scale(0.9)",
                                          right: "-22px",
                                          top: "30px",
                                          pointerEvents: "none", // Disable interaction
                                          opacity: 0.5, // Visually indicate disabled state
                                        }}
                                      />
                                    </Box>
                                  </Box>
                    )}

                    {/* Row 5: RouteAdministration, Timing / Quantity, AreaApplication / Diluent, RateInfusion / Additives */}
                                  <Box display="flex" flexDir="row">
                                    {editMedicine.medicinetype == "Injection" && (
                                      <>
                                        <Box width={"50%"}>
                                          <DropdownInput
                                            variant="downSide"
                                            dropDownPlace="Route of Administration"
                                            options={[
                                              "Intravenous (IV)",
                                              "Intramuscular (IM)",
                                              "Subcutaneous (SC)",
                                            ]}
                                            onClick={(value) =>
                                              handleEditMedicineChange(
                                                "routeofadministration",
                                                value
                                              )
                                            }
                                            defaultOption={
                                              editMedicine.routeofadministration
                                            }
                                          />
                                        </Box>
                                        <Box width={"50%"}>
                                          <PrimaryInput
                                            variant={"bothSide"}
                                            onChange={(e) =>
                                              handleEditMedicineChange(
                                                "timingofinjection",
                                                e.target.value
                                              )
                                            }
                                            inputPlace="Timing"
                                            defaultValue={
                                              editMedicine.timingofinjection
                                            }
                                          />
                                        </Box>
                                      </>
                                    )}
                                    {(editMedicine.medicinetype == "Ointment" || editMedicine.medicinetype == "Cream" || editMedicine.medicinetype == "Gel") && (
                                      <>
                                        {/* Topical descriptive Quantity (legacy) - restored */}
                                        <DropdownInput
                                          variant="downSide"
                                          dropDownPlace="Quantity"
                                          options={[
                                            "Pea-sized",
                                            "Thin layer",
                                            "Fingertip unit (FTU)",
                                            "Half a fingertip",
                                          ]}
                                          onClick={(value) =>
                                            handleEditMedicineChange(
                                              "quantitytobeapplied",
                                              value
                                            )
                                          }
                                          defaultOption={
                                            editMedicine.quantitytobeapplied
                                          }
                                          value={editMedicine.quantitytobeapplied || ""}
                                        />
                                        <DropdownInput
                                          variant="downSide"
                                          dropDownPlace="Area of Application"
                                          options={["On Scalp", "On Skin", "On Wound", "On Hair"]}
                                          onClick={(value) => handleEditMedicineChange("areaofapplication", value)}
                                          value={editMedicine.areaofapplication || ""}
                                        />
                                      </>
                                    )}
      
                                    {editMedicine.medicinetype == "Nebulization" && (
                                      <>
                                        <DropdownInput
                                          variant="downSide"
                                          dropDownPlace="Diluent"
                                          options={[
                                            "Normal saline",
                                            "Distilled water",
                                            "3% saline",
                                          ]}
                                          onClick={(value) =>
                                            handleEditMedicineChange("diluent", value)
                                          }
                                          defaultOption={editMedicine.diluent}
                                        />
                                      </>
                                    )}
      
                                    {editMedicine.medicinetype == "IVFluids" && (
                                      <>
                                        <MiniDropdownInput
                                          variant="bothside"
                                          options={[
                                            { label: "ml/hr", value: "ml/hr" },
                                            { label: "ml/min", value: "ml/min" },
                                            // { label: "mg/hr", value: "mg/hr" },
                                            // { label: "grms/hr", value: "grms/hr" },
                                          ]}
                                          handleInputChange={(e) =>
                                            handleEditMedicineChange(
                                              "rateofinfusionvalue",
                                              validationOfNumberWithOnly1Decimal(
                                                e.target.value
                                              )
                                            )
                                          }
                                          placeholderProp={"Rate of Infusion"}
                                          onSelect={(selectedOption) =>
                                            handleEditMedicineChange(
                                              "rateofinfusionunit",
                                              selectedOption.label
                                            )
                                          }
                                          maxLength="6"
                                          defaultOptionProp={
                                            editMedicine.rateofinfusionunit
                                          }
                                          defaultValue={
                                            editMedicine.rateofinfusionvalue
                                          }
                                        />
                                        <PrimaryInput
                                          variant={"bothSide"}
                                          onChange={(e) =>
                                            handleEditMedicineChange(
                                              "additives",
                                              e.target.value
                                            )
                                          }
                                          inputPlace="Additives"
                                          defaultValue={editMedicine.additives}
                                        />
                                      </>
                                    )}
                                  </Box>
                    
                    {/* Row 6: MealTiming or Frequency / Before/AfterFood / ApplicationTiming, WhereToApply */}
                                  <CheckboxGroup colorScheme="green">
                                    <Stack spacing={2} alignItems='center' pt="20px" direction="row" flexWrap="wrap">
                                      {/* COMMENTED OUT - Replaced with dropdown */}
                                      {/* Time checkboxes */}
                                      {/* <Checkbox
                                        isChecked={editMedicine.morning === 1}
                                        onChange={() => {
                                          // Uncheck frequency inputs when checking a time checkbox
                                          if (editMedicine.morning !== 1) {
                                            handleEditMedicineChange("frequencytime", "");
                                            handleEditMedicineChange("frequencyvalue", "");
                                          }
                                          handleEditMedicineChange(
                                            "morning",
                                            editMedicine.morning === 1 ? 0 : 1
                                          );
                                        }}
                                      >
                                        Morning
                                      </Checkbox>
                                      
                                      <Checkbox
                                        isChecked={editMedicine.afternoon === 1}
                                        onChange={() => {
                                          // Uncheck frequency inputs when checking a time checkbox
                                          if (editMedicine.afternoon !== 1) {
                                            handleEditMedicineChange("frequencytime", "");
                                            handleEditMedicineChange("frequencyvalue", "");
                                          }
                                          handleEditMedicineChange(
                                            "afternoon",
                                            editMedicine.afternoon === 1 ? 0 : 1
                                          );
                                        }}
                                      >
                                        Afternoon
                                      </Checkbox>
                                      
                                      <Checkbox
                                        isChecked={editMedicine.night === 1}
                                        onChange={() => {
                                          // Uncheck frequency inputs when checking a time checkbox
                                          if (editMedicine.night !== 1) {
                                            handleEditMedicineChange("frequencytime", "");
                                            handleEditMedicineChange("frequencyvalue", "");
                                          }
                                          handleEditMedicineChange(
                                            "night",
                                            editMedicine.night === 1 ? 0 : 1
                                          );
                                        }}
                                      >
                                        Night
                                      </Checkbox> */}

                                      {/* Dropdown for Meal Timing */}
                                      <Box width='180px'>
                                        <DropdownInput
                                          variant="bothSide"
                                          dropDownPlace="Meal Timing"
                                          arrowCSS={{pr:0}}
                                          options={[
                                            "1-0-0",
                                            "0-1-0",
                                            "0-0-1",
                                            "1-1-0",
                                            "1-0-1",
                                            "0-1-1",
                                            "1-1-1",
                                            "0-0-0"
                                          ]}
                                          onClick={(value) => {
                                            if (value) {
                                              const { morning, afternoon, night } = parseMealTiming(value);
                                              handleEditMedicineChange("morning", morning);
                                              handleEditMedicineChange("afternoon", afternoon);
                                              handleEditMedicineChange("night", night);
                                              // Clear frequency inputs when selecting meal timing
                                              handleEditMedicineChange("frequencytime", "");
                                              handleEditMedicineChange("frequencyvalue", "");
                                            }
                                          }}
                                          value={editMedicine && getMealTimingLabel(editMedicine.morning, editMedicine.afternoon, editMedicine.night)}
                                        />
                                      </Box>
      
                                      <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>
      
                                      {/* Frequency inputs */}
                                      <Box display='flex'>
                                      <Box width='120px'>
                                        <DropdownInput
                                          variant="bothSide"
                                          dropDownPlace="Frequency"
                                          arrowCSS={{pr:0}}
                                          options={["Hours", "Daily", "Weekly"]}
                                          onClick={(value) => {
                                            // Uncheck time checkboxes when selecting frequency
                                            if (value) {
                                              handleEditMedicineChange("morning", 0);
                                              handleEditMedicineChange("afternoon", 0);
                                              handleEditMedicineChange("night", 0);
                                            }
                                            handleEditMedicineChange("frequencytime", value || 0);
                                          }}
                                          // defaultOption={"Hours"}
                                          value={editMedicine.frequencytime}
                                        />
                                      </Box>
      
                                      <Box width='70px'>
                                        <DropdownInputForVitals
                                          variant="bothSide"
                                          dropDownPlace="Value"
                                          arrowCSS={{pr:0}}
                                          readOnly=""
                                          options={["1", "2", "3", "4", "8"]}
                                          onClick={(value) => {
                                            // Uncheck time checkboxes when selecting value
                                            if (value) {
                                              handleEditMedicineChange("morning", 0);
                                              handleEditMedicineChange("afternoon", 0);
                                              handleEditMedicineChange("night", 0);
                                              handleEditMedicineChange("frequencyvalue", value);
                                            }
                                          }}
                                          onChange={(e) => {
                                            // Handle manual text input for value
                                            const value = e.target.value;
                                            if (value) {
                                              handleEditMedicineChange("morning", 0);
                                              handleEditMedicineChange("afternoon", 0);
                                              handleEditMedicineChange("night", 0);
                                            }
                                            handleEditMedicineChange("frequencyvalue", value);
                                          }}
                                          value={editMedicine.frequencyvalue}
                                          inputValueProp={editMedicine.frequencyvalue || ""}
                                          maxLength={2}
                                        />
                                        {/* <DropdownInput
                                          variant="bothSide"
                                          dropDownPlace="Value"
                                          options={["1", "2", "3", "4", "8"]}
                                          onClick={(value) => {
                                            // Uncheck time checkboxes when selecting value
                                            if (value) {
                                              handleEditMedicineChange("morning", 0);
                                              handleEditMedicineChange("afternoon", 0);
                                              handleEditMedicineChange("night", 0);
                                            }
                                            handleEditMedicineChange("frequencyvalue", value || "");
                                          }}
                                          onChange={(e) => {
                                            // Handle manual text input for value
                                            const value = e.target.value;
                                            if (value) {
                                              handleEditMedicineChange("morning", 0);
                                              handleEditMedicineChange("afternoon", 0);
                                              handleEditMedicineChange("night", 0);
                                            }
                                            handleEditMedicineChange("frequencyvalue", value || "");
                                          }}
                                          value={editMedicine.frequencyvalue}
                                        /> */}
                                      </Box>
                                      </Box>
                                      {/* Food timing radio buttons */}
                                      <Spacer/>
                                      {/* <RadioGroup
                                        value={editMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
                                        display='flex'
                                        justifyItems='start'
                                        flexWrap='wrap'
                                        gap='0.5rem'
                                        onChange={(value) => {
                                          if (value === "beforefood") {
                                            handleEditMedicineChange("beforefood", 1);
                                            handleEditMedicineChange("afterfood", 0);
                                          } else if (value === "afterfood") {
                                            handleEditMedicineChange("beforefood", 0);
                                            handleEditMedicineChange("afterfood", 1);
                                          }
                                        }}
                                      >
                                        <Radio value="beforefood" colorScheme="green">Before Food</Radio>
                                        <Radio value="afterfood" colorScheme="green">After Food</Radio>
                                      </RadioGroup> */}
                                      {(editMedicine?.medicinetype === "Cream" || editMedicine?.medicinetype === "Ointment") || editMedicine?.medicinetype === "Gel" ? (
                                        <Box>
                                          {/* <Text fontSize="sm" mb={1}>Application Timing</Text> */}
                                          <DropdownInput
                                            variant="downSide"
                                            dropDownPlace="Application Timing"
                                            options={[
                                              "After Bath",
                                              "Before Bath",
                                              "After Sun",
                                              "Before Sun",
                                              "Time-based",
                                            ]}
                                            onClick={(value) => {
                                              handleEditMedicineChange("timing", value);
                                              handleEditMedicineChange("beforefood", 0);
                                              handleEditMedicineChange("afterfood", 0);
                                            }}
                                            value={editMedicine.timing || ""}
                                          />
                                        </Box>
                                      ) : (
                                        <RadioGroup
                                          value={editMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
                                          display='flex'
                                          justifyItems='start'
                                          flexWrap='wrap'
                                          gap='0.5rem'
                                          onChange={(value) => {
                                            if (value === "beforefood") {
                                              handleEditMedicineChange("beforefood", 1);
                                              handleEditMedicineChange("afterfood", 0);
                                              handleEditMedicineChange("timing", "Before Food");
                                            } else if (value === "afterfood") {
                                              handleEditMedicineChange("beforefood", 0);
                                              handleEditMedicineChange("afterfood", 1);
                                              handleEditMedicineChange("timing", "After Food");
                                            }
                                          }}
                                        >
                                          <Radio value="beforefood" colorScheme="green">Before Food</Radio>
                                          <Radio value="afterfood" colorScheme="green">After Food</Radio>
                                        </RadioGroup>
                                      )}
                                    </Stack>
                                  </CheckboxGroup>
      
                                  <Divider my="10px" />
      
                    {/* Row 7: Instructions Text area */}
                                  <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
        <Box
          as="form"
          width='100%'
          bg="white"
          pt={"2px"}
        >
          <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
            <Textarea
              borderRadius='0'
              // {...register("textField")}
              // defaultValue={editMedicine.custommessage}
              // inputValue={editMedicine.custommessage}
              value={editMedicine.custommessage}
              onChange={(e) => {
                handleEditMedicineChange("custommessage", e.target.value);
                // Also update the form field
                setMedicineValue("textField", e.target.value, {
                  shouldDirty: true,
                  shouldTouch: true,
                  shouldValidate: true,
                });
              }}
              height="100%"
              padding="2"
              resize="none"
              style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
            />
            
            {/* {!editMedicine.custommessage && ( */}
              {!medicineTextFieldValue && (
              <Text
                position="absolute"
                bottom="2"
                left="50%"
                transform="translateX(-50%)"
                fontSize="sm"
                color="gray.500"
                w={{ base: "100%", md: "unset" }}
                textAlign={{ base: "center", md: "unset" }}
              >
                {medicinePlaceholder}
              </Text>
            )}
          </Box>
          
        </Box>
      
        {/* <GPUChatAudioManager
            transcriber={activeTranscriber}
            setPlaceholder={setPlaceholder}
            setTyping={setTyping}
            // onTranscribedText={handleTranscribedText}
          /> */}
          {/* <Box w='15%'>
          <DropdownWithMultiLingual 
                    menuList={{pos:'relative', right:'75px'}}
                    placeholder="English"
                    onClick={handleChangeLanguage}
                    options={languageOptions.map(value => ({ value }))}
                    title="Input Language"
                  />
                  </Box>
          <GPUChatAudioManagerSpeechMode
            transcriber={activeTranscriber}
            mode={mode}
            setPlaceholder={setPlaceholder}
            setTyping={setTyping}
              onRecordingStateChange={handleRecordingStateChange} 
          />
          {isRecording && (
                    <AudioDisplayForClutter
                      mx="auto"
                      borderRadius="lg"
                      stream={stream}
                    />
                  )}
                  <Box w='15%'>
                  <DropdownWithMultiLingual 
                    menuList={{pos:'relative', right:'75px'}}
                    placeholder="English"
                    onClick={handleChangeOutputLanguage}
                    options={languageOptions.map(value => ({ value }))}
                    title="Output Language"
                  />
                  </Box>
      
          <Box
            as="button"
            type="button"
            border="1px solid #E6E7E9"
            borderRadius="full"
            w="36px"
            h="auto"
            p="10px"
            mr='10px'
            display="flex"
            justifyContent="center"
            alignItems="center"
            cursor={textFieldValue ? "pointer" : "not-allowed"}
            opacity={textFieldValue ? 1 : 0.5}
            pointerEvents={textFieldValue ? "auto" : "none"}
            onClick={() => textFieldValue && correctOrders("edit")}
          >
            <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
          </Box> */}
      </Box>

                    {/* Row 8: Input/Output Language, AudioRecorder */}
      {/* Audio & Language Controls Row - Highlighted Section */}
                          <Box
                            bg="#f8f9fa"
                            border="1px solid #e9ecef"
                            borderRadius="8px"
                            p="0.5rem"
                            mt="1rem"
                            // mb="1rem"
                          >
                            <Flex
                              alignItems="center"
                              justifyContent="space-around"
                              // justifyContent="space-between"
                              gap="1rem"
                              flexWrap={{ base: "wrap", md: "nowrap" }}
                            >
                              {/* Input Language Dropdown */}
                              <Box flex="1" minW="120px">
                                <DropdownWithMultiLingual 
                                  menuList={{pos:'relative', right:'75px'}}
                                  placeholder="English"
                                  onClick={handleMedicineChangeLanguage}
                                  options={languageOptions.map(value => ({ value }))}
                                  title="Input Language"
                                />
                              </Box>
                              
                              {/* Audio Controls and Wave Display */}
                              <Box 
                          flex="1"
                          display="flex" 
                          alignItems="center" 
                          justifyContent="center"
                          gap="0.75rem"
                          minH="50px"
                          px="1rem"
                        >
                          <GPUChatAudioManagerSpeechMode
                            transcriber={medicineTranscriber}
                            mode={medicineMode}
                            setPlaceholder={setMedicinePlaceholder}
                            setTyping={setMedicineTyping}
                            onTranscribedText={(text) => {
                              handleEditMedicineChange("custommessage", text);
                              setMedicineValue("textField", text); 
                            }}
                            onRecordingStateChange={handleRecordingStateChange} 
                          />
                    
                          {isRecording && (
                            <Box flex="1" minW="180px" maxW="250px">
                              <AudioDisplayForClutter
                                borderRadius="lg"
                                stream={stream}
                                width="100%"
                              />
                            </Box>
                          )}
                        </Box>
                    
                              {/* Output Language Dropdown */}
                              <Box flex="1" minW="120px">
                                <DropdownWithMultiLingual 
                                  menuList={{pos:'relative', right:'75px'}}
                                  placeholder="English"
                                  onClick={handleChangeMedicineOutputLanguage}
                                  options={languageOptions.map(value => ({ value }))}
                                  title="Output Language"
                                />
                              </Box>
                    
                              {/* AI Correction Button */}
                              <Box
                                as="button"
                                type="button"
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="40px"
                                h="40px"
                                p="8px"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                                // opacity={medicineTextFieldValue ? 1 : 0.5}
                                // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                                // onClick={() => medicineTextFieldValue && correctMedOrders("edit")}
                                cursor={isMedicineButtonEnabled ? "pointer" : "not-allowed"} // Changed logic
  opacity={isMedicineButtonEnabled ? 1 : 0.5} // Changed logic
  pointerEvents={isMedicineButtonEnabled ? "auto" : "none"} // Changed logic
  onClick={() => isMedicineButtonEnabled && correctMedOrders("edit")}
                                flexShrink="0"
                                bg="white"
                                // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                                _hover={isMedicineButtonEnabled ? { bg: "#f0f0f0" } : {}}
                              >
                                <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                              </Box>
                            </Flex>
                          </Box>
                          <Divider my="10px" />
                                </Box>
                              </Stack>
                            </Box>
                          )}
                        </Box>
                      ))}   
                        </>
                      }
                      modalFooterBtn={
    <HStack width="100%" justifyContent="flex-end" gap="1rem">
      <PrimaryButton
        buttonText="Cancel"
        variant="grayBtn"
        btnStyle={{
          w: "auto",
          h: "2.5rem",
          px: "2rem",
        }}
        onClick={() => editSelectedPrescriptionMedication.current?.closeModal?.()}
      />
      <PrimaryButton
        // buttonText="Save Changes"
        buttonText="Add to prescription"
        btnStyle={{
          w: "auto",
          h: "2.5rem",
          px: "2rem",
        }}
        // onClick={() => {
        //   handleSaveEditMedicine();
        //   saveMedicineToOrders();
        //   // saveSelectedMedicinesToOrders();
        // }}
        onClick={handleSaveEditMedicine}
      // isDisabled={!editMedicine?.medicinename}
      />
      {/* <PrimaryButton
        buttonText="Update & Add to prescription"
        btnStyle={{
          w: "auto",
          h: "2.5rem",
          px: "2rem",
        }}
        // onClick={() => {
        //   handleSaveEditMedicine();
        //   saveMedicineToOrders();
        //   // saveSelectedMedicinesToOrders();
        // }}
        onClick={handleSaveEditMedicine}
      // isDisabled={!editMedicine?.medicinename}
      /> */}
    </HStack>
  }
                    />

<DynamicModal
  ref={deleteMedicineModal}
  modalHeader={"Delete Medicine?"}
  modalBody={
    <>
      <Text fontSize="14px" fontWeight="600">
        Are you sure you want to delete{" "}
        <Text as="span" fontWeight="700">
          "{medicationNameToDelete ? medicationNameToDelete : "-"}"
        </Text>
        ?
        {/* {medicationNameToDelete ? medicationNameToDelete : "-"}? */}
      </Text>
      {/* <Text fontSize="12px" color="gray.600" mt={2}>
        This action cannot be undone.
      </Text> */}
    </>
  }
  modalFooterBtn={
    <PrimaryButton
                    variant="deleteBtn"
                    buttonText="Delete"
                    onClick={deleteMedication}
                  />
    // <HStack width="100%" justifyContent="flex-end" gap="1rem">
    //   <PrimaryButton
    //     buttonText="Cancel"
    //     variant="grayBtn"
    //     btnStyle={{
    //       w: "auto",
    //       h: "2.5rem",
    //       px: "2rem",
    //     }}
    //     onClick={() => {
    //       deleteMedicineModal.current?.closeModal();
    //       setIsDeleteModalOpen(false);
    //     }}
    //   />
    //   <PrimaryButton
    //     variant="deleteBtn"
    //     buttonText="Delete"
    //     btnStyle={{
    //       w: "auto",
    //       h: "2.5rem",
    //       px: "2rem",
    //       bg: "red.500",
    //       color: "white",
    //       _hover: { bg: "red.600" }
    //     }}
    //     onClick={deleteMedication}
    //   />
    // </HStack>
  }
/>

      <DynamicModal
        ref={audioCompatibilityDemo}
        modalHeader="Aira: Config"
        modalWidth={"100vw"}
        modalHeight={"100vh"}
        hasFooter={false}
        modalBody={
          <>
            {/* <AIRA CHAT NOTES /> */}
            <AudioCompatibilityCheck modalRef={audioCompatibilityDemo} openRecordFunction={handleAIRANotesClick}/>
          </>
        }
      />

      <DynamicModal
        ref={airaTranscribeNotes}
        modalHeader="Aira: Notes"
        hasHeader={false}
        modalWidth={"100vw"}
        modalHeight={"100vh"}
        hasFooter={false}
        modalBody={
          <>
            {/* <TranscribeNotes /> */}
            {useGPUChatbot &&
            localStorage.getItem("capableGPU") === "true" ? (
              (() => {
              return (
              <GPUChunksTranscribeNotes
                patientId={patientId}
                doctorId={doctorId}
                appointmentId={appointmentId}
                showSuccessToast={showSuccessToast}
                showErrorToast={showErrorToast}
                closeNotesModal={() =>
                  airaTranscribeNotes.current.closeModal()
                }
                fetchPatientHealthData={fetchPatientHealthData}
                isDischargeSummary={false}
              />
              );
                })()
            ) : (
              (() => {
          return (
              <CPUTranscribeNotes
                patientId={patientId}
                doctorId={doctorId}
                appointmentId={appointmentId}
                showSuccessToast={showSuccessToast}
                showErrorToast={showErrorToast}
                closeNotesModal={() =>
                  airaTranscribeNotes.current.closeModal()
                }
                fetchPatientHealthData={fetchPatientHealthData}
                isDischargeSummary={false}
              />
              );
        })()
            )}
          </>
        }
      />
      {ShowAssignModal &&<AssignVisit appointmentId={appointmentId}/>}
    </>
  );
};

export default QuickVisitIndex;
